import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  fr: {

    newsPage: {
  hero: {
    tag: "Actualités & Insights",
    title: "Portail <span>Partenaires</span> S2i",
    subtitle: "Découvrez les dernières innovations technologiques de nos partenaires mondiaux."
  },
  readMore: "Plus de détails",
  filters: {
    all: "Tous",
    dell: "Dell Technologies",
    kyocera: "Kyocera",
    pny: "PNY",
    vembu: "Vembu",
    infortrend: "Infortrend"
  },
  items: [
    {
      id: 1,
      sortDate: "2026-05",
      brand: "dell",
      category: "Infrastructure",
      date: " Mai 2026",
      title: "Dell PowerEdge 18G : L'ère du Quantum-Ready",
      desc: "Présentation de la 18ème génération de serveurs Dell PowerEdge. Une architecture révolutionnaire conçue pour la cybersécurité post-quantique et une réduction de 40% de la consommation énergétique.",
      image: "/images/dell_poweredge.png",
      url: "https://www.dell.com/fr-fr/shop/scc/sc/servers"
    },
{
      id: 2,
      sortDate: "2026-04",
      brand: "dell",
      category: "Cloud IA",
      date: "Avril 2026",
      title: "IA Souveraine en Tunisie avec Dell APEX",
      desc: "Déployez vos propres modèles d'IA en toute sécurité. S2i et Dell lancent les solutions 'Sovereign AI' pour garantir que vos données stratégiques ne quittent jamais votre infrastructure.",
      image: "/images/apex.png",
      url: "https://www.dell.com/fr-fr/dt/apex/index.htm"
    },

    {
  id: 3,
  sortDate: "2026-03",
  brand: "vembu",
  category: "Sécurité & Backup",
  date: "Mars 2026",
  title: "Vembu BDRSuite v9.0 : La Restauration Autonome",
  desc: "S2i déploie la nouvelle version v9.0 de BDRSuite. Grâce à l'IA intégrée, le système détecte les anomalies de données en temps réel et automatise la restauration sans aucune intervention humaine.",
  image: "/images/vembu_dis.jpg",
  url: "https://www.bdrsuite.com/bdrsuite-v7-0-general-availability/" // Lien vers leur blog/actualités
},

    {
  id: 4,
  brand: "infortrend",
  sortDate: "2026-02",
  category: "Stockage Unifié",
  date: "Février 2026",
  title: "Infortrend EonStor GS Gen5 : Le Stockage Multi-Cloud",
  desc: "Déploiement des nouvelles baies de 5ème génération. Une architecture unifiée supportant jusqu'à 100 Po, intégrant le NVMe-over-Fabrics et une synchronisation cloud ultra-rapide pour vos charges de travail IA.",
  image: "/images/infor.jpg",
  url: "https://www.infortrend.com/global/products/gs"
},


      {
  id: 5,
  sortDate: "2026-05",
  brand: "pny",
  category: "Graphisme Pro",
  date: "Mai 2026",
  title: "Programme de mise à jour PNY : Passez aux GPU NVIDIA RTX PRO Blackwell",
  desc: " Boostez vos stations de travail avec l'architecture Blackwell, offrant des performances d'IA et de rendu 3 fois supérieures aux générations précédentes.",
  image: "/images/pny1.jpg",
  url: "https://news.pny.eu/2026/04/pny-launches-its-upgrade-program-for-nvidia-rtx-pro-blackwell-gpus/"
},
{
  id: 6,
  sortDate: "2025-01",
  brand: "pny",
  category: "Gaming & Création",
  date: "Janvier 2025",
  title: "PNY dévoile la série GeForce RTX 50 ",
  desc: "La révolution est là. Les nouvelles GeForce RTX 50 de PNY redéfinissent le possible avec le Ray Tracing en temps réel de nouvelle génération et une gestion de l'IA sans précédent pour les créateurs de contenu.",
  image: "/images/pny2.jpg",
  url: "https://news.pny.eu/2025/01/pny-launches-the-game-changing-geforce-rtx-50-series/"
},


{
  id: 7,
  sortDate: "2026-01",
  brand: "kyocera",
  category: "Innovation & IoT",
  date: "Janvier 2026",
  title: "Kyocera au CES 2026 : L'IA et l'IoT révolutionnent la Mobilité",
  desc: "Présent au CES 2026 à Las Vegas, Kyocera dévoile ses dernières innovations en IA, IoT et capteurs intelligents. Découvrez comment ces technologies transforment le secteur de l'automobile et des télécommunications de demain.",
  image: "/images/kyo.jpg",
  // Lien vers la Newsroom globale de Kyocera (stable)
  url: "https://global.kyocera.com/newsroom/news/2026/001143.html"
},

{
  id: 8,
  sortDate: "2026-06",
  brand: "pny",
  category: "Graphisme Pro",
  date: "Juin 2026",
  title: "PNY lance les modèles Slim dual-slot des GeForce RTX 50",
  desc: "Trois nouvelles cartes GeForce RTX 50 Slim (RTX 5080, 5070 Ti et 5070) au format dual-slot ultra-compact, conçues pour délivrer toute la puissance de l'architecture Blackwell dans les configurations les plus contraintes.",
  image: "/images/pny8.jpg",
  url: "https://www.pny.com/geforce-rtx-5080-slim-models"
},
{
  id: 9,
  sortDate: "2026-07",
  brand: "dell",
  category: "Stockage & Données",
  date: "Juillet 2026",
  title: "Dell PowerStore Elite : disponibilité mondiale",
  desc: "Annoncée au Dell Technologies World, la nouvelle génération PowerStore (1500, 5500 et 9500) est désormais disponible : jusqu'à 5,8 Po de capacité effective en 3U, réduction de données garantie 6:1 et mises à niveau sans interruption de service.",
  image: "/images/dell9.png",
  url: "https://www.dell.com/en-us/shop/powerstore/sf/power-store"
},
{
  id: 10,
  sortDate: "2026-08",
  brand: "vembu",
  category: "Sécurité & Backup",
  date: "Août 2026",
  title: "BDRSuite v9.2 : support vSphere 9.1 et stockage immuable renforcé",
  desc: "La version 9.2 on-premises ajoute la prise en charge de VMware vSphere 9.1, les copies secondaires de sauvegarde de VM, un stockage proxy immuable renforcé et le contrôle d'intégrité des proxies Linux.",
  image: "/images/vembu_dis.jpg",
  url: "https://www.bdrsuite.com"
},
{
  id: 11,
  sortDate: "2026-09",
  brand: "kyocera",
  category: "Innovation & IoT",
  date: "Septembre 2026",
  title: "Kyocera à Electronica India 2026",
  desc: "Du 16 au 18 septembre au Bangalore International Exhibition Centre, Kyocera Asia Pacific présente ses composants électroniques, technologies semi-conducteurs et solutions d'affichage automobile de nouvelle génération.",
  image: "/images/kyocera11.png", 
  url: "https://global.kyocera.com/newsroom/news/2026/001198.html"
}

  ]
},


    header: {
      news: "Actualités",	
      group: "Groupe S2i", contact: "Contacter", admin: "Espace Admin", home: "Accueil", about: "À propos", solutions: "Solutions et produits", services: "Services",
      aboutMenu: { history: "Notre histoire", values: "Valeurs", faq: "Nos questions fréquentes" },
      categories: { infra: "Infrastructure Data Center", cloud: "Cloud & Sécurité", reseau: "Réseau", affichage: "Affichage Dynamique", print: "Management Printing", analyse: "Analyse & Conseil", impl: "Implémentation & Support" }
    },
    footer: {
      desc: "Société d'Ingénierie Informatique et de Communication spécialisée dans l'intégration de solutions réseaux.",
      servicesTitle: "Nos Services", contactTitle: "Contact", rights: "Tous droits réservés.",
      s1: "Diagnostic et Analyse de l'existant", s2: "Conseil", s3: "Assistance et support", s4: "Déploiement"
    },
    home: {
      seo: {
        title: "S2i Tunisie | Intégrateur Infrastructure IT, Cloud & Cybersécurité",
        description: "S2i accompagne votre transformation digitale en Tunisie. Expert en serveurs Dell, réseaux Cisco, sécurité Fortinet et solutions Cloud sur mesure."
      },
      hero: { tag: "Expertise IT & Intelligence Artificielle", title: "Innover. Intégrer. <br/><span>Transformer.</span>", subtitle: "S2i accompagne votre infrastructure vers le futur.", cta: "Découvrir nos solutions" },
      services: {
        s1: { title: "Conseil & Stratégie", desc: "Nous analysons vos besoins et proposons des stratégies IT adaptées à vos objectifs." },
        s2: { title: "Gestion de Projets", desc: "De la planification à la livraison, nous pilotons vos projets avec rigueur et expertise." },
        s3: { title: "Support Technique", desc: "Un support réactif et disponible pour assurer la continuité de vos opérations." },
        s4: { title: "Optimisation IT", desc: "Nous optimisons vos infrastructures pour réduire les coûts et améliorer les performances." }
      },
      partners: "Nos Alliances <span>Stratégiques</span>", partners_sub: "Nous collaborons avec les meilleurs acteurs technologiques",
      international_title: "Quelques Références à l'<span>International</span>",
      international_sub: "Une expertise déployée à travers le monde",
      realized_in: "Projets à l'international :",
      countries: {
        ly: "Libye",
        cg: "Congo Brazzaville",
        dz: "Algérie",
        cz: "Tchéquie",
        ae: "Émirats Arabes Unis", 
        jo: "Jordanie"
      },
      clients: "Ils nous font <span>Confiance</span>", clients_sub: "Des leaders d'industrie qui ont choisi l'excellence S2i",
      certifications: "Nos <span>Certifications</span>", certifications_sub: "Une expertise reconnue et certifiée par les leaders technologiques",
      why: { title: "Pourquoi choisir S2i ?", stats: [{ val: 37, lab: "Années d'Expérience", desc: "Près d'une décennie au service de nos clients." }, { val: 100, lab: "Projets réalisés", desc: "Solutions livrées avec succès." }, { val: 400, lab: "Clients Satisfaits", desc: "Partenaires qui nous font confiance." }, { val: 50, lab: "Support Technique", desc: "Assistance continue pour nos clients." }] },
      contact: { title: "Un projet ?", name_ph: "Votre nom complet", email_ph: "Votre email professionnel", phone_ph: "Votre téléphone", msg_ph: "Décrivez votre projet...", send_btn: "Envoyer", sending: "Envoi...", success: "Message envoyé avec succès !", error: "Erreur lors de l'envoi." }
    },
    contactPage: {
      hero: {
        title: "Contactez-Nous",
        subtitle: "Prêt à discuter de votre projet ? Notre équipe d'experts est là pour vous accompagner."
      },
      form: {
        title: "Envoyez-nous un Message",
        labels: {
          name: "Nom complet *",
          email: "Email *",
          phone: "Téléphone",
          company: "Entreprise",
          service: "Service d'intérêt",
          message: "Message *"
        },
        placeholders: {
          name: "Ex: Ahmed Ben Ali",
          email: "votre@email.com",
          phone: "Ex: +216 20 000 000",
          company: "Nom de l'entreprise",
          message: "Décrivez votre projet..."
        },
        serviceOptions: {
          select: "Sélectionnez un service",
          cyber: "Cyber Sécurité",
          infra: "Infrastructure Data Center",
          network: "Réseau & WIFI"
        },
        btn: {
          send: "Envoyer le Message",
          sending: "Envoi en cours..."
        }
      },
      messages: {
        success: "Félicitations ! Votre message a été envoyé avec succès à l'équipe S2i.",
        error: "Une erreur est survenue. Veuillez vérifier la connexion avec le serveur."
      },
      sidebar: {
        title: "Pourquoi S2i ?",
        item1: "Équipe d'experts certifiés",
        item2: "Support technique réactif",
        item3: "Plus de 30 ans d'expérience"
      },
      info: {
        address: "Adresse",
        city: "Tunis, Tunisie",
        area: "Zone industrielle",
        phone: "Téléphone",
        phoneHours: "Lun-Ven 8h-17h",
        emailResponse: "Réponse sous 24h",
        hours: "Horaires",
        weekDays: "Lun-Ven: 8h-17h",
        satHours: "Sam: 8h-12h"
      }
    },
    servers: {
      seo: { title: "Serveur Dell PowerEdge Tunisie | Rack, Tour & IA | S2i", description: "Partenaire Dell Platinum en Tunisie. Gamme complète de serveurs Dell PowerEdge pour Data Center et virtualisation. Devis et installation expert." },
      hero: {
        badge: "Solutions Serveurs Dell Technologies",
        title: "Serveurs <span>Dell EMC PowerEdge</span>",
        subtitle: "Découvrez notre gamme complète de serveurs Dell PowerEdge, des solutions tour aux infrastructures hyperconvergées",
        btnExplore: "Explorer les serveurs",
        btnQuote: "Demander un devis"
      },
      categories: {
        title: "Catégories de Serveurs",
        subtitle: "Trouvez la solution serveur adaptée à vos besoins",
        rack: "Data Center Rack Servers",
        tower: "Data Center Tower Servers",
        ai: "AI Servers",
        edge: "Edge Servers"
      },
      sidebar: {
        title: "Filtres & Recherche",
        searchLabel: "Recherche",
        searchPlaceholder: "Nom, processeur, cas d'usage...",
        catLabel: "Catégorie",
        allServers: "Tous les serveurs",
        socketLabel: "Type de Socket",
        allSockets: "Tous les sockets",
        found: "serveur(s) trouvé(s)",
        pageOf: "sur",
        viewLabel: "Vue",
        grid: "Grille",
        list: "Liste",
        notFound: "Aucun serveur trouvé",
        notFoundSub: "Essayez de modifier vos critères de recherche"
      },
      card: {
        badgeNew: "Nouveau",
        usage: "Cas d'usage",
        specs: "Spécifications",
        cpu: "Processeur",
        ram: "Mémoire",
        gpu: "GPU",
        points: "Points forts"
      },
      others: {
        title: "Autres Solutions de <span>Data Center</span>",
        subtitle: "Complétez votre infrastructure avec nos solutions Dell Technologies intégrées",
        hci: { 
            title: "Infrastructure Hyperconvergée", 
            desc: "Simplifiez votre infrastructure avec nos solutions HCI Dell VxRail qui intègrent calcul, stockage et réseau en une seule plateforme unifiée.",
            f1: "Réduction des coûts opérationnels jusqu'à 40%", f2: "Déploiement simplifié en quelques heures", f3: "Scalabilité par nœuds selon vos besoins", f4: "Haute disponibilité avec VMware vSAN"
        },
        st: { 
            title: "Stockage & Sauvegarde", 
            desc: "Solutions de stockage Dell PowerStore et PowerProtect pour une gestion optimale de vos données critiques avec performances exceptionnelles.",
            f1: "Performances All-Flash jusqu'à 7M IOPS", f2: "Compression et déduplication avancées", f3: "Protection ransomware intégrée", f4: "Sauvegarde cloud hybride automatisée"
        },
        nt: { 
            title: "Infrastructure Réseau", 
            desc: "Solutions réseau Dell PowerSwitch et Cisco pour une connectivité haute performance, sécurisée et évolutive.",
            f1: "Commutation 10/25/40/100 GbE", f2: "SDN et automatisation réseau", f3: "Sécurité Zero Trust intégrée", f4: "Gestion centralisée intelligente"
        }
      },
      cta: {
        title: "Concevons ensemble votre Data Center de demain",
        subtitle: "Nos architectes solutions vous accompagnent dans la conception et l'implémentation de votre infrastructure avec les technologies Dell les plus avancées.",
        btnExpert: "Consulter nos experts",
        btnCatalog: "Télécharger notre catalogue"
      }
    },
    storage: {
      seo: { title: "Solution Stockage Dell Tunisie | PowerStore & All-Flash | S2i", description: "Optimisez vos données avec Dell PowerStore. Solutions de stockage All-Flash haute performance et protection ransomware pour entreprises en Tunisie." },
      hero: {
        badge: "Solutions de Stockage Dell",
        title: "Solutions de Stockage<br />Intelligentes",
        subtitle: "Découvrez notre gamme complète de solutions de stockage Dell, de l'all-flash haute performance aux systèmes scale-out pour l'IA.",
        btnExplore: "Explorer les solutions",
        btnGuide: "Guide de sélection",
        certified: "Solutions Certifiées",
        idc: "#1 mondial en stockage enterprise externe selon IDC"
      },
      advantages: {
        intel: { name: "Intelligent", desc: "IA intégrée pour optimisation automatique" },
        efficace: { name: "Efficace", desc: "Garantie de réduction de données 5:1" },
        cyber: { name: "Cyber-résilient", desc: "99.5% de confiance de détection corruption" },
        cloud: { name: "Multicloud", desc: "87% d'économies vs stockage cloud natif" }
      },
      sidebar: {
        search: "RECHERCHE",
        searchPl: "Rechercher un produit...",
        category: "CATÉGORIE",
        allCats: "Toutes les catégories",
        type: "TYPE DE STOCKAGE",
        allTypes: "Tous les types",
        found: "solution(s) trouvée(s)",
        pageOf: "sur",
        viewLabel: "Vue",
        grid: "Grille",
        list: "Liste"
      },
      categories: {
        af: "All-Flash Storage", afD: "Solutions de stockage haute performance tout flash",
        un: "Unified Storage", unD: "Stockage unifié pour environnements mixtes",
        nas: "Scale-out NAS", nasD: "Stockage NAS évolutif pour données non structurées",
        sds: "Software-Defined Storage", sdsD: "Infrastructure de stockage définie par logiciel",
        bk: "Backup & Protection", bkD: "Solutions de sauvegarde et protection des données"
      },
      card: {
        badgeNew: "Nouveau",
        capacity: "CAPACITÉ",
        processors: "PROCESSEURS",
        specs: "SPÉCIFICATIONS",
        memory: "Mémoire",
        network: "Réseau",
        disks: "Disques"
      },
      cta: {
        title: "Besoin d'aide pour choisir ?",
        subtitle: "Nos architectes solutions vous accompagnent dans la sélection et l'implémentation de vos solutions de stockage Dell.",
        btnExpert: "Consulter nos experts",
        btnGuide: "Guide de sélection"
      }
    },     
    switching: {
      seo: { 
    title: "Switch Dell PowerSwitch Tunisie | Réseau Data Center | S2i", 
    description: "Optimisez votre réseau avec Dell PowerSwitch en Tunisie. Architecture Open Networking, Spine-Leaf et ultra-faible latence pour Data Center." 
  },
      hero: {
        badge: "Solutions de Switching Dell",
        title: "PowerSwitch<br />Open Networking",
        subtitle: "Découvrez notre gamme complète de switches PowerSwitch pour data centers, du top-of-rack aux architectures spine-leaf et AI fabric.",
        btnExplore: "Explorer les switches",
        btnGuide: "Guide d'architecture",
        leader: "Open Networking Leader",
        leaderDesc: "Premier fournisseur de solutions open networking disagrégées"
      },
      advantages: {
        open: { name: "Open Networking", desc: "Première approche open networking disagrégée" },
        ai: { name: "AI-Ready", desc: "Optimisé pour les charges de travail IA/ML" },
        latency: { name: "Ultra faible latence", desc: "Latence sub-microseconde pour applications critiques" },
        scalable: { name: "Évolutif", desc: "Architecture spine-leaf hautement évolutive" }
      },
      categories: {
        campus: "S Series 1GbE", campusD: "Switches 1GbE pour gestion data center",
        tor: "S Series 10/25+GbE", torD: "Switches ToR haute performance",
        spine: "Z Series Core/Aggregation", spineD: "Switches core/agrégation pour fabrics leaf/spine"
      },
      sidebar: {
        search: "Recherche",
        searchPlaceholder: "Rechercher un switch...",
        category: "Catégorie",
        allCats: "Toutes les catégories",
        view: "Vue",
        grid: "Grille",
        list: "Liste",
        found: "switch(es) trouvé(s)",
        pageOf: "sur"
      },
      card: {
        new: "Nouveau",
        usage: "Usage clé",
        options: "Options"
      },
      cta: {
        title: "Besoin d'aide pour votre architecture réseau ?",
        subtitle: "Nos experts réseaux vous accompagnent dans la conception et l'implémentation de vos infrastructures PowerSwitch.",
        btnExpert: "Consulter nos experts",
        btnGuide: "Guide d'architecture"
      }
    },
    hci: {
      seo: { title: "Infrastructure Hyperconvergée Dell VxRail Tunisie | S2i", description: "Simplifiez votre IT avec Dell VxRail. Solutions HCI pour moderniser votre Data Center avec VMware en Tunisie. Performance et scalabilité." },
      hero: { badge: "Solutions HCI Dell Technologies", title: "Infrastructure <span style='color: #d90000'>Hyperconvergée</span> Dell", subtitle: "Modernisez l'IT, simplifiez les opérations et réduisez les risques avec nos systèmes hyperconvergés pour charges applicatives modernes et traditionnelles", btnExplore: "Explorer les solutions", btnQuote: "Demander un devis" },
      categories: {
        title: "Solutions HCI Dell Technologies", subtitle: "Choisissez la solution hyperconvergée adaptée à vos besoins",
        vxrail: { name: "VxRail", desc: "Systèmes intégrés conçus avec VMware, pour VMware" },
        azure: { name: "Dell AX pour Azure Local", desc: "Solution Microsoft Premier avec automatisation améliorée" },
        vsan: { name: "Nœuds vSAN Ready", desc: "Infrastructure HCI avec serveurs PowerEdge et VMware vSAN" },
        xc: { name: "Gamme XC", desc: "Solutions intégrant logiciel Nutanix et serveurs Dell PowerEdge" }
      },
      sidebar: { title: "Filtres & Recherche", search: "Recherche", searchPl: "Nom, cas d'usage, fonctionnalité...", category: "Catégorie", all: "Toutes les solutions", results: "solution(s) trouvée(s)", pageOf: "sur", view: "Vue", grid: "Grille", list: "Liste" },
      card: { new: "Nouveau", usage: "Cas d'usage", specs: "Spécifications", cpu: "Processeur", mem: "Mémoire", st: "Stockage", points: "Points forts" },
      noResults: { title: "Aucune solution trouvée", sub: "Essayez de modifier vos filtres ou votre recherche", btn: "Réinitialiser les filtres" },
      cta: { title: "Modernisez l'IT, simplifiez les opérations et réduisez les risques", subtitle: "Découvrez la vaste gamme de solutions HCI de Dell Technologies qui permet de choisir en fonction de l'infrastructure actuelle, des modèles opérationnels et des résultats IT souhaités.", btnContact: "Contactez nos experts", btnDoc: "Documentation" },
      products: {
        vxrail_int: { name: "VxRail - Systèmes intégrés", badge: "Populaire", workloads: ["Virtualisation VMware", "Opérations rationalisées", "Évolution prévisible"], specs: { cpu: "Processeurs Intel® Xeon® Scalable", mem: "Configuration flexible selon besoins", st: "Stockage software-defined intégré" }, features: ["Conçu avec VMware, pour VMware", "Rationalise les opérations", "Évolution prévisible", "Gestion simplifiée"] },
        vcf: { name: "VMware Cloud Foundation sur VxRail", badge: "Datacenter Software-Defined", workloads: ["Datacenter software-defined", "Cloud hybride", "Transition digitale"], specs: { cpu: "Processeurs Intel® Xeon® Scalable", mem: "Mémoire haute capacité", st: "Stockage software-defined VMware" }, features: ["Accélère la transition vers le datacenter software-defined", "Cloud hybride VMware", "Infrastructure unifiée", "Gestion centralisée"] },
        dynamic: { name: "Nœuds dynamiques VxRail", badge: "Flexible", workloads: ["Calcul flexible", "Stockage évolutif", "Charges variables"], specs: { cpu: "Processeurs Intel® Xeon® Scalable", mem: "Évolution indépendante du calcul", st: "Stockage software-defined Dell évolutif" }, features: ["Évolution flexible du calcul et stockage", "Évolution indépendante", "Stockage software-defined Dell", "Optimisation des ressources"] },
        azure: { name: "Système Dell AX pour Azure Local", badge: "Microsoft Premier", workloads: ["Cloud adaptatif Azure", "Automatisation", "Intégration améliorée"], specs: { cpu: "Processeurs Intel® Xeon® Scalable", mem: "Configuration Azure optimisée", st: "Stockage compatible Azure Local" }, features: ["Solution Microsoft Premier", "Automatisation améliorée", "Intégration optimisée", "Innovation avec audace", "Cloud adaptatif Azure optimisé"] },
        vsan: { name: "Nœuds vSAN Ready", badge: "Modernisation", workloads: ["Modernisation datacenter", "Infrastructure HCI", "Déploiement accéléré"], specs: { cpu: "Large éventail de serveurs PowerEdge", mem: "Configuration selon modèle PowerEdge", st: "VMware vSAN™ intégré" }, features: ["Combine serveurs PowerEdge avec VMware vSAN™", "Solution préconfigurée et certifiée", "Réduit les risques", "Accélère le déploiement", "Modernise le datacenter"] },
        xc: { name: "Solutions de la gamme XC", badge: "Polyvalent", workloads: ["Infrastructure polyvalente", "HCI évolutive", "Multi-hyperviseur"], specs: { cpu: "Serveurs Dell PowerEdge avec processeurs Intel Xeon", mem: "Configuration selon modèle PowerEdge", st: "Stockage software-defined Nutanix" }, features: ["Intègrent logiciel Nutanix", "Serveurs Dell PowerEdge avec processeurs Intel Xeon", "Plateforme HCI polyvalente et évolutive", "Une des plus polyvalentes du marché"] }
      }
    },
    backup: {
      seo: { title: "Sauvegarde & Cyber-résilience Tunisie | Dell Data Domain | S2i", description: "Protégez vos données critiques avec Dell PowerProtect Data Domain. Solution leader de backup et récupération après sinistre en Tunisie." },
      hero: {
        badge: "Solutions de Sauvegarde Dell Technologies",
        title: "Solutions de <span style='color: #d90000'>Sauvegarde</span> & Cyberrésilience",
        sub: "PowerProtect Data Domain : Protection et gestion des données leader sur le marché, que ce soit sur site ou dans un environnement multicloud. Cyberrésilience intégrée pour une récupération plus rapide.",
        btn1: "Découvrir les Solutions",
        btn2: "Nous Contacter",
        whyTitle: "Pourquoi choisir nos solutions ?",
        whyList: [
          'Cyberrésilience intégrée contre les ransomwares',
          'Réduction des données jusqu\'à 65:1',
          'Restaurations jusqu\'à 44% plus rapides',
          'Protection multicloud native',
          'Architecture d\'invulnérabilité des données (DIA)',
          'Support 24/7 par nos experts certifiés'
        ]
      },
      titleSection: "Solutions de <span style='color: #d90000'>Sauvegarde</span>",
      available: "solutions disponibles",
      categories: {
        title: "Catégories de <span style='color: #d90000'>Solutions</span>",
        subtitle: "Solutions complètes de sauvegarde et cyberrésilience Dell PowerProtect",
        "physical-appliance": { name: "Appliances Physiques", desc: "Solutions de sauvegarde haute performance sur matériel dédié" },
        "virtual-edition": { name: "Éditions Virtuelles", desc: "Solutions de sauvegarde software-defined pour le Cloud" },
        "all-flash": { name: "All-Flash", desc: "Appliances ultra-rapides pour restaurations critiques" },
        "cyber-recovery": { name: "Cyberrésilience", desc: "Solutions de protection contre cyberattaques et ransomwares" }
      },
      sidebar: {
        title: "Filtres & Recherche",
        search: "Recherche",
        searchPl: "Nom, fonctionnalité, cas d'usage...",
        cat: "Catégorie",
        all: "Toutes les solutions",
        results: "solution(s) trouvée(s)",
        pageOf: "sur",
        view: "Vue",
        grid: "Grille",
        list: "Liste"
      },
      card: {
        new: "Nouveau",
        cpu: "Processeur",
        cap: "Capacité",
        st: "Stockage",
        net: "Réseau",
        highlights: "FONCTIONNALITÉS CLÉS"
      },
      cta: {
        title: "Prêt à Sécuriser Vos Données ?",
        sub: "Contactez nos experts pour une consultation personnalisée sur nos solutions PowerProtect Data Domain et renforcez votre cyberrésilience avec la protection de données leader du marché.",
        btn1: "Contactez nos experts",
        btn2: "Documentation"
      },
      products: {
        dd9910: {
          name: "PowerProtect Data Domain DD9910",
          badge: "Haute Performance",
          workloads: ['Sauvegarde entreprise', 'Archivage long terme', 'Reprise après sinistre'],
          specs: { cpu: "Processeurs Intel® Xeon® Scalable", cap: "576 TB - 1.5 PB utilisable", st: "Jusqu'à 97.5 PB avec Cloud Tier", net: "Jusqu'à 130 TB/heure de débit" },
          features: ['Performances jusqu\'à 130 TB/heure', 'Capacité jusqu\'à 97.5 PB', 'Réduction des données jusqu\'à 65:1', 'Cyberrésilience intégrée', 'Architecture d\'invulnérabilité des données (DIA)']
        },
        dd9410: {
          name: "PowerProtect Data Domain DD9410",
          badge: "Performance",
          workloads: ['Sauvegarde mid-range', 'Protection multicloud', 'Consolidation'],
          specs: { cpu: "Processeurs Intel® Xeon® Scalable", cap: "192 TB - 768 TB utilisable", st: "Jusqu'à 49.9 PB avec Cloud Tier", net: "Jusqu'à 75 TB/heure de débit" },
          features: ['Performances jusqu\'à 75 TB/heure', 'Capacité jusqu\'à 49.9 PB', 'Efficacité optimale avec déduplication', 'Protection multicloud native', 'Évolution flexible']
        },
        dd6410: {
          name: "PowerProtect Data Domain DD6410",
          badge: "Entrée de gamme",
          workloads: ['PME/ETI', 'Sites distants', 'Sauvegarde bureaux'],
          specs: { cpu: "Processeurs Intel® Xeon®", cap: "12 TB - 256 TB utilisable", st: "Jusqu'à 16.6 PB avec Cloud Tier", net: "Jusqu'à 66.8 TB/heure de débit" },
          features: ['Solution économique et évolutive', 'Performances jusqu\'à 66.8 TB/heure', 'Idéal pour PME et sites distants', 'Déduplication avancée', 'Protection intégrée']
        },
        flash: {
          name: "All-Flash Ready Node",
          badge: "Ultra-rapide",
          workloads: ['Restauration critique', 'Sauvegarde flash', 'Performances extrêmes'],
          specs: { cpu: "Processeurs Intel® Xeon® Scalable de dernière génération", cap: "220 TB utilisable", st: "Stockage All-Flash haute performance", net: "Jusqu'à 56.4 TB/heure de débit" },
          features: ['Restaurations ultra-rapides', 'Technologie All-Flash', 'Cyberrésilience avancée', 'Efficacité énergétique', 'Performances constantes', 'Durabilité et sécurité intégrées']
        },
        ddve: {
          name: "PowerProtect Data Domain Virtual Edition",
          badge: "Software-Defined",
          workloads: ['Cloud public', 'Virtualisation', 'Déploiement flexible'],
          specs: { cpu: "Compatible tous hyperviseurs", cap: "Configuration flexible selon besoins", st: "Stockage software-defined", net: "Déploiement Cloud et on-premises" },
          features: ['Déploiement sur site et Cloud', 'Indépendant du matériel', 'Évolution à la demande', 'Technologie Data Domain', 'Protection cohérente partout']
        },
        cyber: {
          name: "PowerProtect Cyber Recovery",
          badge: "Cyberrésilience",
          workloads: ['Protection ransomware', 'Récupération cyber', 'Analyse forensique'],
          specs: { cpu: "Architecture Air-Gapped sécurisée", cap: "Coffre-fort cyber isolé", st: "Protection immuable des données", net: "Isolation réseau complète" },
          features: ['Protection contre les ransomwares', 'Coffre-fort cyber air-gapped', 'Détection d\'activités suspectes', 'Récupération automatisée', 'Analyse forensique intégrée', 'Conformité réglementaire']
        }
      }
    },
    digitalSignage: {
      hero: {
        badge: "Solutions d'affichage Sharp/NEC",
        title: "Murs d'Écrans<br />Large Format Display",
        subtitle: "Découvrez notre gamme complète d'écrans Sharp/NEC pour signalétique numérique, centres de contrôle et applications professionnelles.",
        btnExplore: "Explorer les écrans",
        btnGuide: "Guide technique",
        cardTitle: "Affichage Professionnel",
        cardSub: "Solutions d'écrans grande taille pour tous vos besoins d'affichage"
      },
      sidebar: {
        search: "Recherche",
        searchPl: "Rechercher un écran...",
        category: "Catégorie",
        all: "Toutes les catégories",
        display: "Affichage",
        found: "écran(s) trouvé(s)",
        pageOf: "sur"
      },
      categories: {
        essential: { name: "Essential Displays", desc: "Écrans grand format essentiels pour les applications de base" },
        midrange: { name: "Midrange Displays", desc: "Écrans milieu de gamme avec fonctionnalités avancées" },
        professional: { name: "Professional Displays", desc: "Écrans professionnels haute performance" }
      },
      advantages: {
        quality: "Qualité Professionnelle",
        qualityD: "Écrans haute résolution pour un affichage professionnel",
        format: "Grand Format",
        formatD: "Tailles d'écran de 32\" à 98\" pour tous les besoins",
        reliable: "Fonctionnement 24/7",
        reliableD: "Conçus pour un fonctionnement continu et fiable",
        features: "Fonctionnalités Avancées",
        featuresD: "Technologies intégrées pour une gestion simplifiée"
      },
      card: {
        usage: "Usage clé",
        tech: "Technologies",
        noImage: "Image non disponible",
        noResults: "Aucun écran trouvé",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      products: {
  e869: { desc: "Écran LCD 86\" Essential Large Format Display - Solution d'affichage grand format idéale pour les applications de signalétique numérique de base", use: "Signalétique numérique, Présentations, Applications retail", tech: "Android SoC, MediaPlayer, Connectivité étendue" },
  e759: { desc: "Écran LCD 75\" Essential Large Format Display - Affichage grand format polyvalent pour les environnements commerciaux", use: "Commerce de détail, Bureaux, Espaces d'accueil", tech: "Luminosité optimisée, Connectivité multiple" },
  e659: { desc: "Écran LCD 65\" Essential Large Format Display - Solution d'affichage compacte et efficace", use: "Salles de réunion, Présentations, Affichage d'information", tech: "Format compact, Installation flexible" },
  m552: { desc: "Écran LCD 55\" Message Large Format Display - Écran milieu de gamme avec fonctionnalités de messagerie avancées", use: "Messagerie dynamique, Communication interne, Affichage interactif", tech: "Fonctionnalités messagerie, Connectivité avancée" },
  me752: { desc: "Écran LCD 75\" Message Essential Large Format Display - Solution d'affichage grand format avec capacités de messagerie", use: "Communication d'entreprise, Affichage dynamique, Centres de contrôle", tech: "Technologie Message Essential, Multi-input" },
  me982: { desc: "Écran LCD 98\" Message Essential Large Format Display - Écran ultra grand format pour applications critiques", use: "Centres de contrôle, Salles de conférence, Affichage grand public", tech: "Ultra grand format, Haute résolution, Connectivité étendue" },
  me862: { desc: "Écran LCD 86\" Message Essential Large Format Display - Écran grand format avec technologie Message Essential", use: "Affichage publicitaire, Communication visuelle, Espaces publics", tech: "Message Essential, Luminosité élevée" },
  p556: { desc: "Écran LCD 55\" Professional Large Format Display - Écran professionnel haute performance pour applications critiques", use: "Applications 24/7, Environnements professionnels, Centres de contrôle", tech: "Fonctionnement 24/7, Luminosité élevée, Fiabilité industrielle" },
  p656: { desc: "Écran LCD 65\" Professional Large Format Display - Solution d'affichage professionnel avec performances optimales", use: "Surveillance, Centres de données, Applications critiques", tech: "Haute fiabilité, Luminosité professionnelle, Connectivité avancée" },
  e328: { desc: "Écran LCD 32\" Essential Large Format Display - Écran compact NEC pour applications essentielles", use: "Affichage d'information, Points de vente, Applications légères", tech: "Format compact, Efficacité énergétique" },
  m651: { desc: "Écran LCD 65\" Message Large Format Display - Écran NEC milieu de gamme avec capacités de messagerie", use: "Communication d'entreprise, Affichage informatif, Espaces collaboratifs", tech: "Messagerie intégrée, Connectivité multiple" },
  m551: { desc: "Écran LCD 55\" Message Large Format Display - Solution d'affichage NEC avec fonctionnalités de messagerie avancées", use: "Bureaux modernes, Salles de réunion, Communication visuelle", tech: "Technologie Message, Installation flexible" }
}    },
    digitalSignage2: {
      hero: {
        badge: "Solutions de Signalétique Numérique Sharp/NEC",
        title: "Signalétique<br />Numérique Professionnelle",
        subtitle: "Solutions de signalétique numérique personnalisées avec computing embarqué, verre de protection et réseau de partenaires pour intégrations complètes.",
        btnExplore: "Explorer les solutions",
        btnGuide: "Partenaires logiciels",
        cardTitle: "Signalétique Sur Mesure",
        cardSub: "Solutions modulaires adaptées à tous vos besoins de communication visuelle"
      },
      advantages: {
        custom: { name: "Solutions Sur Mesure", desc: "Solutions de signalétique numérique personnalisées et modulaires" },
        power: { name: "Puissance Intégrée", desc: "Computing embarqué avec Raspberry Pi et Android SoC" },
        protection: { name: "Protection Avancée", desc: "Verre de protection, miroir, cadres colorés et boîtiers" },
        partner: { name: "Réseau Partenaires", desc: "Large réseau de partenaires solutions pour intégrations complètes" }
      },
      sidebar: {
        search: "Recherche",
        searchPl: "Rechercher une solution...",
        category: "Catégorie",
        all: "Toutes les catégories",
        display: "Affichage",
        found: "solution(s) trouvée(s)",
        pageOf: "sur"
      },
      categories: {
        essential: "Message Essential",
        brightness: "Haute Luminosité",
        modular: "Computing Modulaire"
      },
      card: {
        usage: "Usage clé",
        tech: "Technologies",
        noImage: "Image non disponible",
        noResults: "Aucune solution trouvée",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      products: {
        me752: "Écran LCD 75\" Message Essential Large Format Display - Solution de signalétique numérique professionnelle avec technologies intégrées",
        me982: "Écran LCD 98\" Message Essential Large Format Display - Écran ultra grand format pour signalétique d'impact maximal",
        me862: "Écran LCD 86\" Message Essential Large Format Display - Solution polyvalente pour signalétique numérique professionnelle",
        me652: "Écran LCD 65\" Message Essential Large Format Display - Format standard pour applications de signalétique variées",
        me552: "Écran LCD 55\" Message Essential Large Format Display - Solution compacte et efficace pour signalétique ciblée",
        me502: "Écran LCD 50\" Message Essential Large Format Display - Format moyen idéal pour espaces restreints",
        me432: "Écran LCD 43\" Message Essential Large Format Display - Solution d'entrée de gamme pour signalétique basique",
        useRetail: "Signalétique retail, Affichage publicitaire, Communication corporate",
        usePublic: "Centres commerciaux, Aéroports, Gares, Espaces publics",
        useHospitality: "Retail, Hôtellerie, Corporate, Espaces d'accueil",
        useOffice: "Bureaux, Retail, Restaurants, Espaces de vente",
        usePoint: "Points de vente, Affichage promotionnel, Information clients",
        useBoutique: "Boutiques, Cafés, Bureaux, Salles d'attente",
        useBasic: "Information basique, Menus digitaux, Affichage simple",
        tech_me752: "Android SoC, MediaPlayer intégré, Luminosité 700 cd/m², Orientation portrait/paysage",
        tech_me982: "Ultra grand format, Haute résolution 4K, Computing embarqué, Connectivité étendue", 
        tech_me862: "Message Essential technology, Luminosité élevée, Support modulaire",
        tech_me652: "Message Essential, MediaPlayer NEC inclus, Orientation flexible",
        tech_me552: "Computing modulaire, Raspberry Pi supporté, Verre de protection disponible",
        tech_me502: "Android SoC intégré, Luminosité optimisée, Installation flexible",
        tech_me432: "Format compact, Efficacité énergétique, MediaPlayer intégré"
      }
    },
    printing: {
      hero: {
        badge: "Solutions d'impression Kyocera",
        title: "Solutions<br />d'Impression ECOSYS",
        subtitle: "Découvrez notre gamme complète d'imprimantes, multifonctions et solutions de production Kyocera pour optimiser vos processus documentaires.",
        btnExplore: "Explorer les solutions",
        btnGuide: "Guide ECOSYS",
        techTitle: "Technologie ECOSYS",
        techDesc: "Solutions d'impression éco-responsables et économiques"
      },
      sidebar: {
        search: "Recherche",
        searchPlaceholder: "Rechercher une solution...",
        category: "Catégorie",
        all: "Toutes les catégories",
        display: "Affichage",
        found: "solution(s) trouvée(s)",
        pageOf: "sur",
        noResults: "Aucune solution trouvée",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      advantages: {
        title: "Solutions MDS <span style='color: #dc2626'>Avantages</span>",
        subtitle: "Découvrez les avantages pratiques du MDS Kyocera : réduction des coûts, impact environnemental et sécurité renforcée",
        eco_title: "Économique : Transparence des coûts et économies jusqu'à 30%",
        eco_desc: "Plusieurs façons de réduire votre coût total de possession grâce au MDS.",
        eco_list: [
          "Réduction de l'utilisation de consommables comme le papier et le toner",
          "Diminution des coûts énergétiques et de service",
          "Politiques d'impression contraignantes pour éviter les coûts inutiles",
          "Identification facile des facteurs de coût par échange d'appareils"
        ],
        opti_title: "Optimisation : Productivité et motivation des employés",
        opti_desc: "Des avantages mesurables résultent d'autres bénéfices moins orientés coûts.",
        opti_list: [
          "Augmentation de la productivité grâce à des workflows optimisés",
          "Réduction des temps d'arrêt et minimisation de la charge IT",
          "Solutions de sortie modernes pour une gestion documentaire efficace",
          "Gestion d'appareils optimisée pour économiser du temps"
        ],
        service_title: "Sans tracas : Professionnel, personnalisé et d'une seule source",
        service_desc: "Avec un seul point de contact, le MDS vous fait économiser des tracas et de la main-d'œuvre.",
        service_list: [
          "Fourniture complète pour toutes les imprimantes, toutes marques",
          "Maintenance et réparation pour nos appareils et ceux d'autres fabricants",
          "Système de surveillance à distance avec réaction rapide",
          "Service professionnel et personnalisé"
        ],
        secure_title: "Écologique et Sécurisé : Durabilité et Protection des données",
        secure_desc: "Réduction de la consommation d'énergie et protection renforcée des documents et données.",
        secure_list: [
          "Amélioration de la durabilité environnementale avec la technologie ECOSYS",
          "Efficacité énergétique par consolidation matérielle",
          "Accès autorisé aux appareils et réseaux pour plus de sécurité",
          "Contrôles renforcés sur les impressions et protection des données clients"
        ]
      }
    },
    cloud: {
      seo: { title: "Cloud Computing & IaaS Tunisie | Cloud Hybride S2i", description: "Accélérez votre transformation avec le Cloud S2i. Hébergement sécurisé, IaaS, BaaS et DRaaS avec un support local 24/7 en Tunisie." },
      hero: {
        badge: "Cloud Computing by S2i",
        title: "Accélérez votre <span>Transformation Cloud</span>",
        subtitle: "Conçues pour les exigences des entreprises tunisiennes, nos solutions cloud couvrent le cloud privé, hybride et les services managés (IaaS, BaaS, DRaaS) avec sécurité, performance et un accompagnement local S2i de bout en bout.",
        btnExplore: "Explorer le Cloud",
        btnContact: "Nous Contacter",
        whyTitle: "Pourquoi choisir le Cloud S2i ?",
        whyList: [
          "Architecture adaptée à votre métier",
          "Sécurité et conformité intégrées",
          "Supervision & support 24/7 en local",
          "Transparence sur les coûts (FinOps)",
          "Accompagnement de la stratégie à l'exploitation"
        ]
      },
      overview: {
        title: "Comprendre le <span style='color: #dc2626'>Cloud Computing</span>",
        subtitle: "Vue claire et progressive du cloud : concepts, cas d’usage, architecture, gouvernance et FAQ.",
        tabs: {
          apercu: "Aperçu",
          architecture: "Architecture",
          faq: "FAQ"
        },
        cardSvc: {
          title: "Modèles de services",
          list: [
            { t: 'IaaS', d: 'Compute, stockage, réseau à la demande' },
            { t: 'PaaS', d: 'Plateformes pour développer et déployer vite' },
            { t: 'SaaS', d: 'Applications consommées en service' }
          ]
        },
        cardDep: {
          title: "Modèles de déploiement",
          list: [
            { t: 'Privé', d: 'Contrôle & performances garanties' },
            { t: 'Public', d: 'Élasticité & services avancés' },
            { t: 'Hybride/Multicloud', d: 'Le meilleur des deux mondes' }
          ]
        },
        cardBen: {
          title: "Bénéfices clés",
          list: [
            "Agilité & time-to-market",
            "Résilience & PRA/DRaaS",
            "Réseau & sécurité intégrés",
            "Optimisation OPEX (FinOps)"
          ]
        },
        archText: "Architecture multi-couches : Accès, Services, Données et Sécurité.",
        faqQ1: "Public, privé ou hybride ?",
        faqA1: "Le choix dépend de vos contraintes de sécurité et d'agilité."
      },
      catalog: {
        badge: "Catalogue Dynamique",
        title: "Nos Dernières <span>Solutions Cloud</span>",
        subtitle: "Innovations ajoutées récemment par notre équipe S2I",
        new: "Nouveauté",
        details: "Détails"
      },
      others: {
        title: "Autres Solutions de <span style='color: #dc2626'>Data Center</span>",
        hci: "Solutions HCI",
        hciDesc: "Hyperconvergence Dell VxRail.",
        backup: "Backup",
        backupDesc: "Protection des données critiques.",
        storage: "Stockage",
        storageDesc: "Performances All-Flash."
      },
      cta: {
        title: "Prêt à monter dans le Cloud ?",
        subtitle: "Parlez à nos experts S2i pour définir votre stratégie.",
        btn: "Contactez nos experts"
      }
    },
    cybersecurity: {
      hero: {
        badge: "Cybersécurité by S2i",
        title: "Renforcez votre <span style='color: #dc2626'>posture de cybersécurité</span>",
        subtitle: "Protégez vos utilisateurs, applications et données grâce à une approche en couches.",
        btnExplore: "Explorer les solutions",
        btnContact: "Nous Contacter"
      },
      intro: {
        title: "La cybersécurité, <span>un défi permanent</span>",
        subtitle: "Dans un monde hyperconnecté, la sécurité informatique n'est plus une option. S2i vous apporte l'expertise nécessaire pour anticiper les menaces."
      },
      solutions: {
        title: "Nos <span style='color: #dc2626'>Solutions de Sécurité</span>",
        subtitle: "Combinaison de nos piliers historiques et des dernières innovations",
        fw_title: "Firewall (NGFW)",
        fw_desc: "Protection périmétrique avancée avec inspection applicative.",
        waf_title: "WAF (FortiWeb)",
        waf_desc: "Protection spécialisée pour applications web et APIs.",
        lb_title: "Load Balancer",
        lb_desc: "Répartition intelligente de charge et haute disponibilité.",
        newBadge: "Nouveauté Admin"
      },
      cta: {
        title: "Prêt à sécuriser votre entreprise ?",
        btn: "Parlez à un expert"
      }
    },
    firewall: {
      seo: { title: "Pare-feu Fortinet FortiGate Tunisie | Sécurité Réseau | S2i", description: "Protection périmétrique avec les firewalls Next-Gen FortiGate. Expert Fortinet en Tunisie pour sécuriser votre réseau contre les cybermenaces." },
      hero: {
        badge: "Pare-feu Nouvelle Génération Fortinet FortiGate",
        title: "Pare-feu <span style='color: #d90000'>Nouvelle Génération</span> FortiGate",
        subtitle: "Les pare-feux FortiGate offrent une sécurité inégalée et des performances 17 fois supérieures, avec des processeurs ASIC brevetés et une protection optimisée par l'IA pour tous vos environnements hybrides.",
        btnExplore: "Découvrir les Solutions",
        btnContact: "Nous Contacter",
        whyTitle: "Pourquoi choisir FortiGate ?",
        whyList: [
          'Performances 17x supérieures à la concurrence',
          'Processeurs ASIC brevetés SP5, NP7, CP9',
          'Protection optimisée par l\'IA FortiGuard',
          'Efficacité de la sécurité 99,98%',
          'Réduction énergétique de 62% en moyenne',
          'Gestion unifiée FortiManager'
        ]
      },
      categories: {
        title: "Catégories de <span style='color: #d90000'>Solutions</span>",
        subtitle: "Pare-feux FortiGate pour tous vos environnements hybrides",
        "data-center": { name: "Data Center", desc: "Solutions haute performance pour data centers et entreprises" },
        "campus-enterprise": { name: "Campus d'Entreprise", desc: "Protection pour sites d'entreprise et campus" },
        "branch-office": { name: "Succursales", desc: "Sécurité et SD-WAN pour sites distants" },
        "cloud-security": { name: "Cloud & Virtualisé", desc: "Protection pour environnements cloud et virtualisés" }
      },
      sidebar: {
        title: "Filtres & Recherche",
        search: "Recherche",
        searchPl: "Nom, fonctionnalité, cas d'usage...",
        cat: "Catégorie",
        all: "Toutes les solutions",
        results: "solution(s) trouvée(s)",
        pageOf: "sur",
        view: "Vue",
        grid: "Grille",
        list: "Liste"
      },
      card: {
        new: "Nouveau",
        processor: "Processeur",
        performance: "Performance",
        interfaces: "Interfaces",
        network: "Réseau",
        featuresTitle: "Fonctionnalités clés"
      },
      cta: {
        title: "Prêt à Sécuriser Votre Réseau ?",
        subtitle: "Contactez nos experts pour une démonstration personnalisée des solutions FortiGate et découvrez pourquoi plus de 50% des entreprises mondiales font confiance à Fortinet pour leur sécurité réseau.",
        btn1: "Contactez nos experts",
        btn2: "Démo gratuite"
      },
      products: {
        f7121f: {
          name: "FortiGate 7121F",
          badge: "Ultra Haute Performance",
          workloads: ['Data Center hyperscale', 'Protection haute performance', 'Trafic intensif'],
          specs: { processor: 'Processeurs de sécurité SP5 + NP7', memory: '520 Gbps de débit pare-feu', storage: 'Interfaces 400GE/200GE/100GE', network: 'Inspection SSL/TLS haute performance' },
          features: ['Débit pare-feu jusqu\'à 520 Gbps', 'Processeurs de sécurité dédiés SP5', 'Interfaces 400GE haute vitesse', 'Architecture hyperscale', 'Inspection SSL/TLS avancée']
        },
        f6500f: {
          name: "FortiGate 6500F",
          badge: "Haute Performance",
          workloads: ['Data center entreprise', 'Protection avancée', 'Consolidation sécurité'],
          specs: { processor: 'Processeurs NP7 + CP9', memory: '100 Gbps de débit pare-feu', storage: 'Interfaces 100GE/40GE/25GE', network: 'Fonctions SD-WAN intégrées' },
          features: ['Débit pare-feu jusqu\'à 100 Gbps', 'Processeurs réseau NP7', 'SD-WAN sécurisé intégré', 'Protection contre les menaces avancées', 'Évolutivité modulaire']
        },
        f4800f: {
          name: "FortiGate 4800F",
          badge: "Performance",
          workloads: ['Réseau d\'entreprise', 'Protection multi-couches', 'Connectivité sécurisée'],
          specs: { processor: 'Processeurs NP7', memory: '70 Gbps de débit pare-feu', storage: 'Interfaces 100GE/40GE/10GE', network: 'Protection IPS/UTM complète' },
          features: ['Débit pare-feu jusqu\'à 70 Gbps', 'Protection UTM complète', 'Interfaces haute vitesse flexibles', 'Gestion centralisée FortiManager', 'Efficacité énergétique optimale']
        },
        f1800f: {
          name: "FortiGate 1800F",
          badge: "Entreprise",
          workloads: ['Campus d\'entreprise', 'Protection utilisateurs', 'Contrôle applicatif'],
          specs: { processor: 'Processeurs NP6 + CP9', memory: '15 Gbps de débit pare-feu', storage: 'Interfaces 10GE/GE flexibles', network: 'SD-WAN et sécurité convergés' },
          features: ['Débit pare-feu jusqu\'à 15 Gbps', 'Protection utilisateurs avancée', 'Contrôle applicatif granulaire', 'SD-WAN sécurisé', 'Inspection SSL décentralisée']
        },
        f1000f: {
          name: "FortiGate 1000F",
          badge: "Milieu de gamme",
          workloads: ['Site d\'entreprise', 'Protection périmétrique', 'Accès sécurisé'],
          specs: { processor: 'Processeurs NP6', memory: '13 Gbps de débit pare-feu', storage: 'Interfaces 10GE/GE', network: 'VPN SSL/IPSec' },
          features: ['Débit pare-feu jusqu\'à 13 Gbps', 'Protection périmétrique complète', 'VPN haute performance', 'Gestion simplifiée', 'Rapport qualité-prix optimal']
        },
        f600f: {
          name: "FortiGate 600F",
          badge: "Succursales",
          workloads: ['Succursales moyennes', 'SD-WAN', 'Protection edge'],
          specs: { processor: 'Processeurs NP6', memory: '10 Gbps de débit pare-feu', storage: 'Interfaces GE/SFP+', network: 'SD-WAN intégré' },
          features: ['SD-WAN sécurisé intégré', 'Protection edge complète', 'Gestion centralisée simplifiée', 'Connectivité WAN flexible', 'Zero-touch provisioning']
        },
        f200f: {
          name: "FortiGate 200F",
          badge: "Compact",
          workloads: ['Petites succursales', 'SOHO', 'Bureau distant'],
          specs: { processor: 'Processeur intégré', memory: '20 Gbps de débit pare-feu', storage: 'Interfaces GE intégrées', network: 'Wi-Fi 6 en option' },
          features: ['Débit élevé dans format compact', 'Wi-Fi 6 intégré disponible', 'Déploiement simplifié', 'Protection complète UTM', 'Coût total de possession réduit']
        },
        fvm: {
          name: "FortiGate VM",
          badge: "Virtualisé",
          workloads: ['Cloud public', 'Virtualisation', 'Déploiements hybrides'],
          specs: { processor: 'CPU virtuels flexibles', memory: 'Performance basée sur ressources', storage: 'Stockage cloud/virtualisé', network: 'Interfaces virtuelles' },
          features: ['Déploiement multi-cloud', 'Élasticité automatique', 'Même FortiOS que matériel', 'Intégration DevOps/API', 'Licence flexible pay-as-you-grow']
        }
      }
    },
    waf: {
      seo: { title: "Protection Applications Web Tunisie | Fortinet FortiWeb | S2i", description: "Sécurisez vos applications et APIs avec FortiWeb WAF. Protection contre le Top 10 OWASP et les attaques zero-day en Tunisie." },
      hero: {
        badge: "Pare-feu Applicatif Web Fortinet FortiWeb",
        title: "WAF <span style='color: #d90000'>Nouvelle Génération</span> FortiWeb",
        subtitle: "FortiWeb protège vos applications web critiques contre les menaces du Top 10 OWASP, les attaques zero-day et les bots malveillants avec une intelligence artificielle avancée et une détection comportementale sans faux positifs.",
        btnExplore: "Découvrir les Solutions",
        btnContact: "Nous Contacter"
      },
      why: {
        title: "Pourquoi choisir FortiWeb ?",
        list: [
          'Protection OWASP Top 10 complète',
          'Intelligence artificielle FortiGuard intégrée',
          'Détection zero-day sans faux positifs',
          'Protection anti-bots biométrique avancée',
          'Découverte et protection d\'API automatique',
          'Intégration Security Fabric native'
        ]
      },
      categories: {
        title: "Catégories de <span style='color: #d90000'>Solutions WAF</span>",
        subtitle: "Protection d'applications web pour tous vos environnements hybrides",
        "appliances-hardware": { name: "Appliances Matérielles", desc: "Solutions WAF physiques avec processeurs dédiés et accélération SSL" },
        "virtual-machines": { name: "Machines Virtuelles", desc: "Solutions WAF virtualisées pour environnements cloud et hybrides" },
        "cloud-services": { name: "Services Cloud", desc: "WAF as a Service pour AWS, Azure, GCP et autres clouds publics" }
      },
      sidebar: {
        title: "Filtres & Recherche",
        searchLabel: "Recherche",
        searchPlaceholder: "Nom, fonctionnalité, cas d'usage...",
        catLabel: "Catégorie",
        all: "Toutes les solutions",
        found: "solution(s) trouvée(s)",
        pageOf: "sur",
        viewLabel: "Vue",
        grid: "Grille",
        list: "Liste"
      },
      card: {
        new: "Nouveau",
        workloads: "Charges de travail",
        specs: {
          processor: "Processeur",
          performance: "Performance",
          connectivity: "Connectivité",
          network: "Réseau"
        },
        featuresTitle: "Fonctionnalités clés"
      },
      cta: {
        title: "Prêt à Protéger Vos Applications ?",
        subtitle: "Contactez nos experts pour une démonstration personnalisée des solutions FortiWeb WAF et découvrez comment protéger vos applications critiques contre les menaces du Top 10 OWASP, les attaques zero-day et les bots malveillants avec l'IA FortiGuard.",
        btnExpert: "Contactez nos experts",
        btnDemo: "Démo gratuite"
      }
    },
    loadbalancer: {
      seo: {
    title: "Load Balancer Fortinet FortiADC Tunisie | S2i",
    description: "Optimisez la disponibilité et la sécurité de vos applications avec FortiADC en Tunisie. Équilibrage de charge L4-L7, GSLB et accélération SSL pour entreprises."
  },
      hero: {
        badge: "Contrôleur de livraison d'applications Fortinet FortiADC",
        title: "Load Balancer <span style='color: #d90000'>Avancé</span> FortiADC",
        subtitle: "FortiADC offre une accélération des applications, une répartition des charges et une sécurité Web inégalées avec WAF intégré, équilibrage global et haute disponibilité dans une solution unique.",
        btnExplore: "Découvrir les Solutions",
        btnContact: "Nous Contacter",
        whyTitle: "Pourquoi choisir FortiADC ?",
        whyList: [
          'Accélération d\'application inégalée',
          'WAF et sécurité intégrés natifs',
          'Équilibrage de charge L4-L7 avancé',
          'GSLB pour continuité d\'activité globale',
          'Intégration Security Fabric Fortinet',
          'Déploiement flexible : physique, VM, cloud'
        ]
      },
      categories: {
        title: "Catégories de <span style='color: #d90000'>Solutions ADC</span>",
        subtitle: "Contrôleurs de livraison d'applications FortiADC pour tous vos environnements",
        hardware: { name: "Appliances Matérielles", desc: "Solutions ADC physiques haute performance avec accélération matérielle" },
        virtual: { name: "Machines Virtuelles", desc: "Solutions ADC virtualisées pour environnements cloud et hybrides" },
        gslb: { name: "GSLB Global", desc: "Équilibrage de charge global DNS pour la continuité d'activité" }
      },
      sidebar: {
        title: "Filtres & Recherche",
        search: "Recherche",
        searchPl: "Nom, fonctionnalité, cas d'usage...",
        category: "Catégorie",
        all: "Toutes les solutions",
        results: "solution(s) trouvée(s)",
        pageOf: "sur",
        view: "Vue",
        grid: "Grille",
        list: "Liste"
      },
      products: {
        f120f: { badge: "Entrée de gamme", workloads: ['Petites applications', 'Sites PME', 'Environnements de test'], specs: { cpu: 'Processeur multicœur', perf: 'Throughput 3 Gbps', int: '6x GE RJ45', net: 'SSL offloading matériel' }, features: ['Équilibrage L4-L7 avancé', 'Accélération SSL matérielle', 'Health checks internes', 'Interface web intuitive', 'Protection DDoS basique'] },
        f220f: { badge: "Performance", workloads: ['Applications moyennes', 'E-commerce', 'Portails web'], specs: { cpu: 'Processeurs multicœurs avancés', perf: 'Throughput 5 Gbps', int: '4x GE RJ45, 2x GE SFP', net: 'WAF intégré avancé' }, features: ['Débit élevé 5 Gbps', 'WAF intégré haute performance', 'Persistance de session avancée', 'Compression HTTP/HTTPS', 'Algorithmes LB intelligents'] },
        f300f: { badge: "Optimisé", workloads: ['Applications critiques', 'Haute disponibilité', 'Charge élevée'], specs: { cpu: 'Processeurs haute performance', perf: 'Throughput 8 Gbps', int: '4x GE RJ45, 4x GE SFP', net: 'Sécurité multicouches' }, features: ['Performances optimales 8 Gbps', 'Sécurité applicative avancée', 'Global Server Load Balancing', 'Cache applicatif intelligent', 'Monitoring temps réel'] },
        f400f: { badge: "Haute Performance", workloads: ['Data center', 'Applications d\'entreprise', 'Trafic intensif'], specs: { cpu: 'Processeurs multicœurs optimisés', perf: 'Throughput 15 Gbps', int: '2x 10GE SFP+, 4x GE SFP, 4x GE', net: 'Protection avancée intégrée' }, features: ['Très haute performance 15 Gbps', 'Interfaces 10GE haute vitesse', 'Sécurité applicative complète', 'Load balancing géographique', 'API REST pour automatisation'] },
        fvm: { badge: "Virtualisé", workloads: ['Cloud privé', 'Virtualisation', 'Déploiements hybrides'], specs: { cpu: 'CPU virtuels flexibles', perf: 'Performance selon ressources', int: 'Stockage virtuel évolutif', net: 'Interfaces réseau virtuelles' }, features: ['Déploiement multi-hyperviseur', 'Élasticité automatique', 'Mêmes fonctionnalités que matériel', 'Intégration DevOps/API', 'Licence flexible'] },
        fgslb: { badge: "Service DNS", workloads: ['Global applications', 'Disaster Recovery', 'CDN intelligent'], specs: { cpu: 'Infrastructure DNS globale', perf: 'Résolution DNS < 5ms', int: 'Redondance géographique', net: 'Anycast DNS worldwide' }, features: ['DNS géographiquement distribué', 'Health checks multi-sites', 'Basculement automatique DR', 'Géolocalisation intelligente', 'Analytics trafic global'] }
      },
      security: {
        title: "Solutions de <span style='color: #d90000'>Sécurité</span>",
        subtitle: "Trois piliers essentiels pour sécuriser votre infrastructure",
        learnMore: "En savoir plus",
        pillars: {
          fw: { title: "Firewall (NGFW)", desc: "Protection périmétrique avancée avec inspection applicative, IPS, contrôle SSL et VPN sécurisé.", features: ['Inspection stateful & applicative', 'IPS/AV, filtrage URL, SSL/TLS', 'VPN & SD-WAN sécurisé', 'Segmentation & Zero Trust'] },
          waf: { title: "WAF (Web Application Firewall)", desc: "Protection spécialisée pour applications web et APIs contre l'OWASP Top 10 et attaques logiques.", features: ['Protection OWASP Top 10 & bots', 'Sécurité API & JSON', 'Machine learning & signatures', 'Intégration CI/CD & DevSecOps'] },
          cyber: { title: "Cyber Sécurité", desc: "Stratégie de cybersécurité complète avec approche Zero Trust et protection multicouches.", features: ['Approche Zero Trust complète', 'Protection multicouches avancée', 'SOC et surveillance 24/7', 'Formation et sensibilisation'] }
        }
      },
      cta: {
        title: "Optimisez Vos Applications",
        subtitle: "Contactez nos experts pour découvrir comment FortiADC peut améliorer les performances, la sécurité et la disponibilité de vos applications critiques avec une solution tout-en-un.",
        btnContact: "Contactez nos experts",
        btnDemo: "Démo gratuite FortiADC"
      }
    },
    antispam: {
      hero: {
        badge: "Protection FortiGuard AntiSpam & Antivirus",
        title: "Protection <span style='color: #d90000'>AntiVirus & AntiSpam</span> Avancée",
        subtitle: "FortiGuard Antivirus & Anti-Spam offrent une protection complète contre les menaces malware, ransomware et attaques email avec technologies IA/ML et détection CPRL. Protection temps réel 99.98% d'efficacité prouvée.",
        btnExplore: "Explorer les solutions",
        btnContact: "Nous Contacter"
      },
      whyBox: {
        title: "Pourquoi FortiGuard ?",
        features: [
          'Protection IA/ML contre zero-day & polymorphes',
          'CPRL - Détection avancée sans signatures',
          'Efficacité 99.98% prouvée contre spam',
          'Intégration Security Fabric complète',
          'Mises à jour temps réel automatisées',
          'Support multi-plateforme et endpoints'
        ]
      },
      tabs: {
        av: "FortiGuard Antivirus",
        as: "FortiGuard Anti-Spam"
      },
      overview: {
        title: "Solutions de <span style='color: #d90000'>Protection Avancée</span>",
        subtitle: "Découvrez nos services FortiGuard Antivirus et Anti-Spam intégrés dans la Security Fabric"
      },
      avContent: {
        mainTitle: "Protection Anti-Malware Intelligente",
        mainDesc: "Le service FortiGuard Antivirus utilise une pile technologique complète incluant la détection par signatures, l'analyse heuristique comportementale, et l'analyse pilotée par IA/ML pour protéger contre les malwares polymorphes et zero-day.",
        list: {
          cprl: "CPRL (Content Pattern Recognition Language) - Plus efficace que les signatures traditionnelles",
          ia: "Intelligence Artificielle - Détection des malwares évasifs et alimentés par IA",
          updates: "Mises à jour temps réel - Protection à jour contre les dernières menaces"
        },
        featTitle: "Fonctionnalités Clés",
        featList: [
          "Protection Zero-Day : Coordination avec FortiSandbox",
          "Security Fabric : Protection à différentes étapes",
          "Multi-plateforme : FortiGate, FortiMail, FortiWeb, FortiClient",
          "Couverture étendue : Réseaux IT/OT et workloads cloud"
        ],
        cprlTitle: "Technologie CPRL",
        cprlList: [
          "Efficacité supérieure : Plus précis que les signatures traditionnelles",
          "Détection élargie : Identifie les malwares sans fichier signature",
          "IA intégrée : Combinaison CPRL + Machine Learning",
          "Protection étendue : Contre variants inconnus"
        ]
      },
      asContent: {
        mainTitle: "Protection Email Multi-Couches Avancée",
        mainDesc: "FortiGuard Anti-Spam fournit une approche complète et multi-couches pour détecter et filtrer le spam. Avec une technologie de détection dual-pass, il réduit drastiquement le volume de spam au périmètre avec 99.98% d'efficacité.",
        list: {
          dual: "Détection Dual-Pass - Réduction drastique du volume de spam",
          perso: "Personnalisation avancée - Politiques par domaine, groupe ou utilisateur",
          updates: "Mises à jour rapides - Options push et pull"
        },
        featTitle: "Filtrage Intelligent",
        featList: [
          "Protection périmétrique : Contre menaces email #1 vecteur d'attaque",
          "Contrôle granulaire : Gestion des attaques et infections email",
          "Protection mobile : FortiClient pour appareils distants",
          "Efficacité prouvée : 99.98% selon tests Virus Bulletin"
        ],
        opsTitle: "Gestion Simplifiée",
        opsList: [
          "Set & Forget : Réduction coûts gestion et opérationnels",
          "Licence device-based : Coûts d'entrée et maintenance réduits",
          "Politiques flexibles : Adaptation à votre organisation",
          "Mises à jour accélérées : Sécurité toujours à jour"
        ]
      },
      fabric: {
        title: "Intégration Security Fabric Fortinet",
        desc: "La force de l'approche platform-driven de Fortinet permet des workflows coordonnés incluant la réponse, avec un effet réseau globalisé sur l'ensemble de la base installée Fortinet.",
        items: {
          ngfw: "Protection périmètre",
          mail: "Sécurité email",
          client: "Protection endpoints",
          sandbox: "Analyse comportementale",
          fabricTitle: "Security Fabric",
          fabricSub: "Protection coordonnée et intégrée sur l'ensemble de votre infrastructure"
        }
      },
      useCases: {
        title: "Cas d'Usage Principaux",
        subtitle: "Applications concrètes des services FortiGuard Antivirus & Anti-Spam",
        list: [
          { title: "Réseaux IT & OT", desc: "Protection réseaux convergents sans impact productivité" },
          { title: "Protection Endpoints", desc: "Sécurisation appareils et prévention exécution malveillante" },
          { title: "Workloads Cloud", desc: "Protection applications et données dans le cloud" },
          { title: "Sécurité Email", desc: "Filtrage spam et protection contre attaques email" },
          { title: "Zero-Day Protection", desc: "Coordination avec FortiSandbox contre menaces inconnues" },
          { title: "Gestion Multi-Utilisateurs", desc: "Politiques personnalisées par domaine, groupe ou utilisateur" }
        ]
      },
      cta: {
        title: "Renforcez Votre Protection",
        desc: "Contactez nos experts S2i pour déployer FortiGuard Antivirus & Anti-Spam et bénéficier d'une protection 99.98% efficace contre malwares et spam.",
        btnExpert: "Contactez nos experts",
        btnDemo: "Démo FortiGuard"
      }
    },
    coreSwitching: {
      seo: { 
    title: "Switch Cisco Catalyst Core & Distribution Tunisie | S2i", 
    description: "Découvrez les solutions Cisco Catalyst 9600 et 9500 pour un cœur de réseau performant. Expert Cisco en Tunisie pour infrastructures campus et distribution." 
  },
      hero: {
        badge: "Core & Distribution Réseau Cisco",
        title: "Switches <span style='color: #d90000'>Cisco Campus Core</span> & Distribution",
        subtitle: "Les plateformes Catalyst 9600/9500 et Meraki pour un coeur de réseau performant, sécurisé et automatisé.",
        btnExplore: "Explorer les switches",
        btnQuote: "Demander un devis"
      },
      categoriesTitle: "Catégories de Switches",
      categoriesSubtitle: "Choisissez la plateforme adaptée à votre coeur et distribution",
      sidebar: {
        title: "Filtres & Recherche",
        searchLabel: "Recherche",
        searchPlaceholder: "Nom, fonctionnalité, cas d'usage...",
        catLabel: "Catégorie",
        allSwitches: "Tous les switches",
        found: "switch(es) trouvé(s)",
        pageOf: "sur",
        viewLabel: "Vue",
        grid: "Grille",
        list: "Liste",
        noResults: "Aucun switch trouvé",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      card: {
        new: "Nouveau",
        usage: "Cas d'usage",
        specsLabel: "Spécifications",
        ports: "Ports",
        uplinks: "Uplinks",
        fabric: "Fabric/Backplane",
        unit: "Unité",
        points: "Points forts"
      },
      otherSolutions: {
        title: "Autres Solutions <span>Réseau</span>",
        subtitle: "Complétez votre infrastructure réseau avec nos nos solutions Cisco intégrées",
        access: {
          title: "Access Switching",
          desc: "Switches d'accès campus haute performance et sécurisés (Catalyst 9200/9300, Meraki MS225/MS390).",
          f: ["Accès filaire pour utilisateurs et AP WiFi", "PoE/PoE+ et gestion intelligente", "Automatisation Cisco DNA", "Sécurité d'accès avancée"]
        },
        wifi: {
          title: "WiFi (Access Point)",
          desc: "Points d'accès WiFi 6/6E/7 pour des performances élevées et une couverture fiable en campus.",
          f: ["WiFi 6E/7 très haut débit", "Optimisation RF automatique", "Sécurité WPA3 & segmentation", "Gestion centralisée ou cloud"]
        },
        controller: {
          title: "WiFi Contrôleur",
          desc: "Contrôleurs WiFi pour l'orchestration, la politique et la visibilité de bout en bout.",
          f: ["Pilotage centralisé des AP", "Politiques et QoS unifiées", "Analyse et dépannage avancés", "Haute disponibilité & redondance"]
        }
      },
      cta: {
        title: "Concevons ensemble votre coeur de réseau",
        subtitle: "Nos experts vous accompagnent dans la conception et l'implémentation d'un backbone campus sécurisé, performant et automatisé.",
        btnExpert: "Consulter nos experts",
        btnCatalog: "Télécharger notre catalogue"
      }
    },
    wifi: {
      seo: { title: "Switch Cisco Catalyst Tunisie | Réseau LAN Campus | S2i", description: "Découvrez la gamme Cisco Catalyst 9000 et Meraki. Solutions de switching intelligentes et sécurisées pour réseaux d'entreprise en Tunisie." },
      hero: {
        badge: "Solutions WiFi Cisco Meraki",
        title: "Points d'Accès<br />WiFi Enterprise",
        subtitle: "Découvrez notre gamme complète de points d'accès WiFi Cisco Meraki, du WiFi 6 au WiFi 7, pour tous vos environnements professionnels.",
        btnExplore: "Explorer les solutions",
        btnGuide: "Guide Meraki",
        cardTitle: "WiFi Enterprise Cloud",
        cardSub: "Solutions WiFi gérées dans le cloud pour une simplicité maximale"
      },
      sidebar: {
        search: "Recherche",
        searchPlaceholder: "Rechercher un point d'accès...",
        category: "Catégorie",
        allCats: "Toutes les catégories",
        view: "Affichage",
        found: "point(s) d'accès trouvé(s)",
        pageOf: "sur",
        noResults: "Aucun point d'accès trouvé",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      categories: {
        wifi7: "WiFi 7 Indoor",
        wifi7D: "Points d'accès WiFi 7 intérieurs ultra-performants",
        wifi6e: "WiFi 6E Indoor",
        wifi6eD: "Points d'accès WiFi 6E intérieurs haute performance",
        wifi6: "WiFi 6 Indoor",
        wifi6D: "Points d'accès WiFi 6 intérieurs pour bureaux et campus",
        outdoor: "Outdoor",
        outdoorD: "Points d'accès extérieurs ruggedisés et étanches"
      },
      card: {
        usage: "Usage clé",
        tech: "Technologies"
      },
      advantages: {
        title: "Solutions WiFi <span style='color: #dc2626'>Intelligentes</span>",
        subtitle: "Transformez votre infrastructure sans fil avec des technologies AI-natives",
        card1Title: "Un Wi-Fi plus intelligent, des espaces plus intelligents",
        card1Desc: "Tirez le meilleur parti de vos investissements sans fil en utilisant les données des capteurs pour fournir des services basés sur le cloud tels que le suivi de localisation en temps réel, la gestion des actifs et la surveillance environnementale avec Cisco Spaces.",
        card2Title: "L'intelligence réseau simplifiée",
        card2Desc: "Transformez votre infrastructure sans fil grâce à une technologie native IA afin d'offrir les meilleures performances pour tous les espaces.",
        card2List: [
          "Remédier aux problèmes à grande échelle grâce à des alertes intelligentes et à une analyse automatisée des causes profondes",
          "Optimiser automatiquement les configurations radio pour atténuer les interférences et améliorer les performances"
        ]
      }
    },
    wifiController: {
      seo: { 
    title: "Contrôleur WiFi Cisco Catalyst Tunisie | WLAN Controller | S2i", 
    description: "Gérez votre infrastructure sans fil avec les contrôleurs Cisco Catalyst 9800. Solutions évolutives et sécurisées pour réseaux d'entreprise en Tunisie." 
  },
      hero: {
        badge: "Contrôleurs WiFi Cisco Catalyst",
        title: "Contrôleurs WiFi<br />Enterprise",
        subtitle: "Découvrez notre gamme complète de contrôleurs WiFi Cisco Catalyst, de 250 à 6000 points d'accès, pour tous vos environnements d'entreprise.",
        btnExplore: "Explorer les contrôleurs",
        btnGuide: "Guide Catalyst",
        heroCardTitle: "Contrôleurs WiFi Catalyst",
        heroCardSub: "Solutions de contrôle centralisé pour infrastructures WiFi d'entreprise"
      },
      sidebar: {
        search: "Recherche",
        placeholder: "Rechercher un contrôleur...",
        category: "Catégorie",
        all: "Toutes les catégories",
        display: "Affichage",
        results: "contrôleur(s) trouvé(s)",
        pageOf: "sur",
        noResults: "Aucun contrôleur trouvé",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      specs: {
        capabilities: "Capacités",
        features: "Caractéristiques",
        noImage: "Image non disponible",
        ap: "APs",
        clients: "clients",
        debit: "débit"
      },
      advantagesSection: {
        title: "Contrôleurs WiFi",
        titleRed: "Intelligent",
        subtitle: "Gérez et optimisez votre infrastructure sans fil avec des contrôleurs nouvelle génération",
        card1: {
          title: "Gestion centralisée et évolutive",
          desc: "Administrez de 250 à 6000 points d'accès depuis une console unique avec des capacités de gestion avancées, hot patching et mises à niveau sans interruption."
        },
        card2: {
          title: "Performance et sécurité avancées",
          desc: "Bénéficiez de performances jusqu'à 100 Gbps avec chiffrement matériel ligne de débit et intégration SD-Access.",
          list: [
            'Chiffrement matériel pour éliminer la dégradation des performances',
            'Télémétrie avancée à la demande pour un monitoring optimal',
            'Déploiements flexibles : campus, cloud ou data center'
          ]
        }
      },
      categories: [
        { id: 'new-generation', name: 'Nouvelle Génération', description: 'Contrôleurs CW9800 dernière génération' },
        { id: 'campus', name: 'Campus', description: 'Solutions pour déploiements campus moyens et grands' },
        { id: 'cloud', name: 'Cloud', description: 'Déploiement dans le cloud privé ou public' },
        { id: 'legacy', name: 'Génération Précédente', description: 'Contrôleurs 9800 (fin de vente annoncée)' }
      ],
      controllerProducts: [
        {
          id: 1,
          name: "Cisco Catalyst CW9800M",
          image: "/images/CiscoWIFIController/cisco-cw9800m.avif",
          category: "new-generation",
          description: "Pour les déploiements de campus de taille moyenne nécessitant des connexions sans fil rapides",
          keyUse: "Campus moyens, Déploiements flexibles, Data centers",
          options: "Jusqu'à 3000 APs, 32000 clients, 50 Gbps, Design 1RU, Port HA 10 Gbps",
          specifications: { accessPoints: "3000", clients: "32000", throughput: "50 Gbps", uplinks: "1/10/25 Gbps", design: "1RU", features: "Port HA 10 Gbps, Chiffrement matériel" }
        },
        {
          id: 2,
          name: "Cisco Catalyst CW9800H1",
          image: "/images/CiscoWIFIController/cisco-cw9800h1.avif",
          category: "new-generation",
          description: "Pour les déploiements de grands campus nécessitant des connexions sans fil rapides",
          keyUse: "Grands campus, Haute performance, Déploiements critiques",
          options: "Jusqu'à 6000 APs, 64000 clients, 100 Gbps, +36% performance vs 9800-80",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "100 Gbps", uplinks: "1/10/25 Gbps", design: "1RU", features: "Port HA 10 Gbps, -40% consommation vs 9800-80" }
        },
        {
          id: 3,
          name: "Cisco Catalyst CW9800H2",
          image: "/images/CiscoWIFIController/cisco-cw9800h2.avif",
          category: "new-generation", 
          description: "Pour les déploiements de grands campus nécessitant des connexions sans fil rapides avec connectivité 40G",
          keyUse: "Grands campus, Connectivité 40G, Haute densité",
          options: "Jusqu'à 6000 APs, 64000 clients, 100 Gbps, Uplinks 1/10/40 Gbps",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "100 Gbps", uplinks: "1/10/40 Gbps", design: "1RU", features: "Port HA 10 Gbps, Chiffrement ligne de débit" }
        },
        {
          id: 4,
          name: "Cisco Catalyst 9800-L",
          image: "/images/CiscoWIFIController/cisco-9800l.avif",
          category: "campus",
          description: "Pour les déploiements de petits campus, avec la flexibilité des liaisons montantes cuivre ou fibre",
          keyUse: "Petits campus, Liaisons flexibles, PME",
          options: "Jus'à 250 APs, 5000 clients, 5 Gbps, Hot patching, ISSU",
          specifications: { accessPoints: "250", clients: "5000", throughput: "5 Gbps", uplinks: "Cuivre/Fibre", design: "Compact", features: "Hot patching, ISSU, Télémétrie avancée" }
        },
        {
          id: 5,
          name: "Cisco Catalyst 9800-CL",
          image: "/images/CiscoWIFIController/cisco-9800cl.avif",
          category: "cloud",
          description: "Pour le déploiement dans un cloud privé ou public",
          keyUse: "Cloud privé/public, Virtualisation, Scalabilité cloud",
          options: "Jus'à 6000 APs, 64000 clients, Options de mise à l'échelle multiples",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "Variable", uplinks: "Virtualisé", design: "Cloud", features: "Hot patching, ISSU, SD-Access, Télémétrie" }
        },
        {
          id: 6,
          name: "Cisco Catalyst 9800-40",
          image: "/images/CiscoWIFIController/cisco-9800-40.avif",
          category: "legacy",
          description: "Pour les déploiements de campus de taille moyenne (fin de vente annoncée)",
          keyUse: "Campus moyens, Solutions existantes, Migration prévue",
          options: "Jusqu'à 2000 APs, 32000 clients, 40 Gbps, Hot patching, ISSU",
          specifications: { accessPoints: "2000", clients: "32000", throughput: "40 Gbps", uplinks: "Standard", design: "Legacy", features: "Hot patching, ISSU, SD-Access, EOS annoncé" }
        },
        {
          id: 7,
          name: "Cisco Catalyst 9800-80",
          image: "/images/CiscoWIFIController/cisco-9800-80.webp",
          category: "legacy",
          description: "Pour les grands campus et déploiements de fournisseurs de services (fin de vente annoncée)",
          keyUse: "Grands campus, Fournisseurs de services, Solutions legacy",
          options: "Jusqu'à 6000 APs, 64000 clients, 80 Gbps, Châssis modulaire",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "80 Gbps", uplinks: "Modulaire", design: "Châssis", features: "Hot patching, ISSU, Télémétrie, EOS annoncé" }
        }
      ]
    },
    analyse: {
      seo: { title: "Audit & Diagnostic Infrastructure IT Tunisie | Conseil S2i", description: "Évaluation complète de votre Data Center, sécurité et réseau. S2i réalise votre audit IT pour optimiser vos performances en Tunisie." },
      hero: {
        title: "Analyse & Conseil ",
        subtitle: "Une évaluation de votre infrastructure informatique, fiable et efficace",
        cta: "Prenez un rendez-vous"
      },
      intro: {
        title: "S2i vous accompagne dans l'audit complet de votre infrastructure",
        p1: "S2i vous accompagne et vous propose un audit complet de l'infrastructure informatique de votre entreprise; un état des lieux qui a le mérite de rendre votre vision plus claire et de vous inscrire dans une démarche pragmatique.",
        p2: "Votre système d'information est le moteur de votre entreprise; notre équipe d'experts IT en procède à l'analyse complète et détaillée, et détermine ainsi les points positifs et les facteurs à risque de votre infrastructure informatique.",
        p3: "Tout en convergeant vers votre objectif professionnel, le cahier des charges livré vous permet d'évaluer au mieux les performances de votre infrastructure et de déterminer les leviers d'amélioration, en accord avec les dernières tendances technologiques."
      },
      mainServices: [
        { title: "Diagnostic de l'Existant", description: "Analyse complète et détaillée de votre infrastructure informatique actuelle" },
        { title: "Conseil & Stratégie", description: "Recommandations expertes pour optimiser votre système d'information" }
      ],
      approach: {
        title: "Découvrez notre approche",
        subtitle: "Une méthodologie éprouvée pour un audit complet de votre infrastructure",
        steps: [
          { title: "Prise de rendez-vous", description: "Planification de l'audit avec nos experts IT certifiés" },
          { title: "Analyse détaillée", description: "Évaluation complète de votre infrastructure informatique" },
          { title: "Identification des risques", description: "Détermination des points positifs et facteurs à risque" },
          { title: "Cahier des charges", description: "Livraison d'un rapport détaillé avec recommandations" }
        ]
      },
      evaluations: {
        title: "Nos Domaines d'Évaluation",
        items: [
          {
            title: "Évaluation du Data Center",
            description: "Face à un besoin permanent d'améliorer la performance de votre infrastructure IT, qui subit plusieurs extensions à un rythme assez élevé et de vos Data Centers qui connaissent une prolifération de données dupliquées, augmentant ainsi la complexité de leur gestion, l'évaluation de vos Data Centres représente un atout essentiel pour vous aider à acquérir un avantage concurrentiel et réduire vos coûts d'exploitation.",
            features: ["Évaluation de l'infrastructure physique", "Analyse de la performance des serveurs", "Optimisation de la gestion des données", "Planification des extensions futures", "Maîtrise des plans de Backup"]
          },
          {
            title: "Évaluation du Système de Sécurité",
            description: "Les services de S2i d'analyse et diagnostic de l'infrastructure, orientés vers les dispositifs de sécurité de votre entreprise, sont un mécanisme essentiel et nécessaire pour vous permettre d'identifier les éventuelles failles dans votre infrastructure de sécurité et vous fournir un ensemble d'actions prioritaires pour les corriger, afin de garantir et renforcer la sécurité de l'ensemble de votre architecture IT.",
            features: ["Identification des failles de sécurité", "Audit des dispositifs de protection", "Actions prioritaires de correction", "Renforcement de l'architecture IT", "Garantie de la sécurité globale"]
          },
          {
            title: "Évaluation des Réseaux",
            description: "La protection du système de production et la garantie de la haute disponibilité du réseau est un challenge permanent des responsables informatiques. Dans ce domaine, nos experts ont pour mission l'évaluation des performances des périphériques réseau et l'examen des caractéristiques de l'infrastructure réseau reliant les applications de votre entreprise entre elles ainsi qu'avec vos centres de données consolidés.",
            features: ["Évaluation des performances réseau", "Examen de l'infrastructure réseau", "Analyse de la haute disponibilité", "Optimisation des connexions", "Services de backup optimaux"]
          }
        ]
      },
      deliverables: {
        title: "Nos Livrables de l'Audit de votre Infrastructure",
        subtitle: "Un rapport complet et des recommandations concrètes pour optimiser votre infrastructure",
        items: [
          { title: "Analyse de l'infrastructure existante", description: "Une analyse de l'infrastructure et de la capacité informatique existante" },
          { title: "Diagnostic des risques réseau", description: "Un diagnostic complet des risques au niveau de l'infrastructure réseau" },
          { title: "Diagnostic sécurité système", description: "Un diagnostic relatif à la sécurité système" },
          { title: "Repérage des SPOF", description: "Un repérage d'éventuels Points de Défaillance Unique (SPOF)" },
          { title: "Diagnostic stockage", description: "Un diagnostic sur la capacité de stockage système" },
          { title: "Documentation architecture", description: "Une documentation détaillée de l'architecture" },
          { title: "Plan d'actions urgentes", description: "Un plan des actions urgentes" },
          { title: "Stratégie d'optimisation", description: "Une stratégie d'optimisation de l'infrastructure" }
        ]
      },
      conseil: {
        title: "Services de Conseil S2i",
        subtitle: "Nos experts vous accompagnent dans la définition de votre stratégie IT et l'optimisation de vos infrastructures",
        strat: {
          title: "Conseil Stratégique IT",
          description: "Définition de votre feuille de route technologique alignée sur vos objectifs business. Nos consultants vous aident à prendre les bonnes décisions pour votre transformation digitale.",
          list: ["Élaboration de la stratégie IT", "Alignement Business/IT", "Roadmap technologique", "Analyse ROI des projets", "Gouvernance des données"]
        },
        tech: {
          title: "Conseil Technique & Architecture",
          description: "Conception d'architectures robustes et évolutives. Nos architectes IT vous guident dans les choix technologiques pour optimiser performances et sécurité.",
          list: ["Architecture système & réseau", "Choix des technologies", "Optimisation des performances", "Sécurité & conformité", "Migration & modernisation"]
        },
        process: {
          title: "Notre Processus de Conseil",
          steps: [
            { title: "Analyse des Besoins", description: "Compréhension approfondie de vos enjeux business et techniques" },
            { title: "Étude & Préconisations", description: "Élaboration de recommandations personnalisées et chiffrées" },
            { title: "Plan d'Action", description: "Définition des étapes de mise en œuvre avec planning détaillé" },
            { title: "Accompagnement", description: "Support continu pendant la phase de déploiement" }
          ]
        },
        advantages: {
          title: "Pourquoi choisir S2i pour vos conseils IT ?",
          btn: "Consulter nos experts",
          items: [
            { title: "37+ ans d'expertise", description: "Une expérience reconnue dans tous les domaines IT" },
            { title: "Équipe certifiée", description: "Des consultants experts certifiés sur les dernières technologies" },
            { title: "Approche personnalisée", description: "Des solutions sur-mesure adaptées à vos besoins spécifiques" },
            { title: "Innovation continue", description: "Veille technologique et intégration des dernières innovations" }
          ]
        }
      }
    },
    deploiementSupport: {
      seo: { title: "Support Technique & Infogérance Tunisie | Maintenance IT | S2i", description: "Support technique 24/7 et assistance pour votre infrastructure. Experts certifiés pour le déploiement et la maintenance de vos systèmes en Tunisie." },
      banner: {
        title: "Déploiement & <span>Support</span>",
        subtitle: "Solutions complètes de déploiement IT et support technique professionnel",
        cta: "Démarrer un projet"
      },
      deploiement: {
        badge: "Déploiement",
        title: "Solutions de <span>Déploiement</span> IT",
        description: "Nous gérons l'intégralité de vos projets de déploiement IT, de la planification à la mise en production, avec l'expertise Dell Technologies",
        services: [
          { title: "Infrastructure Serveur", desc: "Déploiement et configuration de serveurs physiques et virtuels Dell Technologies", features: ["Installation serveurs Dell PowerEdge", "Configuration RAID et stockage", "Virtualisation VMware/Hyper-V", "Clustering et haute disponibilité"] },
          { title: "Réseau & Connectivité", desc: "Mise en place d'infrastructures réseau robustes et sécurisées", features: ["Déploiement switches Dell Networking", "Configuration VLAN et routage", "Points d'accès WiFi professionnels", "Sécurisation réseau et firewall"] },
          { title: "Stockage & Sauvegarde", desc: "Solutions de stockage et stratégies de sauvegarde complètes", features: ["Baies de stockage Dell EMC", "Solutions de backup automatisées", "Réplication et disaster recovery", "Archivage et conformité"] },
          { title: "Sécurité IT", desc: "Déploiement de solutions de cybersécurité avancées", features: ["Firewalls nouvelle génération", "Solutions antivirus et anti-malware", "Monitoring de sécurité 24/7", "Authentification multi-facteurs"] }
        ],
        processTitle: "Notre Processus de Déploiement",
        processSub: "Une méthodologie éprouvée pour garantir le succès de vos projets",
        steps: [
          { step: "01", title: "Analyse & Planning", desc: "Étude détaillée de vos besoins et planification du déploiement", timeline: "1-2 semaines" },
          { step: "02", title: "Préparation & Tests", desc: "Préparation de l'environnement et tests en laboratoire", timeline: "1-3 semaines" },
          { step: "03", title: "Déploiement", desc: "Installation et configuration sur site de votre infrastructure", timeline: "2-5 jours" },
          { step: "04", title: "Tests & Validation", desc: "Tests complets et validation de tous les composants", timeline: "1-2 jours" },
          { step: "05", title: "Formation & Transfert", desc: "Formation de vos équipes et transfert de compétences", timeline: "1-3 jours" },
          { step: "06", title: "Support Continu", desc: "Accompagnement et support technique post-déploiement", timeline: "Permanent" }
        ]
      },
      support: {
        badge: "Support",
        title: "Support Technique <span>Expert</span>",
        description: "Un accompagnement continu pour assurer la performance et la sécurité de votre infrastructure IT",
        services: [
          { title: "Support Technique 24/7", desc: "Assistance technique continue pour garantir la continuité de vos opérations", features: ["Hotline dédiée 24h/24 7j/7", "Tickets de support priorisés", "Intervention sur site si nécessaire", "Résolution rapide des incidents"], stats: { response: "< 30min", availability: "99.9%", satisfaction: "98%" } },
          { title: "Monitoring & Surveillance", desc: "Surveillance proactive de votre infrastructure pour prévenir les pannes", features: ["Monitoring 24/7 de l'infrastructure", "Alertes automatiques en temps réel", "Tableaux de bord personnalisés", "Rapports de performance mensuels"], stats: { uptime: "99.99%", alerts: "< 5min", coverage: "100%" } },
          { title: "Maintenance Préventive", desc: "Maintenance régulière pour optimiser les performances et prolonger la durée de vie", features: ["Maintenance préventive planifiée", "Mises à jour sécurité automatiques", "Optimisation des performances", "Vérifications de santé système"], stats: { frequency: "Mensuelle", reduction: "85%", efficiency: "+30%" } },
          { title: "Formation & Accompagnement", desc: "Formation de vos équipes pour une utilisation optimale de vos systèmes", features: ["Sessions de formation personnalisées", "Documentation technique détaillée", "Transfert de compétences", "Support post-formation"], stats: { satisfaction: "95%", completion: "98%", retention: "92%" } }
        ],
        whyTitle: "Pourquoi choisir notre Support ?",
        whySub: "Les avantages qui font la différence avec S2i",
        advantages: [
          { title: "Expertise Certifiée", desc: "Équipe d'experts certifiés Dell Technologies avec plus de 15 ans d'expérience" },
          { title: "Réactivité Garantie", desc: "Interventions rapides et résolution efficace de vos problématiques IT" },
          { title: "Accompagnement Personnalisé", desc: "Un interlocuteur dédié qui connaît votre environnement et vos enjeux" },
          { title: "Sécurité Renforcée", desc: "Monitoring proactif et mesures de sécurité avancées pour protéger vos données" }
        ]
      },
      cta: {
        title: "Prêt à transformer votre infrastructure IT ?",
        desc: "Nos experts S2i vous accompagnent dans le déploiement et le support de vos solutions IT avec l'excellence Dell Technologies.",
        btn: "Consulter nos experts"
      }
    },
    accessSwitching: {
      seo: { title: "Switch Cisco Catalyst Tunisie | Réseau LAN Campus | S2i", description: "Découvrez la gamme Cisco Catalyst 9000 et Meraki. Solutions de switching intelligentes et sécurisées pour réseaux d'entreprise en Tunisie." },
      hero: {
        badge: "Solutions Réseau Cisco",
        title: "Switches <span style='color: #d90000'>Cisco Campus Access</span>",
        subtitle: "Découvrez notre gamme complète de switches Cisco Catalyst et Meraki pour réseaux campus haute performance et sécurisés",
        btnExplore: "Explorer les switches",
        btnQuote: "Demander un devis"
      },
      categories: {
        title: "Catégories de Switches",
        subtitle: "Trouvez la solution switching adaptée à vos besoins réseau"
      },
      sidebar: {
        title: "Filtres & Recherche",
        search: "Recherche",
        searchPlaceholder: "Nom, fonctionnalité, cas d'usage...",
        category: "Catégorie",
        all: "Tous les switches",
        found: "switch(es) trouvé(s)",
        page: "Page",
        of: "sur",
        view: "Vue",
        grid: "Grille",
        list: "Liste",
        noResults: "Aucun switch trouvé",
        noResultsSub: "Essayez de modifier vos critères de recherche"
      },
      card: {
        new: "Nouveau",
        usage: "Cas d'usage",
        specs: "Spécifications",
        ports: "Ports",
        uplinks: "Uplinks",
        poe: "PoE",
        highlights: "Points forts"
      },
      other: {
        title: "Autres Solutions <span style='color: #d90000'>Réseau</span>",
        subtitle: "Complétez votre infrastructure réseau avec nos solutions Cisco intégrées",
        wifi: {
          title: "Solutions WiFi",
          desc: "Infrastructure WiFi 6/6E haute performance avec Cisco Catalyst et Meraki pour une connectivité sans fil optimale dans tous vos environnements.",
          f: ["WiFi 6E avec bandes 6 GHz jusqu'à 9.6 Gbps", "Gestion cloud centralisée Meraki", "Sécurité WPA3 et segmentation automatique", "Intelligence artificielle pour optimisation"]
        },
        security: {
          title: "Sécurité Réseau",
          desc: "Solutions de sécurité réseau complètes avec pare-feu Cisco ASA, Firepower et technologies de détection des menaces avancées.",
          f: ["Firewall Next-Gen avec inspection profonde", "Réalité de détection et réponse aux menaces", "VPN sécurisé site-to-site et remote access", "Gestion centralisée des politiques de sécurité"]
        },
        wan: {
          title: "Solutions WAN",
          desc: "Optimisation et sécurisation des connexions WAN avec SD-WAN Cisco et technologies de routage avancées pour performances maximales.",
          f: ["SD-WAN intelligent avec optimisation automatique", "Routage multi-path et load balancing", "Chiffrement bout-en-bout des données", "Visibilité et contrôle application par application"]
        }
      },
      cta: {
        title: "Concevons ensemble votre infrastructure réseau de demain",
        subtitle: "Nos experts réseau vous accompagnent dans la conception et l'implémentation de votre infrastructure avec les technologies Cisco les plus avancées.",
        btnExpert: "Consulter nos experts",
        btnCatalog: "Télécharger notre catalogue"
      }
    },
    about: {
      banner: { title: "À propos de <span style='color: #d90000'>S2i</span>", subtitle: "Plus de 37 ans d'expertise au service de votre transformation digitale" },
      timeline: {
        title: "Notre Histoire", sub: "Un parcours d'innovation et d'excellence technologique",
        events: [
          { year: "1989", title: "Création de S2i", desc: "Fondation de la société à Tunis avec une vision d'innovation technologique" },
          { year: "1995", title: "Premier partenariat Dell", desc: "Début de notre collaboration stratégique avec Dell Technologies" },
          { year: "2005", title: "Expansion des services", desc: "Diversification vers la cybersécurité et les solutions réseau" },
          { year: "2015", title: "Transformation digitale", desc: "Accompagnement des entreprises dans leur transformation numérique" },
          { year: "2020", title: "Leadership technologique", desc: "Reconnaissance comme leader des solutions IT en Tunisie" },
          { year: "2024", title: "Innovation continue", desc: "Plus de 3 ans d'expertise au service de nos clients" }
        ]
      },
      expertise: {
        title: "L’expertise S2i au service de <span style='color: #dc2626'>l’innovation</span>",
        sub: "S2i met en œuvre son expertise technique pour relever les défis de l'infrastructure IT en s'appuyant sur plusieurs axes complémentaires",
        cards: [
          { title: "Maîtrise approfondie des métiers IT", desc: "S2i a développé ses compétences dans des domaines clés tels que l'intégration de solutions, l'ingénierie réseaux, l'analyse des réseaux LAN et WAN, la sécurité informatique, le data management, le stockage et la téléphonie IP. Cette diversité technique leur permet de concevoir des infrastructures IT optimisées, fiables et adaptées aux besoins spécifiques des clients." },
          { title: "Offre de solutions viables et pérennes, intégrant les technologies de pointe", desc: "S2i anticipe les évolutions technologiques et propose des environnements IT innovants et performants, incluant notamment des aspects liés à l'intelligence artificielle, à la cybersécurité et à la gestion des infrastructures mixtes (on-premise, cloud). Cette capacité d’innovation continue leur permet de garantir la compétitivité et la résilience des infrastructures déployées." },
          { title: "Accompagnement complet tout au long du cycle de vie des projets", desc: "De la conception à la mise en production, jusqu’au support et à la maintenance, S2i assure un suivi réactif et une assistance technique de haute qualité. Cela garantit la disponibilité et la performance des systèmes, ainsi qu’une adaptation continue aux évolutions du contexte technologique et métier." },
          { title: "Stratégie basée sur l’anticipation et la formation certifiante", desc: "En associant développement technique, formation des équipes et diversification des compétences, S2i prépare ses clients à intégrer et maîtriser les technologies nouvelles, réduisant ainsi les risques liés à la complexité et à la sécurité des infrastructures IT." }
        ]
      },
      solutionsTitle: "Nos Solutions & Services",
      values: {
        title: "Nos Trois Piliers", sub: "Les valeurs fondamentales qui guident notre action",
        items: [
          { title: "Innovation Continue", desc: "Nous intégrons les dernières technologies pour anticiper les besoins futurs de nos clients." },
          { title: "Engagement Client", desc: "Nous nous engageons à offrir une assistance réactive et un accompagnement durable." },
          { title: "Excellence Technique", desc: "Nos équipes certifiées conjuguent expertise et écoute client pour des résultats mesurables." }
        ]
      },
      faq: {
        title: "Questions Fréquemment Posées", sub: "Découvrez comment S2i met son expertise au service de votre réussite",
        data: [
          { q: "Comment S2i met-elle en œuvre son expertise technique pour répondre aux défis de l'infrastructure IT ?", a: "S2i met en œuvre son expertise technique pour relever les défis de l'infrastructure IT en s'appuyant sur plusieurs axes complémentaires :\n\n**•	Maîtrise approfondie des métiers IT  :** S2i a développé ses compétences dans des domaines clés tels que l'intégration de solutions, l'ingénierie réseaux, l'analyse des réseaux LAN et WAN, la sécurité informatique, le data management, le stockage et la téléphonie IP. Cette diversité technique leur permet de concevoir des infrastructures IT optimisées, fiables et adaptées aux besoins spécifiques des clients.\n\n**Offre de solutions viables et pérennes, intégrant les technologies de pointe :** S2i anticipe les évolutions technologiques et propose des environnements IT innovants et performants, incluant notamment des aspects liés à l'intelligence artificielle, à la cybersécurité et à la gestion des infrastructures mixtes (on-premise, cloud). Cette capacité d’innovation continue leur permet de garantir la compétitivité et la résilience des infrastructures déployées.\n\n**Accompagnement complet tout au long du cycle de vie des projets:** De la conception à la mise en production, jusqu’au support et à la maintenance, S2i assure un suivi réactif et une assistance technique de haute qualité. Cela garantit la disponibilité et la performance des systèmes, ainsi qu’une adaptation continue aux évolutions du contexte technologique et métier.\n\n**Stratégie basée sur l’anticipation et la formation certifiante :** En associant développement technique, formation des équipes et diversification des compétences, S2i prépare ses clients à intégrer et maîtriser les technologies nouvelles, réduisant ainsi les risques liés à la complexité et à la sécurité des infrastructures IT.\n\n**En résumé,**S2i déploie son expertise technique selon une approche globale et proactive qui couvre l’ingénierie, l’intégration, la sécurité, l’innovation technologique et un accompagnement personnalisé, permettant de répondre efficacement aux défis complexes et évolutifs des infrastructures IT modernes." },
          { q: "Comment S2i utilise-t-elle son expertise pour sécuriser et intégrer des solutions innovantes dans les réseaux IT ?" , a: "S2i utilise son expertise pour sécuriser et intégrer des solutions innovantes dans les réseaux IT à travers plusieurs axes clés :\n\n**• Intégration sécurisée des infrastructures :** S2i conçoit et déploie des architectures réseaux fiables et sécurisées, incluant la configuration d’équipements réseau (routeurs, commutateurs, pare-feux) avec des protocoles à jour et des politiques de segmentation (VLAN, gestion des droits d’accès) adaptées aux besoins spécifiques des clients. Cela garantit une connectivité optimale tout en limitant les risques d’intrusion et les accès non autorisés.\n\n**• Surveillance proactive et gestion des risques :**S2i met en place des solutions de surveillance continue des réseaux, détectant en temps réel des comportements anormaux, tentatives d’intrusion ou failles potentielles. Cette approche permet d’anticiper et de neutraliser les menaces avant leur impact sur les systèmes.\n\n**• Déploiement de technologies de pointe en cybersécurité :** L’entreprise intègre des dispositifs avancés tels que les systèmes de détection et de prévention d’intrusion (IDS/IPS), les solutions SIEM pour l’analyse des événements de sécurité, ainsi que des dispositifs de gestion des endpoints afin de protéger les terminaux contre les malwares et accès non autorisés.\n\n**• Approche d’innovation continue ** S2i anticipe les évolutions technologiques en intégrant des solutions innovantes comme l’intelligence artificielle appliquée à la cybersécurité, et en développant des systèmes personnalisés permettant d’adapter les réseaux aux enjeux modernes (ex. IA générative, digital signage).\n\n**• Accompagnement personnalisé et formation  :**En plus de l’intégration technique, S2i accompagne ses clients tout au long du cycle de vie des projets avec une approche sur mesure incluant une gestion rigoureuse, des ateliers de développement spécifiques et la formation certifiante des équipes client pour assurer une maîtrise continue des solutions intégrées.\n\n**En résumé, S2i combine une expertise complète en ingénierie réseau, sécurité informatique, innovation technologique et accompagnement client pour sécuriser et intégrer des solutions performantes adaptées à l’écosystème IT de chaque entreprise, permettant ainsi de répondre efficacement aux défis actuels des infrastructures informatiques."},
          { q: "Quelles stratégies S2i emploie-t-elle pour assurer la sécurité des infrastructures numériques ?",  a: "S2i emploie plusieurs stratégies clés pour assurer la sécurité des infrastructures numériques, basées sur une expertise technique approfondie, une approche rigoureuse et une intégration de technologies avancées :\n\n**• Conception et déploiement d’architectures réseaux sécurisées :**S2i met en place des infrastructures IT robustes en configurant des équipements réseau (routeurs, commutateurs, pare-feux) avec des protocoles à jour et des politiques de segmentation comme les VLAN, assurant ainsi un cloisonnement des réseaux et la gestion fine des accès pour limiter les risques d’intrusion.\n\n**• Surveillance proactive et gestion des risques : :** L’entreprise intègre des outils de surveillance continue, tel que les systèmes de détection et prévention d’intrusion (IDS/IPS) et des plateformes SIEM (Security Information and Event Management) qui analysent en temps réel les événements de sécurité pour détecter et anticiper les menaces.\n\n**• Adoption de technologies avancées de cybersécurité :** : S2i déploie des solutions incluant la gestion des endpoints, l’authentification forte, la cryptographie, et intègre des innovations comme l’intelligence artificielle appliquée à la cybersécurité, ce qui permet d’adapter les systèmes aux menaces modernes et complexes.\n\n**• Approche basée sur l’analyse et la maîtrise des risques ** L’entreprise réalise une cartographie précise des risques liés aux infrastructures numériques, identifie les menaces spécifiques et adapte sa politique de sécurité en conséquence. Cela inclut la mise en œuvre d’un plan d’assurance sécurité avec des procédures de tests rigoureux (tests d’intrusion, tests de reprise, audits).\n\n**• Accompagnement personnalisé et formation ** Au-delà de la technique, S2i accompagne ses clients sur toute la durée du projet en proposant une gestion rigoureuse, des ateliers dédiés, et la formation certifiante des équipes afin de garantir une maîtrise continue des solutions sécurisées.\n\n**• Respect des normes et bonnes pratiques en sécurité ** Dans sa démarche, S2i se réfère aux standards de sécurité reconnus comme la norme ISO/CEI 27001 et aux meilleures pratiques recommandées dans le domaine de la sécurité des systèmes d’information, assurant un cadre fiable et conforme pour la protection des données et des accès.\n\n**En synthèse, S2i sécurise les infrastructures numériques par une stratégie complète alliant ingénierie réseau sécurisée, technologies avancées, analyse proactive des risques, et accompagnement renforcé, garantissant ainsi la confidentialité, l’intégrité, la disponibilité et l’authenticité des systèmes informatiques."  },
          { q: "Comment S2i utilise-t-elle des solutions technologiques avancées pour protéger ses clients ?", a: "S2i utilise des solutions technologiques avancées pour protéger ses clients en combinant plusieurs approches clés :\n\n**• Intégration de technologies de cybersécurité avancées :** S2i déploie des dispositifs tels que les systèmes de détection et prévention d’intrusion (IDS/IPS), des solutions SIEM (Security Information and Event Management) pour analyser en temps réel les événements de sécurité, ainsi que des dispositifs de gestion des endpoints pour protéger les terminaux contre les malwares et accès non autorisés.\n\n**• Surveillance proactive et gestion des menaces :** L'entreprise met en place une surveillance continue des infrastructures, détectant les comportements anormaux ou tentatives d’intrusion, permettant d’anticiper et neutraliser les menaces avant qu’elles n’affectent les systèmes.\n\n**• Intégration d’innovations comme l’intelligence artificielle :** S2i intègre l’IA appliquée à la cybersécurité, notamment l’IA générative, pour renforcer la détection des fraudes, identifier les schémas de menaces complexes et améliorer la réponse aux incidents avec une précision accrue.\n\n**• Approche personnalisée et formation continue :** Au-delà des outils, S2i accompagne ses clients avec des formations certifiantes et des ateliers spécifiques pour garantir une maîtrise complète des solutions déployées et une adaptation continue aux évolutions technologiques et réglementaires.\n\n**• Respect des normes et collaboration avec des organismes spécialisés :** S2i se conforme aux standards tels que ISO/CEI 27001 et collabore avec des acteurs reconnus pour assurer des audits, des tests d’intrusion, et une gouvernance robuste de la sécurité informatique.\n\nCette stratégie globale, qui allie ingénierie technique, innovation technologique et accompagnement stratégique, permet à S2i de protéger efficacement les infrastructures IT de ses clients contre les cybermenaces actuelles et futures, tout en assurant la continuité et la résilience de leurs systèmes."  },
          { q: "Quel est l’impact de l’expérience de plus de 37 ans de S2i sur la qualité de ses services et sa réputation ?",  a: "L’expérience de plus de 37 ans de la société S2i a un impact significatif sur la qualité de ses services et sa réputation. Cette longue expérience lui a permis de développer un savoir-faire considérable dans les technologies de l’information, s’appuyant sur des compétences techniques solides et une capacité d’innovation constante. Grâce à cette expertise approfondie et éprouvée, S2i offre à ses clients des solutions techniques optimisées, fiables et pérennes, tout en assurant un support et une maintenance réactifs de haute qualité. Cette maîtrise opérationnelle a permis à S2i de se positionner parmi les leaders du marché IT, avec une clientèle diversifiée et internationale, renforçant ainsi sa réputation et sa crédibilité à l’échelle mondiale.\n\nEn parallèle, cette expérience s’accompagne d’une approche stratégique basée sur l’anticipation, l’innovation et la personnalisation, permettant à S2i de proposer des services adaptés à des besoins complexes et diverses industries. La capacité à accompagner les projets de bout en bout, de la conception à l’exploitation, est un autre élément clé qui découle directement de cette solide expérience terrain, assurant la réussite durable des projets IT de ses clients.\n\nEn résumé, plus de trois décennies d’activité confèrent à S2i une réputation solide fondée sur la qualité, la fiabilité et l’innovation, facteurs déterminants pour un acteur IT souhaitant maintenir une compétitivité sur le marché national et international."  },
          { q: "Quel rôle joue l’ancienneté de S2i dans la perception de ses capacités à fournir des services de haute qualité ?",  a: "L’ancienneté de S2i, avec plus de 37 ans d’existence, joue un rôle central dans la perception de ses capacités à fournir des services de haute qualité. En effet, cette longue expérience lui a permis de développer un savoir-faire technique solide, une expertise opérationnelle confirmée, ainsi qu’une capacité d’innovation constante pour anticiper et répondre aux évolutions technologiques. Cette expérience accumulée rassure les clients sur la fiabilité, la pérennité et la performance des solutions proposées.\n\nDe plus, la continuité de service et la qualité du support technique résultent directement de cette ancienneté, renforçant la confiance des clients qui voient en S2i un partenaire stable et réactif. L’ancienneté permet aussi à S2i de construire une réputation solide, fondée sur des références notoires auprès de milliers de clients, aussi bien au niveau national qu’international, dans divers secteurs (administration, finance, télécoms, industrie).\n\nAinsi, l’ancienneté confère une image de maturité, de professionnalisme et de compétence éprouvée, ce qui joue positivement sur la perception des capacités de S2i à fournir des services qui répondent aux exigences de qualité élevées."  },
          { q: "En quoi l'expérience de S2i contribue-t-elle à l'innovation dans ses services ?",  a: "L'expérience de plus de 37 ans de S2i contribue directement à l'innovation dans ses services de plusieurs manières essentielles.\n\nPremièrement, cette longue expérience a permis à S2i de développer un savoir-faire technique solide et d'acquérir une expertise approfondie dans divers métiers de l'IT comme l’intégration de solutions, l’ingénierie réseaux, la sécurité, la gestion des données, le stockage, la téléphonie IP, et plus encore. Cette maîtrise technique est un levier clé pour intégrer et déployer des technologies innovantes, répondant aux besoins évolutifs de ses clients.\n\nDeuxièmement, l’ancienneté de S2i lui a offert un positionnement stratégique unique lui permettant d’anticiper les évolutions du marché et des technologies. Cela se traduit par une capacité continue à proposer des solutions à la pointe, notamment dans des domaines en forte croissance comme l’intelligence artificielle, la cybersécurité, et le digital signage. Cette anticipation est soutenue by une politique d’innovation axée sur la formation certifiante, le développement permanent, and la diversification complémentaire des compétences, assurant ainsi que les services et solutions proposés restent performants et compétitifs à l’échelle internationale.\n\nTroisièmement, l’expérience accumulée facilite une approche d’innovation collaborative et centrée client. S2i travaille en étroite relation avec ses clients pour comprendre leurs problématiques spécifiques et leur fournir des solutions personnalisées, ce qui nourrit l’innovation pratique et utile. Cette approche stratégique soutenue par un accompagnement de bout en bout permet de co-construire des solutions innovantes tout au long du cycle de vie des projets.\n\nEnfin, S2i capitalise également sur des pôles de recherche et développement, notamment pour préparer des services numériques futurs dans des secteurs comme la Smart City, tirant parti des avancées en intelligence artificielle, IoT ou technologies embarquées. Cette capacité à lancer des projets R&D ambitieux est rendue possible par l’expertise et l’expérience acquises au fil des décennies, contribuant à l’innovation continue au sein de la société." },
          { q: "Comment la relation avec ses partenaires renforce-t-elle l'innovation chez S2i ?",  a: "L’expertise de S2i favorise la création de solutions innovantes par plusieurs mécanismes clés.\n\nD’abord, son expertise technique solide, acquise sur plus de 37 ans, permet une maîtrise approfondie des technologies IT, ce qui constitue un socle indispensable pour intégrer des innovations technologiques adaptées et performantes. Cette compétence couvre un large éventail : intégration de solutions, ingénierie réseaux, cybersécurité, gestion des données, téléphonie IP, intelligence artificielle, entre autres. Cette base technique avancée est essentielle pour développer des solutions innovantes répondant aux besoins spécifiques des clients et des marchés.\n\nEnsuite, S2i mise sur une approche stratégique d’anticipation des évolutions technologiques et des tendances du marché. Sa longue expérience lui permet de rester à la pointe, en intégrant les dernières technologies telles que l’IA générative, le digital signage, ou les systèmes intelligents, ce qui crée un cadre propice à l’innovation constante. Cette veille technologique continue est soutenue par une politique de formation certifiante, de diversification des compétences, et de développement permanent, garantissant ainsi l’adaptabilité et la compétitivité des solutions proposées.\n\nPar ailleurs, l’expertise de S2i favorise une innovation pratique et centrée utilisateur grâce à un accompagnement personnalisé et collaboratif. En travaillant étroitement avec ses clients, la société comprend en profondeur leurs problématiques et adapte ses solutions, ce qui stimule la créativité appliquée et la co-construction de nouvelles offres technologiques réellement utiles et innovantes dans leur contexte d’usage.\n\nEnfin, S2i investit dans la recherche et le développement (R&D) à travers des pôles dédiés et des projets ambitieux liés à des enjeux futurs comme la Smart City, l’Internet des objets (IoT) et l’intelligence artificielle avancée. Cette capacité à générer et structurer des projets R&D est un effet direct de son expertise longue et consolidée, renforçant ainsi son rôle dans l’émergence d’innovations de rupture.\n\nEn résumé, l’expertise de S2i favorise la création de solutions innovantes par sa maîtrise technologique pointue, son anticipation stratégique des évolutions, son approche collaborative personnalisée, et son investissement dans la recherche avancée, ce qui lui permet d’apporter des innovations à la fois pertinentes, performantes et durables." }
        ]
      }
    }
  },
  en: {

   newsPage: {
  hero: {
    tag: "News & Insights",
    title: "S2i <span>Partner</span> Portal",
    subtitle: "Explore the latest technological innovations from our global partners."
  },
  readMore: "More Details",
  filters: {
    all: "All",
    dell: "Dell Technologies",
    kyocera: "Kyocera",
    pny: "PNY",
    vembu: "Vembu",
    infortrend: "Infortrend"
  },
  items: [
    {   
  id: 1,
  sortDate: "2026-05",
  brand: "dell",
  category: "Infrastructure",
  date: "May 2026",
  title: "Dell PowerEdge 18G: The Quantum-Ready Era",
  desc: "Introduction of the 18th generation of Dell PowerEdge servers. A breakthrough architecture designed for post-quantum cybersecurity and 40% more energy efficiency.",
  image: "/images/dell_poweredge.png",
  url: "https://www.dell.com/fr-fr/shop/scc/sc/servers"
},
{
  id: 2,
  sortDate: "2026-04",
  brand: "dell",
  category: "AI Cloud",
  date: "April 2026",
  title: "Sovereign AI in Tunisia with Dell APEX",
  desc: "Deploy your private AI models securely. S2i and Dell launch 'Sovereign AI' solutions to ensure your strategic data never leaves your infrastructure.",
  image: "/images/apex.png",
  url: "https://www.dell.com/en-us/dt/apex/index.htm"
},


   {
  id: 3,
  sortDate: "2026-03",
  brand: "vembu",
  category: "Security & Backup",
  date: "March 2026",
  title: "Vembu BDRSuite v9.0: Autonomous Recovery",
  desc: "S2i introduces BDRSuite v9.0. Featuring built-in AI, the system detects data anomalies in real-time and automates recovery with zero-touch management.",
  image: "/images/vembu_dis.jpg",
  url: "https://www.bdrsuite.com/bdrsuite-v7-0-general-availability/" 
},

     {
  id: 4,
  sortDate: "2026-02",
  brand: "infortrend",
  category: "Unified Storage",
  date: "February 2026",
  title: "Infortrend EonStor GS Gen5: Multi-Cloud Storage",
  desc: "Introduction of the 5th generation GS arrays. A unified architecture supporting up to 100 PB, featuring NVMe-over-Fabrics and ultra-fast cloud synchronization for your AI workloads.",
  image: "/images/infor.jpg",
  url: "https://www.infortrend.com/global/products/gs"
},

   {
  id: 5,
  sortDate: "2026-05",
  brand: "pny",
  category: "Pro Graphics",
  date: "May 2026",
  title: "PNY Launches Upgrade Program for NVIDIA RTX PRO Blackwell GPUs",
  desc: " Upgrade your workstations with Blackwell architecture, delivering 3x faster AI and rendering performance than previous generations.",
  image: "/images/pny1.jpg",
  url: "https://news.pny.eu/2026/04/pny-launches-its-upgrade-program-for-nvidia-rtx-pro-blackwell-gpus/"
},
{
  id: 6,
  sortDate: "2025-01",
  brand: "pny",
  category: "Gaming & Creation",
  date: "January 2025",
  title: "PNY Launches the Game-Changing GeForce RTX 50 Series",
  desc: "The revolution is here. PNY's new GeForce RTX 50 series redefines what's possible with next-gen real-time Ray Tracing and unprecedented AI power for content creators.",
  image: "/images/pny2.jpg",
  url: "https://news.pny.eu/2025/01/pny-launches-the-game-changing-geforce-rtx-50-series/"
},

{
  id: 7,
  sortDate: "2026-01", 
  brand: "kyocera",
  category: "Innovation & IoT",
  date: "January 2026",
  title: "Kyocera Drives Mobility Forward with AI & IoT at CES 2026",
  desc: "Exhibiting at CES 2026 in Las Vegas, Kyocera showcases cutting-edge AI, IoT, and smart sensor solutions. Explore how these advanced technologies are reshaping the future of mobility and telecommunications.",
  image: "/images/kyo.jpg",
  // Global English Link
  url: "https://global.kyocera.com/newsroom/news/2026/001143.html"
},

{
  id: 8,
  sortDate: "2026-06",
  brand: "pny",
  category: "Pro Graphics",
  date: "June 2026",
  title: "PNY Launches Dual-Slot Slim Models for GeForce RTX 50 Series",
  desc: "Three new GeForce RTX 50 Slim cards (RTX 5080, 5070 Ti and 5070) in an ultra-compact dual-slot design, engineered to deliver the full power of NVIDIA's Blackwell architecture in space-constrained builds.",
  image: "/images/pny8.jpg", 
  url: "https://www.pny.com/company/press-center/pny-press-releases"
},
{
  id: 9,
  sortDate: "2026-07",
  brand: "dell",
  category: "Storage & Data",
  date: "July 2026",
  title: "Dell PowerStore Elite: Globally Available",
  desc: "Unveiled at Dell Technologies World, the new PowerStore generation (1500, 5500 and 9500) is now shipping: up to 5.8 PB effective capacity in 3U, a 6:1 data reduction guarantee and non-disruptive upgrades.",
  image: "/images/dell9.png", 
  url: "https://www.dell.com/en-us/shop/powerstore/sf/power-store"
},
{
  id: 10,
  sortDate: "2026-08",
  brand: "vembu",
  category: "Security & Backup",
  date: "August 2026",
  title: "BDRSuite v9.2: vSphere 9.1 Support and Hardened Immutable Storage",
  desc: "The on-premises v9.2 release adds VMware vSphere 9.1 support, secondary VM backup copies, enhanced immutable server-proxy storage and Linux proxy integrity checks.",
  image: "/images/vembu_dis.jpg",
  url: "https://www.bdrsuite.com"
},
{
  id: 11,
  sortDate: "2026-09",
  brand: "kyocera",
  category: "Innovation & IoT",
  date: "September 2026",
  title: "Kyocera at Electronica India 2026",
  desc: "From September 16–18 at the Bangalore International Exhibition Centre, Kyocera Asia Pacific showcases its electronic components, semiconductor technologies and next-generation automotive display solutions.",
  image: "/images/kyocera11.png", 
  url: "https://global.kyocera.com/newsroom/news/2026/001198.html"
}

  ]
},

    header: {
      news: "News",
      group: "S2i Group", contact: "Contact", admin: "Admin Space", home: "Home", about: "About", solutions: "Solutions & Products", services: "Services",
      aboutMenu: { history: "Our History", values: "Values", faq: "Our FAQ" },
      categories: { infra: "Data Center Infrastructure", cloud: "Cloud & Security", reseau: "Network", affichage: "Digital Signage", print: "Print Management", analyse: "Analysis & Consulting", impl: "Implementation & Support" }
    },
    footer: {
      desc: "IT Engineering and Communication company specialized in network solutions integration.",
      servicesTitle: "Our Services", contactTitle: "Contact", rights: "All rights reserved.",
      s1: "Diagnostic & Existing Analysis", s2: "Consulting", s3: "Support & Assistance", s4: "Deployment"
    },
    home: {
      seo: {
        title: "S2i Tunisia | IT Infrastructure, Cloud & Cybersecurity Integrator",
        description: "S2i leads your digital transformation in Tunisia. Expert in Dell servers, Cisco networking, Fortinet security, and custom Cloud solutions."
      },
      hero: { tag: "IT Expertise & Artificial Intelligence", title: "Innovate. Integrate. <br/><span>Transform.</span>", subtitle: "S2i guides your infrastructure towards the future.", cta: "Discover our solutions" },
      services: {
        s1: { title: "Consulting & Strategy", desc: "We analyze your needs and offer IT strategies adapted to your goals." },
        s2: { title: "Project Management", desc: "From planning to delivery, we lead your projects with rigor and expertise." },
        s3: { title: "Technical Support", desc: "Reactive and available support to ensure the continuity of your operations." },
        s4: { title: "IT Optimization", desc: "We optimize your infrastructure to reduce costs and improve performance." }
      },
      partners: "Our Strategic <span>Alliances</span>", partners_sub: "We collaborate with the world's best technology providers",
      international_title: "Some of our <span>International</span> References",
      international_sub: "Expertise deployed across the globe",
      realized_in: "International projects:",
      countries: {
        ly: "Libya",
        cg: "Congo Brazzaville",
        dz: "Algeria",
        cz: "Czech Republic",
        ae: "United Arab Emirates", 
        jo: "Jordan" 
      },	
      clients: "They <span>Trust</span> Us", clients_sub: "Industry leaders who have chosen S2i excellence",
      certifications: "Our <span>Certifications</span>", certifications_sub: "Expertise recognized and certified by technological leaders",
      why: { title: "Why choose S2i?", stats: [{ val: 37, lab: "Years of Experience", desc: "Nearly a decade at the service of our clients." }, { val: 100, lab: "Completed Projects", desc: "Solutions delivered with success." }, { val: 400, lab: "Satisfied Clients", desc: "Partners who trust our expertise." }, { val: 50, lab: "Technical Support", desc: "Continuous assistance for our customers." }] },
      contact: { title: "Have a project?", name_ph: "Full name", email_ph: "Professional email", phone_ph: "Phone number", msg_ph: "Describe your project...", send_btn: "Send", sending: "Sending...", success: "Message sent successfully!", error: "Error during sending." }
    },
    contactPage: {
      hero: {
        title: "Contact Us",
        subtitle: "Ready to discuss your project? Our team of experts is here to support you."
      },
      form: {
        title: "Send us a Message",
        labels: {
          name: "Full Name *",
          email: "Email *",
          phone: "Phone Number",
          company: "Company",
          service: "Service of Interest",
          message: "Message *"
        },
        placeholders: {
          name: "e.g., John Doe",
          email: "your@email.com",
          phone: "e.g., +216 20 000 000",
          company: "Company Name",
          message: "Describe your project..."
        },
        serviceOptions: {
          select: "Select a service",
          cyber: "Cybersecurity",
          infra: "Data Center Infrastructure",
          network: "Network & WIFI"
        },
        btn: {
          send: "Send Message",
          sending: "Sending..."
        }
      },
      messages: {
        success: "Congratulations! Your message has been successfully sent to the S2i team.",
        error: "An error occurred. Please check your server connection."
      },
      sidebar: {
        title: "Why S2i?",
        item1: "Certified expert team",
        item2: "Responsive technical support",
        item3: "Over 30 years of experience"
      },
      info: {
        address: "Address",
        city: "Tunis, Tunisia",
        area: "Industrial Zone",
        phone: "Phone",
        phoneHours: "Mon-Fri 8am-5pm",
        emailResponse: "Response within 24h",
        hours: "Opening Hours",
        weekDays: "Mon-Fri: 8am-5pm",
        satHours: "Sat: 8am-12pm"
      }
    },
    servers: {
      seo: { title: "Dell PowerEdge Server Tunisia | Rack, Tower & AI | S2i", description: "Dell Platinum Partner in Tunisia. Complete range of Dell PowerEdge servers for Data Center and virtualization. Expert quote and installation." },
      hero: {
        badge: "Dell Technologies Server Solutions",
        title: "<span>Dell EMC PowerEdge</span> Servers",
        subtitle: "Discover our full range of Dell PowerEdge servers, from tower solutions to hyper-converged infrastructures",
        btnExplore: "Explore Servers",
        btnQuote: "Request a Quote"
      },
      categories: {
        title: "Server Categories",
        subtitle: "Find the server solution tailored to your needs",
        rack: "Data Center Rack Servers",
        tower: "Data Center Tower Servers",
        ai: "AI Servers",
        edge: "Edge Servers"
      },
      sidebar: {
        title: "Filters & Search",
        searchLabel: "Search",
        searchPlaceholder: "Name, processor, use cases...",
        catLabel: "Category",
        allServers: "All Servers",
        socketLabel: "Socket Type",
        allSockets: "All Sockets",
        found: "server(s) found",
        pageOf: "of",
        viewLabel: "View",
        grid: "Grid",
        list: "List",
        notFound: "No servers found",
        notFoundSub: "Try modifying your search criteria",
        search: "SEARCH",
        searchPl: "Search a product...",
        category: "CATEGORY",
        allCats: "All Categories",
        type: "STORAGE TYPE",
        allTypes: "All Types"
      },
      card: {
        badgeNew: "New",
        usage: "USE CASES",
        specs: "SPECIFICATIONS",
        cpu: "Processor",
        ram: "Memory",
        gpu: "GPU",
        points: "KEY HIGHLIGHTS",
        capacity: "CAPACITY",
        processors: "PROCESSORS",
        memory: "Memory",
        network: "Network",
        disks: "Disks"
      },
      others: {
        title: "Other <span>Data Center</span> Solutions",
        subtitle: "Complete your infrastructure with our integrated Dell Technologies solutions",
        hci: { 
            title: "Hyper-Converged Infrastructure", 
            desc: "Simplify your infrastructure with our Dell VxRail HCI solutions that integrate compute, storage, and networking into a single unified platform.",
            f1: "Up to 40% reduction in operational costs", 
            f2: "Simplified deployment in a matter of hours", 
            f3: "Node-based scalability according to your needs", 
            f4: "High availability with VMware vSAN"
        },
        st: { 
            title: "Storage & Backup", 
            desc: "Dell PowerStore and PowerProtect storage solutions for optimal management of your critical data with exceptional performance.",
            f1: "All-Flash performance up to 7M IOPS", 
            f2: "Advanced compression and deduplication", 
            f3: "Integrated ransomware protection", 
            f4: "Automated hybrid cloud backup"
        },
        nt: { 
            title: "Network Infrastructure", 
            desc: "Dell PowerSwitch and Cisco network solutions for high-performance, secure, and scalable connectivity.",
            f1: "10/25/40/100 GbE switching", 
            f2: "SDN and network automation", 
            f3: "Integrated Zero Trust security", 
            f4: "Intelligent centralized management"
        }
      },
      cta: {
        title: "Let's design your future Data Center together",
        subtitle: "Our solution architects support you in the design and implementation of your infrastructure with the most advanced Dell technologies.",
        btnExpert: "Consult our experts",
        btnCatalog: "Download our catalog"
      }
    },
    storage: {
      seo: { title: "Dell Storage Solutions Tunisia | PowerStore & All-Flash | S2i", description: "Optimize your data with Dell PowerStore. High-performance All-Flash storage and ransomware protection for businesses in Tunisia." },
      hero: {
        badge: "Dell Storage Solutions",
        title: "Intelligent Storage<br />Solutions",
        subtitle: "Discover our full range of Dell storage solutions, from high-performance all-flash to scale-out systems for AI.",
        btnExplore: "Explore solutions",
        btnGuide: "Selection guide",
        certified: "Certified Solutions",
        idc: "#1 worldwide in external enterprise storage according to IDC"
      },
      advantages: {
        intel: { name: "Intelligent", desc: "Integrated AI for automatic optimization" },
        efficace: { name: "Efficient", desc: "Guaranteed 5:1 data reduction" },
        cyber: { name: "Cyber-resilient", desc: "99.5% confidence in corruption detection" },
        cloud: { name: "Multicloud", desc: "87% savings vs native cloud storage" }
      },
      sidebar: {
        searchLabel: "Search",
        searchPlaceholder: "Search for a product...",
        catLabel: "Category",
        allCats: "All Categories",
        typeLabel: "Storage Type",
        allTypes: "All Types",
        found: "solution(s) found",
        pageOf: "of",
        viewLabel: "View",
        grid: "Grid",
        list: "List"
      },
      categories: {
        af: "All-Flash Storage", afD: "High-performance all-flash storage solutions",
        un: "Unified Storage", unD: "Unified storage for mixed environments",
        nas: "Scale-out NAS", nasD: "Scalable NAS storage for unstructured data",
        sds: "Software-Defined Storage", sdsD: "Software-defined storage infrastructure",
        bk: "Backup & Protection", bkD: "Data backup and protection solutions"
      },
      card: {
        badgeNew: "New",
        capacity: "Capacity",
        processors: "Processors",
        specs: "Specifications",
        ram: "Memory",
        net: "Network",
        drives: "Drives"
      },
      cta: {
        title: "Need help choosing?",
        subtitle: "Our solution architects support you in selecting and implementing your Dell storage solutions.",
        btnExpert: "Consult our experts",
        btnGuide: "Selection guide"
      }
    },
    switching: {
      seo: { 
    title: "Dell PowerSwitch Solutions Tunisia | Data Center Networking | S2i", 
    description: "Optimize your network with Dell PowerSwitch in Tunisia. Open Networking, Spine-Leaf architecture, and ultra-low latency for Data Centers." 
  },
      hero: {
        badge: "Dell Switching Solutions",
        title: "PowerSwitch<br />Open Networking",
        subtitle: "Discover our full range of PowerSwitch switches for data centers, from top-of-rack to spine-leaf and AI fabric architectures.",
        btnExplore: "Explore switches",
        btnGuide: "Architecture Guide",
        leader: "Open Networking Leader",
        leaderDesc: "Leading provider of disaggregated open networking solutions"
      },
      advantages: {
        open: { name: "Open Networking", desc: "First disaggregated open networking approach" },
        ai: { name: "AI-Ready", desc: "Optimized for AI/ML workloads" },
        latency: { name: "Ultra-low latency", desc: "Sub-microsecond latency for critical applications" },
        scalable: { name: "Scalable", desc: "Highly scalable spine-leaf architecture" }
      },
      categories: {
        campus: "S Series 1GbE", campusD: "1GbE switches for data center management",
        tor: "S Series 10/25+GbE", torD: "High-performance ToR switches",
        spine: "Z Series Core/Aggregation", spineD: "Core/aggregation switches for leaf/spine fabrics"
      },
      sidebar: {
        search: "Search",
        searchPlaceholder: "Search for a switch...",
        category: "Category",
        allCats: "All Categories",
        view: "View",
        grid: "Grid",
        list: "List",
        found: "switch(es) found",
        pageOf: "of"
      },
      card: {
        new: "New",
        usage: "Key usage",
        options: "Options"
      },
      cta: {
        title: "Need help with your network architecture?",
        subtitle: "Our network experts support you in the design and implementation of your PowerSwitch infrastructures.",
        btnExpert: "Consult our experts",
        btnGuide: "Architecture guide"
      }
    },
    hci: {
      seo: { title: "Dell VxRail Hyperconverged Infrastructure Tunisia | S2i", description: "Simplify your IT with Dell VxRail. HCI solutions to modernize your Data Center with VMware in Tunisia. Performance and scalability." },
      hero: { badge: "Dell Technologies HCI Solutions", title: "Dell <span style='color: #d90000'>Hyperconverged</span> Infrastructure", subtitle: "Modernize IT, simplify operations, and reduce risk with our hyperconverged systems for modern and traditional workloads", btnExplore: "Explore solutions", btnQuote: "Request a quote" },
      categories: {
        title: "Dell Technologies HCI Solutions", subtitle: "Choose the hyperconverged solution that fits your needs",
        vxrail: { name: "VxRail", desc: "Integrated systems built with VMware, for VMware" },
        azure: { name: "Dell AX for Azure Local", desc: "Microsoft Premier solution with enhanced automation" },
        vsan: { name: "vSAN Ready Nodes", desc: "HCI infrastructure with PowerEdge servers and VMware vSAN" },
        xc: { name: "XC Series", desc: "Solutions integrating Nutanix software and Dell PowerEdge servers" }
      },
      sidebar: { title: "Filters & Search", search: "Search", searchPl: "Name, use case, feature...", category: "Category", all: "All solutions", results: "solution(s) found", pageOf: "of", view: "View", grid: "Grid", list: "List" },
      card: { new: "New", usage: "Use cases", specs: "Specifications", cpu: "Processor", mem: "Memory", st: "Storage", points: "Key highlights" },
      noResults: { title: "No solutions found", sub: "Try modifying your filters or search", btn: "Reset filters" },
      cta: { title: "Modernize IT, simplify operations and reduce risks", subtitle: "Discover the vast range of Dell Technologies HCI solutions that allow you to choose based on current infrastructure, operating models, and desired IT outcomes.", btnContact: "Contact our experts", btnDoc: "Documentation" },
      products: {
        vxrail_int: { name: "VxRail - Integrated Systems", badge: "Popular", workloads: ["VMware Virtualization", "Streamlined Operations", "Predictable Evolution"], specs: { cpu: "Intel® Xeon® Scalable Processors", mem: "Flexible configuration as needed", st: "Integrated software-defined storage" }, features: ["Built with VMware, for VMware", "Streamlines operations", "Predictable evolution", "Simplified management"] },
        vcf: { name: "VMware Cloud Foundation on VxRail", badge: "Software-Defined Datacenter", workloads: ["Software-defined datacenter", "Hybrid Cloud", "Digital Transition"], specs: { cpu: "Intel® Xeon® Scalable Processors", mem: "High capacity memory", st: "VMware software-defined storage" }, features: ["Accelerates transition to SDDC", "VMware Hybrid Cloud", "Unified infrastructure", "Centralized management"] },
        dynamic: { name: "VxRail Dynamic Nodes", badge: "Flexible", workloads: ["Flexible compute", "Scalable storage", "Variable workloads"], specs: { cpu: "Intel® Xeon® Scalable Processors", mem: "Independent compute evolution", st: "Scalable Dell software-defined storage" }, features: ["Flexible compute and storage evolution", "Independent scaling", "Dell software-defined storage", "Resource optimization"] },
        azure: { name: "Dell AX System for Azure Local", badge: "Microsoft Premier", workloads: ["Azure adaptive cloud", "Automation", "Enhanced integration"], specs: { cpu: "Intel® Xeon® Scalable Processors", mem: "Optimized Azure configuration", st: "Azure Local compatible storage" }, features: ["Microsoft Premier solution", "Enhanced automation", "Optimized integration", "Innovate with boldness", "Optimized Azure adaptive cloud"] },
        vsan: { name: "vSAN Ready Nodes", badge: "Modernization", workloads: ["Datacenter modernization", "HCI Infrastructure", "Accelerated deployment"], specs: { cpu: "Wide range of PowerEdge servers", mem: "Configuration per PowerEdge model", st: "Integrated VMware vSAN™" }, features: ["Combines PowerEdge servers with VMware vSAN™", "Pre-configured and certified solution", "Reduces risks", "Accelerates deployment", "Modernizes the datacenter"] },
        xc: { name: "XC Series Solutions", badge: "Versatile", workloads: ["Versatile infrastructure", "Scalable HCI", "Multi-hypervisor"], specs: { cpu: "Dell PowerEdge servers with Intel Xeon processors", mem: "Configuration per PowerEdge model", st: "Nutanix software-defined storage" }, features: ["Integrates Nutanix software", "Dell PowerEdge servers with Intel Xeon processors", "Versatile and scalable HCI platform", "One of the most versatile on the market"] }
      }
    },
    backup: {
      seo: { title: "Backup & Cyber-resilience Tunisia | Dell Data Domain | S2i", description: "Protect your critical data with Dell PowerProtect Data Domain. Leading backup and disaster recovery solution in Tunisia." },
      hero: {
        badge: "Dell Technologies Backup Solutions",
        title: "Backup & <span style='color: #d90000'>Cyber-resilience</span> Solutions",
        sub: "PowerProtect Data Domain: Market-leading data protection and management, whether on-premises or in a multi-cloud environment. Integrated cyber-resilience for faster recovery.",
        btn1: "Discover Solutions",
        btn2: "Contact Us",
        whyTitle: "Why choose our solutions?",
        whyList: [
          'Integrated cyber-resilience against ransomware',
          'Data reduction up to 65:1',
          'Up to 44% faster restorations',
          'Native multi-cloud protection',
          'Data Invulnerability Architecture (DIA)',
          '24/7 support by our certified experts'
        ]
      },
      titleSection: "<span style='color: #d90000'>Backup</span> Solutions",
      available: "solutions available",
      categories: {
        title: "<span style='color: #d90000'>Solution</span> Categories",
        subtitle: "Complete Dell PowerProtect backup and cyber-resilience solutions",
        "physical-appliance": { name: "Physical Appliances", desc: "High-performance backup solutions on dedicated hardware" },
        "virtual-edition": { name: "Virtual Editions", desc: "Software-defined backup solutions for the Cloud" },
        "all-flash": { name: "All-Flash", desc: "Ultra-fast appliances for critical restorations" },
        "cyber-recovery": { name: "Cyber Resilience", desc: "Protection solutions against cyberattacks and ransomware" }
      },
      sidebar: {
        title: "Filters & Search",
        search: "Search",
        searchPl: "Name, feature, use case...",
        cat: "Category",
        all: "All solutions",
        results: "solution(s) found",
        pageOf: "of",
        view: "View",
        grid: "Grid",
        list: "List"
      },
      card: {
        new: "New",
        cpu: "Processor",
        cap: "Capacity",
        st: "Storage",
        net: "Network",
        highlights: "KEY HIGHLIGHTS"
      },
      cta: {
        title: "Ready to Secure Your Data?",
        sub: "Contact our experts for a personalized consultation on our PowerProtect Data Domain solutions and strengthen your cyber-resilience with market-leading data protection.",
        btn1: "Contact our experts",
        btn2: "Documentation"
      },
      products: {
        dd9910: {
          name: "PowerProtect Data Domain DD9910",
          badge: "High Performance",
          workloads: ['Enterprise backup', 'Long-term archiving', 'Disaster recovery'],
          specs: { cpu: "Intel® Xeon® Scalable Processors", cap: "576 TB - 1.5 PB usable", st: "Up to 97.5 PB with Cloud Tier", net: "Up to 130 TB/hour throughput" },
          features: ['Throughput up to 130 TB/hour', 'Capacity up to 97.5 PB', 'Data reduction up to 65:1', 'Integrated cyber-resilience', 'Data Invulnerability Architecture (DIA)']
        },
        dd9410: {
          name: "PowerProtect Data Domain DD9410",
          badge: "Performance",
          workloads: ['Mid-range backup', 'Multi-cloud protection', 'Consolidation'],
          specs: { cpu: "Intel® Xeon® Scalable Processors", cap: "192 TB - 768 TB usable", st: "Up to 49.9 PB with Cloud Tier", net: "Up to 75 TB/hour throughput" },
          features: ['Throughput up to 75 TB/hour', 'Capacity up to 49.9 PB', 'Optimal efficiency with deduplication', 'Native multi-cloud protection', 'Flexible evolution']
        },
        dd6410: {
          name: "PowerProtect Data Domain DD6410",
          badge: "Entry Level",
          workloads: ['SMB/Mid-size', 'Remote sites', 'Branch office backup'],
          specs: { cpu: "Intel® Xeon® Processors", cap: "12 TB - 256 TB usable", st: "Up to 16.6 PB with Cloud Tier", net: "Up to 66.8 TB/hour throughput" },
          features: ['Cost-effective and scalable solution', 'Throughput up to 66.8 TB/hour', 'Ideal for SMBs and remote sites', 'Advanced deduplication', 'Integrated protection']
        },
        flash: {
          name: "All-Flash Ready Node",
          badge: "Ultra-Fast",
          workloads: ['Critical restoration', 'Flash backup', 'Extreme performance'],
          specs: { cpu: "Latest generation Intel® Xeon® Scalable Processors", cap: "220 TB usable", st: "High-performance All-Flash storage", net: "Up to 56.4 TB/hour throughput" },
          features: ['Ultra-fast restorations', 'All-Flash technology', 'Advanced cyber-resilience', 'Energy efficiency', 'Consistent performance', 'Integrated sustainability and security']
        },
        ddve: {
          name: "PowerProtect Data Domain Virtual Edition",
          badge: "Software-Defined",
          workloads: ['Public cloud', 'Virtualization', 'Flexible deployment'],
          specs: { cpu: "Compatible with all hypervisors", cap: "Flexible configuration as needed", st: "Software-defined storage", net: "Cloud and on-premises deployment" },
          features: ['On-premises and Cloud deployment', 'Hardware independent', 'Scaling on demand', 'Data Domain technology', 'Consistent protection everywhere']
        },
        cyber: {
          name: "PowerProtect Cyber Recovery",
          badge: "Cyber Resilience",
          workloads: ['Ransomware protection', 'Cyber recovery', 'Forensic analysis'],
          specs: { cpu: "Secure Air-Gapped architecture", cap: "Isolated cyber vault", st: "Immutable data protection", net: "Full network isolation" },
          features: ['Protection against ransomware', 'Air-gapped cyber vault', 'Suspicious activity detection', 'Automated recovery', 'Integrated forensic analysis', 'Regulatory compliance']
        }
      }
    },
    digitalSignage: {
      hero: {
        badge: "Sharp/NEC Display Solutions",
        title: "Video Walls<br />Large Format Displays",
        subtitle: "Discover our full range of Sharp/NEC screens for digital signage, control centers, and professional applications.",
        btnExplore: "Explore Screens",
        btnGuide: "Technical Guide",
        cardTitle: "Professional Display",
        cardSub: "Large format screen solutions for all your display needs"
      },
      sidebar: {
        search: "Search",
        searchPl: "Search for a screen...",
        category: "Category",
        all: "All categories",
        display: "Display",
        found: "screen(s) found",
        pageOf: "of"
      },
      categories: {
        essential: { name: "Essential Displays", desc: "Essential large format displays for basic applications" },
        midrange: { name: "Midrange Displays", desc: "Midrange displays with advanced features" },
        professional: { name: "Professional Displays", desc: "High-performance professional displays" }
      },
      advantages: {
        quality: "Professional Quality",
        qualityD: "High-resolution screens for professional display",
        format: "Large Format",
        formatD: "Screen sizes from 32\" to 98\" for all needs",
        reliable: "24/7 Operation",
        reliableD: "Designed for continuous and reliable operation",
        features: "Advanced Features",
        featuresD: "Integrated technologies for simplified management"
      },
      card: {
        usage: "Key usage",
        tech: "Technologies",
        noImage: "Image not available",
        noResults: "No screens found",
        noResultsSub: "Try modifying your search criteria"
      },
      products: {
  e869: { desc: "86\" Essential Large Format LCD Display - Ideal for basic digital signage applications", use: "Digital signage, Presentations, Retail", tech: "Android SoC, MediaPlayer, Extended connectivity" },
  e759: { desc: "75\" Essential Large Format LCD Display - Versatile display for commercial environments", use: "Retail, Offices, Reception areas", tech: "Optimized brightness, Multi-connectivity" },
  e659: { desc: "65\" Essential Large Format LCD Display - Compact and efficient solution", use: "Meeting rooms, Presentations, Information display", tech: "Compact format, Flexible installation" },
  m552: { desc: "55\" Message Large Format LCD Display - Midrange with advanced messaging features", use: "Dynamic messaging, Internal communication, Interactive display", tech: "Messaging features, Advanced connectivity" },
  me752: { desc: "75\" Message Essential Large Format LCD Display - Large display with messaging capabilities", use: "Corporate communication, Digital signage, Control centers", tech: "Message Essential technology, Multi-input" },
  me982: { desc: "98\" Message Essential Large Format LCD Display - Ultra-large for critical applications", use: "Control centers, Conference rooms, Public display", tech: "Ultra large format, 4K Resolution, Extended connectivity" },
  me862: { desc: "86\" Message Essential Large Format LCD Display - Large screen with Message Essential tech", use: "Advertising display, Visual communication, Public spaces", tech: "Message Essential, High brightness" },
  p556: { desc: "55\" Professional Large Format LCD Display - High-performance for critical apps", use: "24/7 applications, Professional environments, Control centers", tech: "24/7 Operation, High brightness, Industrial reliability" },
  p656: { desc: "65\" Professional Large Format LCD Display - Professional display with optimal performance", use: "Surveillance, Data centers, Critical applications", tech: "High reliability, Professional brightness, Advanced connectivity" },
  e328: { desc: "32\" Essential Large Format LCD Display - Compact NEC screen for essential apps", use: "Information display, Points of sale, Light applications", tech: "Compact format, Energy efficiency" },
  m651: { desc: "65\" Message Large Format LCD Display - Midrange NEC screen with messaging capabilities", use: "Corporate communication, Informative display, Collaborative spaces", tech: "Integrated messaging, Multiple connectivity" },
  m551: { desc: "55\" Message Large Format LCD Display - NEC display with advanced messaging features", use: "Modern offices, Meeting rooms, Visual communication", tech: "Message technology, Flexible installation" }
}
    },
    digitalSignage2: {
      hero: {
        badge: "Sharp/NEC Digital Signage Solutions",
        title: "Professional<br />Digital Signage",
        subtitle: "Custom digital signage solutions with embedded computing, protective glass and partner network for complete integrations.",
        btnExplore: "Explore solutions",
        btnGuide: "Software Partners",
        cardTitle: "Custom Signage",
        cardSub: "Modular solutions adapted to all your visual communication needs"
      },
      advantages: {
        custom: { name: "Custom Solutions", desc: "Customized and modular digital signage solutions" },
        power: { name: "Integrated Power", desc: "Embedded computing with Raspberry Pi and Android SoC" },
        protection: { name: "Advanced Protection", desc: "Protective glass, mirror, colored frames and housings" },
        partner: { name: "Partner Network", desc: "Large network of solution partners for complete integrations" }
      },
      sidebar: {
        search: "Search",
        searchPl: "Search for a solution...",
        category: "Category",
        all: "All categories",
        display: "Display",
        found: "solution(s) found",
        pageOf: "of"
      },
      categories: {
        essential: "Message Essential",
        brightness: "High Brightness",
        modular: "Modular Computing"
      },
      card: {
        usage: "Key Usage",
        tech: "Technologies",
        noImage: "Image not available",
        noResults: "No solutions found",
        noResultsSub: "Try modifying your search criteria"
      },
      products: {
        me752: "75\" Message Essential Large Format LCD Display - Professional digital signage solution with integrated technologies",
        me982: "98\" Message Essential Large Format LCD Display - Ultra-large format screen for maximum impact signage",
        me862: "86\" Message Essential Large Format LCD Display - Versatile solution for professional digital signage",
        me652: "65\" Message Essential Large Format LCD Display - Standard format for various signage applications",
        me552: "55\" Message Essential Large Format LCD Display - Compact and efficient solution for targeted signage",
        me502: "50\" Message Essential Large Format LCD Display - Medium format ideal for restricted spaces",
        me432: "43\" Message Essential Large Format LCD Display - Entry-level solution for basic signage",
        useRetail: "Retail signage, Advertising display, Corporate communication",
        usePublic: "Shopping malls, Airports, Stations, Public spaces",
        useHospitality: "Retail, Hospitality, Corporate, Reception areas",
        useOffice: "Offices, Retail, Restaurants, Sales spaces",
        usePoint: "Points of sale, Promotional display, Customer information",
        useBoutique: "Shops, Cafes, Offices, Waiting rooms",
        useBasic: "Basic information, Digital menus, Simple display",
        tech_me752: "Android SoC, Integrated MediaPlayer, 700 cd/m² Brightness, Portrait/Landscape orientation",
        tech_me982: "Ultra large format, 4K High resolution, Embedded computing, Extended connectivity",
        tech_me862: "Message Essential technology, High brightness, Modular support",
        tech_me652: "Message Essential, NEC MediaPlayer included, Flexible orientation",
        tech_me552: "Modular computing, Raspberry Pi supported, Protective glass available",
        tech_me502: "Integrated Android SoC, Optimized brightness, Flexible installation",
        tech_me432: "Compact format, Energy efficiency, Integrated MediaPlayer"
      }
    },
    printing: {
      hero: {
        badge: "Kyocera Printing Solutions",
        title: "ECOSYS<br />Printing Solutions",
        subtitle: "Discover our full range of Kyocera printers, multifunction systems and production solutions to optimize your document processes.",
        btnExplore: "Explore solutions",
        btnGuide: "ECOSYS Guide",
        techTitle: "ECOSYS Technology",
        techDesc: "Eco-friendly and cost-effective printing solutions"
      },
      sidebar: {
        search: "Search",
        searchPlaceholder: "Search for a solution...",
        category: "Category",
        all: "All categories",
        display: "Display",
        found: "solution(s) found",
        pageOf: "of",
        noResults: "No solutions found",
        noResultsSub: "Try modifying your search criteria"
      },
      advantages: {
        title: "MDS Solutions <span style='color: #dc2626'>Advantages</span>",
        subtitle: "Discover the practical benefits of Kyocera MDS: cost reduction, environmental impact and enhanced security",
        eco_title: "Economic: Cost transparency and savings of up to 30%",
        eco_desc: "Several ways to reduce your total cost of ownership thanks to MDS.",
        eco_list: [
          "Reduction in the use of consumables like paper and toner",
          "Decrease in energy and service costs",
          "Binding printing policies to avoid unnecessary costs",
          "Easy identification of cost factors through device exchange"
        ],
        opti_title: "Optimization: Employee productivity and motivation",
        opti_desc: "Measurable advantages result from other less cost-oriented benefits.",
        opti_list: [
          "Increase in productivity thanks to optimized workflows",
          "Reduction of downtime and minimization of IT load",
          "Modern output solutions for efficient document management",
          "Optimized device management to save time"
        ],
        service_title: "Hassle-free: Professional, personalized and from a single source",
        service_desc: "With a single point of contact, MDS saves you hassle and labor.",
        service_list: [
          "Complete supply for all printers, all brands",
          "Maintenance and repair for our devices and those from other manufacturers",
          "Remote monitoring system with rapid reaction",
          "Professional and personalized service"
        ],
        secure_title: "Eco-friendly and Secure: Sustainability and Data Protection",
        secure_desc: "Reduction in energy consumption and reinforced protection of documents and data.",
        secure_list: [
          "Improvement of environmental sustainability with ECOSYS technology",
          "Energy efficiency through hardware consolidation",
          "Authorized access to devices and networks for more security",
          "Reinforced controls on printing and protection of client data"
        ]
      }
    },
    cloud: {
      seo: { title: "Cloud Computing & IaaS Tunisia | S2i Hybrid Cloud", description: "Accelerate your transformation with S2i Cloud. Secure hosting, IaaS, BaaS, and DRaaS with local 24/7 support in Tunisia." },
      hero: {
        badge: "Cloud Computing by S2i",
        title: "Accelerate your <span style='color: #dc2626'>Cloud Transformation</span>", 
        subtitle: "Designed for the requirements of Tunisian companies, our cloud solutions cover private, hybrid cloud, and managed services (IaaS, BaaS, DRaaS) with security, performance, and end-to-end local S2i support.",
        btnExplore: "Explore Cloud",
        btnContact: "Contact Us",
        whyTitle: "Why Choose S2i Cloud?",
        whyList: [
          "Architecture tailored to your business",
          "Integrated security and compliance",
          "24/7 local monitoring & support",
          "Cost transparency (FinOps)",
          "Support from strategy to operation"
        ]
      },
      overview: {
        title: "Understanding <span style='color: #dc2626'>Cloud Computing</span>",
        subtitle: "A clear and progressive view of the cloud: concepts, use cases, architecture, governance, and FAQ.",
        tabs: {
          apercu: "Overview",
          architecture: "Architecture",
          faq: "FAQ"
        },
        cardSvc: {
          title: "Service Models",
          list: [
            { t: 'IaaS', d: 'On-demand compute, storage, and networking' },
            { t: 'PaaS', d: 'Platforms to develop and deploy quickly' },
            { t: 'SaaS', d: 'Applications consumed as a service' }
          ]
        },
        cardDep: {
          title: "Deployment Models",
          list: [
            { t: 'Private', d: 'Guaranteed control & performance' },
            { t: 'Public', d: 'Elasticity & advanced services' },
            { t: 'Hybrid/Multicloud', d: 'The best of both worlds' }
          ]
        },
        cardBen: {
          title: "Key Benefits",
          list: [
            "Agility & time-to-market",
            "Resilience & PRA/DRaaS",
            "Integrated network & security",
            "OPEX optimization (FinOps)"
          ]
        },
        archText: "Multi-layered architecture: Access, Services, Data, and Security.",
        faqQ1: "Public, private, or hybrid?",
        faqA1: "The choice depends on your security and agility constraints."
      },
      catalog: {
        badge: "Dynamic Catalog",
        title: "Our Latest <span>Cloud Solutions</span>",
        subtitle: "Recent innovations added by our S2I team",
        new: "New",
        details: "Details"
      },
      others: {
        title: "Other <span style='color: #dc2626'>Data Center</span> Solutions",
        hci: "HCI Solutions",
        hciDesc: "Dell VxRail Hyperconvergence.",
        backup: "Backup",
        backupDesc: "Critical data protection.",
        storage: "Storage",
        storageDesc: "All-Flash performance."
      },
      cta: {
        title: "Ready to move to the Cloud?",
        subtitle: "Talk to our S2i experts to define your strategy.",
        btn: "Contact our experts"
      }
    },
    cybersecurity: {
      hero: {
        badge: "Cybersecurity by S2i",
        title: "Strengthen your <span style='color: #dc2626'>cybersecurity posture</span>",
        subtitle: "Protect your users, applications, and data with a layered approach.",
        btnExplore: "Explore solutions",
        btnContact: "Contact Us"
      },
      intro: {
        title: "Cybersecurity, <span style='color: #dc2626'>a permanent challenge</span>",
        subtitle: "In a hyper-connected world, IT security is no longer an option. S2i provides the expertise needed to anticipate threats."
      },
      solutions: {
        title: "Our <span>Security Solutions</span>",
        subtitle: "Combination of our historical pillars and the latest innovations",
        fw_title: "Firewall (NGFW)",
        fw_desc: "Advanced perimeter protection with application inspection.",
        waf_title: "WAF (FortiWeb)",
        waf_desc: "Specialized protection for web applications and APIs.",
        lb_title: "Load Balancer",
        lb_desc: "Intelligent load balancing and high availability.",
        newBadge: "New Admin"
      },
      cta: {
        title: "Ready to secure your business?",
        btn: "Talk to an expert"
      }
    },
    firewall: {
      seo: { title: "Fortinet FortiGate Firewall Tunisia | Network Security | S2i", description: "Perimeter protection with FortiGate Next-Gen firewalls. Fortinet expert in Tunisia to secure your network against cyber threats." },
      hero: {
        badge: "Fortinet FortiGate Next-Generation Firewall",
        title: "FortiGate <span style='color: #d90000'>Next-Generation</span> Firewall",
        subtitle: "FortiGate firewalls provide unmatched security and 17 times higher performance, with patented ASIC processors and AI-optimized protection for all your hybrid environments.",
        btnExplore: "Discover Solutions",
        btnContact: "Contact Us",
        whyTitle: "Why Choose FortiGate?",
        whyList: [
          '17x higher performance than competition',
          'Patented ASIC processors SP5, NP7, CP9',
          'AI-optimized protection by FortiGuard',
          '99.98% security effectiveness',
          '62% average energy reduction',
          'Unified management via FortiManager'
        ]
      },
      categories: {
        title: "<span style='color: #d90000'>Solution</span> Categories",
        subtitle: "FortiGate firewalls for all your hybrid environments",
        "data-center": { name: "Data Center", desc: "High-performance solutions for data centers and enterprises" },
        "campus-enterprise": { name: "Enterprise Campus", desc: "Protection for enterprise sites and campuses" },
        "branch-office": { name: "Branch Offices", desc: "Security and SD-WAN for remote sites" },
        "cloud-security": { name: "Cloud & Virtualized", desc: "Protection for cloud and virtualized environments" }
      },
      sidebar: {
        title: "Filters & Search",
        search: "Search",
        searchPl: "Name, feature, use cases...",
        cat: "Category",
        all: "All solutions",
        results: "solution(s) found",
        pageOf: "of",
        view: "View",
        grid: "Grid",
        list: "List"
      },
      card: {
        new: "New",
        processor: "Processor",
        performance: "Performance",
        interfaces: "Interfaces",
        network: "Network",
        featuresTitle: "Key Features"
      },
      cta: {
        title: "Ready to Secure Your Network?",
        subtitle: "Contact our experts for a personalized demonstration of FortiGate solutions and discover why more than 50% of global enterprises trust Fortinet for their network security.",
        btn1: "Contact our experts",
        btn2: "Free Demo"
      },
      products: {
        f7121f: {
          name: "FortiGate 7121F",
          badge: "Ultra High Performance",
          workloads: ['Hyperscale Data Center', 'High-performance protection', 'Intensive traffic'],
          specs: { processor: 'SP5 + NP7 security processors', memory: '520 Gbps firewall throughput', storage: '400GE/200GE/100GE interfaces', network: 'High-performance SSL/TLS inspection' },
          features: ['Up to 520 Gbps firewall throughput', 'Dedicated SP5 security processors', 'High-speed 400GE interfaces', 'Hyperscale architecture', 'Advanced SSL/TLS inspection']
        },
        f6500f: {
          name: "FortiGate 6500F",
          badge: "High Performance",
          workloads: ['Enterprise Data Center', 'Advanced protection', 'Security consolidation'],
          specs: { processor: 'NP7 + CP9 processors', memory: '100 Gbps firewall throughput', storage: '100GE/40GE/25GE interfaces', network: 'Integrated SD-WAN functions' },
          features: ['Up to 100 Gbps firewall throughput', 'NP7 network processors', 'Integrated secure SD-WAN', 'Advanced threat protection', 'Modular scalability']
        },
        f4800f: {
          name: "FortiGate 4800F",
          badge: "Performance",
          workloads: ['Enterprise network', 'Multi-layer protection', 'Secure connectivity'],
          specs: { processor: 'NP7 processors', memory: '70 Gbps firewall throughput', storage: '100GE/40GE/10GE interfaces', network: 'Full IPS/UTM protection' },
          features: ['Up to 70 Gbps firewall throughput', 'Full UTM protection', 'Flexible high-speed interfaces', 'FortiManager centralized management', 'Optimal energy efficiency']
        },
        f1800f: {
          name: "FortiGate 1800F",
          badge: "Enterprise",
          workloads: ['Enterprise Campus', 'User protection', 'Application control'],
          specs: { processor: 'NP6 + CP9 processors', memory: '15 Gbps firewall throughput', storage: 'Flexible 10GE/GE interfaces', network: 'Converged SD-WAN and security' },
          features: ['Up to 15 Gbps firewall throughput', 'Advanced user protection', 'Granular application control', 'Secure SD-WAN', 'Decentralized SSL inspection']
        },
        f1000f: {
          name: "FortiGate 1000F",
          badge: "Mid-range",
          workloads: ['Enterprise site', 'Perimeter protection', 'Secure access'],
          specs: { processor: 'NP6 processors', memory: '13 Gbps firewall throughput', storage: '10GE/GE interfaces', network: 'SSL/IPSec VPN' },
          features: ['Up to 13 Gbps firewall throughput', 'Complete perimeter protection', 'High-performance VPN', 'Simplified management', 'Optimal value for money']
        },
        f600f: {
          name: "FortiGate 600F",
          badge: "Branch Offices",
          workloads: ['Medium branches', 'SD-WAN', 'Edge protection'],
          specs: { processor: 'NP6 processors', memory: '10 Gbps firewall throughput', storage: 'GE/SFP+ interfaces', network: 'Integrated SD-WAN' },
          features: ['Integrated secure SD-WAN', 'Full edge protection', 'Simplified centralized management', 'Flexible WAN connectivity', 'Zero-touch provisioning']
        },
        f200f: {
          name: "FortiGate 200F",
          badge: "Compact",
          workloads: ['Small branches', 'SOHO', 'Remote office'],
          specs: { processor: 'Integrated processor', memory: '20 Gbps firewall throughput', storage: 'Integrated GE interfaces', network: 'Optional Wi-Fi 6' },
          features: ['High throughput in compact format', 'Integrated Wi-Fi 6 available', 'Simplified deployment', 'Full UTM protection', 'Reduced TCO']
        },
        fvm: {
          name: "FortiGate VM",
          badge: "Virtualized",
          workloads: ['Public cloud', 'Virtualization', 'Hybrid deployments'],
          specs: { processor: 'Flexible virtual CPUs', memory: 'Resource-based performance', storage: 'Cloud/virtualized storage', network: 'Virtual interfaces' },
          features: ['Multi-cloud deployment', 'Auto-elasticity', 'Same FortiOS as hardware', 'DevOps/API integration', 'Flexible pay-as-you-grow licensing']
        }
      }
    },
    waf: { 
      seo: { title: "Web Application Protection Tunisia | Fortinet FortiWeb | S2i", description: "Secure your apps and APIs with FortiWeb WAF. Protection against OWASP Top 10 and zero-day attacks in Tunisia." },
      hero: {
        badge: "Fortinet FortiWeb Web Application Firewall",
        title: "Next-Generation <span style='color: #d90000'>WAF</span> FortiWeb",
        subtitle: "FortiWeb protects your critical web applications from OWASP Top 10 threats, zero-day attacks, and malicious bots with advanced AI and behavioral detection without false positives.",
        btnExplore: "Discover Solutions",
        btnContact: "Contact Us"
      },
      why: {
        title: "Why choose FortiWeb?",
        list: [
          'Comprehensive OWASP Top 10 protection',
          'Integrated FortiGuard AI',
          'Zero-day detection without false positives',
          'Advanced biometric bot protection',
          'Automatic API discovery and protection',
          'Native Security Fabric integration'
        ]
      },
      categories: {
        title: "WAF <span style='color: #d90000'>Solution Categories</span>",
        subtitle: "Web application protection for all your hybrid environments",
        "appliances-hardware": { name: "Hardware Appliances", desc: "Physical WAF solutions with dedicated processors and SSL acceleration" },
        "virtual-machines": { name: "Virtual Machines", desc: "Virtualized WAF solutions for cloud and hybrid environments" },
        "cloud-services": { name: "Cloud Services", desc: "WAF as a Service for AWS, Azure, GCP, and other public clouds" }
      },
      sidebar: {
        title: "Filters & Search",
        searchLabel: "Search",
        searchPlaceholder: "Name, feature, usage case...",
        catLabel: "Category",
        all: "All solutions",
        found: "solution(s) found",
        pageOf: "of",
        viewLabel: "View",
        grid: "Grid",
        list: "List"
      },
      card: {
        new: "New",
        workloads: "Workloads",
        specs: {
          processor: "Processor",
          performance: "Performance",
          connectivity: "Connectivity",
          network: "Network"
        },
        featuresTitle: "Key Features"
      },
      cta: {
        title: "Ready to Protect Your Applications?",
        subtitle: "Contact our experts for a personalized demonstration of FortiWeb WAF solutions and discover how to protect your critical applications against OWASP Top 10 threats, zero-day attacks, and malicious bots with FortiGuard AI.",
        btnExpert: "Contact our experts",
        btnDemo: "Free Demo"
      }
    },
    loadbalancer: {
      seo: {
    title: "Fortinet FortiADC Load Balancer Tunisia | S2i",
    description: "Ensure 24/7 application availability with FortiADC in Tunisia. Advanced L4-L7 load balancing, GSLB, and SSL offloading solutions for enterprise networks."
  },
      hero: {
        badge: "Fortinet FortiADC Application Delivery Controller",
        title: "Advanced <span style='color: #d90000'>Load Balancer</span> FortiADC",
        subtitle: "FortiADC offers unmatched application acceleration, load balancing and web security with integrated WAF, global balancing and high availability in a single solution.",
        btnExplore: "Discover Solutions",
        btnContact: "Contact Us",
        whyTitle: "Why choose FortiADC?",
        whyList: ['Unmatched application acceleration', 'Native integrated WAF and security', 'Advanced L4-L7 load balancing', 'GSLB for global business continuity', 'Fortinet Security Fabric integration', 'Flexible deployment: physical, VM, cloud']
      },
      categories: {
        title: "<span style='color: #d90000'>ADC Solutions</span> Categories",
        subtitle: "FortiADC Application Delivery Controllers for all your environments",
        hardware: { name: "Hardware Appliances", desc: "High performance physical ADC solutions with hardware acceleration" },
        virtual: { name: "Virtual Machines", desc: "Virtualized ADC solutions for cloud and hybrid environments" },
        gslb: { name: "Global GSLB", desc: "Global DNS load balancing for business continuity" }
      },
      sidebar: {
        title: "Filters & Search",
        search: "Search",
        searchPl: "Name, feature, usage...",
        category: "Category",
        all: "All solutions",
        results: "solution(s) found",
        pageOf: "of",
        view: "View",
        grid: "Grid",
        list: "List"
      },
      products: {
        f120f: { badge: "Entry level", workloads: ['Small apps', 'SMB sites', 'Test environments'], specs: { cpu: 'Multi-core processor', perf: '3 Gbps Throughput', int: '6x GE RJ45', net: 'Hardware SSL offloading' }, features: ['Advanced L4-L7 balancing', 'Hardware SSL acceleration', 'Intelligent health checks', 'Intuitive web interface', 'Basic DDoS protection'] },
        f220f: { badge: "Performance", workloads: ['Medium applications', 'E-commerce', 'Web portals'], specs: { cpu: 'Advanced multi-core processors', perf: '5 Gbps Throughput', int: '4x GE RJ45, 2x GE SFP', net: 'Advanced integrated WAF' }, features: ['High 5 Gbps throughput', 'High performance integrated WAF', 'Advanced session persistence', 'HTTP/HTTPS compression', 'Intelligent LB algorithms'] },
        f300f: { badge: "Optimized", workloads: ['Critical applications', 'High availability', 'High load'], specs: { cpu: 'High performance processors', perf: '8 Gbps Throughput', int: '4x GE RJ45, 4x GE SFP', net: 'Multi-layer security' }, features: ['Optimal 8 Gbps performance', 'Advanced application security', 'Global Server Load Balancing', 'Intelligent app cache', 'Real-time monitoring'] },
        f400f: { badge: "High Performance", workloads: ['Data center', 'Enterprise applications', 'Intensive traffic'], specs: { cpu: 'Optimized multi-core processors', perf: '15 Gbps Throughput', int: '2x 10GE SFP+, 4x GE SFP, 4x GE', net: 'Integrated advanced protection' }, features: ['Very high 15 Gbps performance', 'High speed 10GE interfaces', 'Complete app security', 'Geographic load balancing', 'REST API for automation'] },
        fvm: { badge: "Virtualized", workloads: ['Private cloud', 'Virtualization', 'Hybrid deployments'], specs: { cpu: 'Flexible virtual CPUs', perf: 'Performance by resources', int: 'Scalable virtual storage', net: 'Virtual network interfaces' }, features: ['Multi-hypervisor deployment', 'Auto elasticity', 'Same features as hardware', 'DevOps/API integration', 'Flexible licensing'] },
        fgslb: { badge: "DNS Service", workloads: ['Global applications', 'Disaster Recovery', 'Intelligent CDN'], specs: { cpu: 'Global DNS infrastructure', perf: 'DNS resolution < 5ms', int: 'Geographic redundancy', net: 'Worldwide Anycast DNS' }, features: ['Geographically distributed DNS', 'Multi-site health checks', 'Automatic DR failover', 'Intelligent geolocation', 'Global traffic analytics'] }
      },
      security: {
        title: "<span style='color: #d90000'>Security</span> Solutions",
        subtitle: "Three essential pillars to secure your infrastructure",
        learnMore: "Learn more",
        pillars: {
          fw: { title: "Firewall (NGFW)", desc: "Advanced perimeter protection with application inspection, IPS, SSL control and secure VPN.", features: ['Stateful & application inspection', 'IPS/AV, URL filtering, SSL/TLS', 'Secure VPN & SD-WAN', 'Segmentation & Zero Trust'] },
          waf: { title: "WAF (Web Application Firewall)", desc: "Specialized protection for web applications and APIs against OWASP Top 10 and logical attacks.", features: ['OWASP Top 10 & bots protection', 'API & JSON security', 'Machine learning & signatures', 'CI/CD & DevSecOps integration'] },
          cyber: { title: "Cyber Security", desc: "Comprehensive cybersecurity strategy with Zero Trust approach and multi-layer protection.", features: ['Complete Zero Trust approach', 'Advanced multi-layer protection', '24/7 SOC and monitoring', 'Training and awareness'] }
        }
      },
      cta: {
        title: "Optimize Your Applications",
        subtitle: "Contact our experts to discover how FortiADC can improve the performance, security and availability of your critical applications with an all-in-one solution.",
        btnContact: "Contact our experts",
        btnDemo: "Free FortiADC Demo"
      }
    },
    antispam: {
      hero: {
        badge: "FortiGuard Anti-Spam & Antivirus Protection",
        title: "Advanced <span style='color: #d90000'>AntiVirus & AntiSpam</span> Protection",
        subtitle: "FortiGuard Antivirus & Anti-Spam offer comprehensive protection against malware, ransomware, and email threats using AI/ML technologies and CPRL detection. 99.98% proven real-time effectiveness.",
        btnExplore: "Explore Solutions",
        btnContact: "Contact Us"
      },
      whyBox: {
        title: "Why FortiGuard?",
        features: [
          'AI/ML protection against zero-day & polymorphic threats',
          'CPRL - Advanced detection without signatures',
          '99.98% proven efficiency against spam',
          'Full Security Fabric integration',
          'Automated real-time updates',
          'Multi-platform and endpoint support'
        ]
      },
      tabs: {
        av: "FortiGuard Antivirus",
        as: "FortiGuard Anti-Spam"
      },
      overview: {
        title: "Advanced <span style='color: #d90000'>Protection Solutions</span>",
        subtitle: "Discover our FortiGuard Antivirus and Anti-Spam services integrated into the Security Fabric"
      },
      avContent: {
        mainTitle: "Intelligent Anti-Malware Protection",
        mainDesc: "The FortiGuard Antivirus service uses a complete technology stack including signature detection, behavioral heuristic analysis, and AI/ML-driven analysis to protect against polymorphic and zero-day malware.",
        list: {
          cprl: "CPRL (Content Pattern Recognition Language) - More effective than traditional signatures",
          ia: "Artificial Intelligence - Detection of evasive and AI-powered malware",
          updates: "Real-time updates - Up-to-date protection against the latest threats"
        },
        featTitle: "Key Features",
        featList: [
          "Zero-Day Protection: Coordination with FortiSandbox",
          "Security Fabric: Protection at different stages",
          "Multi-platform: FortiGate, FortiMail, FortiWeb, FortiClient",
          "Extended coverage: IT/OT networks and cloud workloads"
        ],
        cprlTitle: "CPRL Technology",
        cprlList: [
          "Superior efficiency: More accurate than traditional signatures",
          "Broad detection: Identifies malware without signature files",
          "Integrated AI: Combination of CPRL + Machine Learning",
          "Extended protection: Against unknown variants"
        ]
      },
      asContent: {
        mainTitle: "Advanced Multi-Layer Email Protection",
        mainDesc: "FortiGuard Anti-Spam provides a comprehensive, multi-layered approach to detecting and filtering spam. With dual-pass detection technology, it drastically reduces spam volume at the perimeter with 99.98% efficiency.",
        list: {
          dual: "Dual-Pass Detection - Drastic reduction in spam volume",
          perso: "Advanced customization - Policies by domain, group, or user",
          updates: "Fast updates - Push and pull options"
        },
        featTitle: "Intelligent Filtering",
        featList: [
          "Perimeter protection: Against email threats (#1 attack vector)",
          "Granular control: Management of email attacks and infections",
          "Mobile protection: FortiClient for remote devices",
          "Proven efficiency: 99.98% according to Virus Bulletin tests"
        ],
        opsTitle: "Simplified Management",
        opsList: [
          "Set & Forget: Reduction in management and operational costs",
          "Device-based licensing: Reduced entry and maintenance costs",
          "Flexible policies: Adaptation to your organization",
          "Accelerated updates: Security always up to date"
        ]
      },
      fabric: {
        title: "Fortinet Security Fabric Integration",
        desc: "The strength of Fortinet's platform-driven approach allows for coordinated workflows including response, with a globalized network effect across the entire Fortinet installed base.",
        items: {
          ngfw: "Perimeter protection",
          mail: "Email security",
          client: "Endpoint protection",
          sandbox: "Behavioral analysis",
          fabricTitle: "Security Fabric",
          fabricSub: "Coordinated and integrated protection across your entire infrastructure"
        }
      },
      useCases: {
        title: "Main Use Cases",
        subtitle: "Concrete applications of FortiGuard Antivirus & Anti-Spam services",
        list: [
          { title: "IT & OT Networks", desc: "Converged network protection without productivity impact" },
          { title: "Endpoint Protection", desc: "Securing devices and preventing malicious execution" },
          { title: "Cloud Workloads", desc: "Protection of applications and data in the cloud" },
          { title: "Email Security", desc: "Spam filtering and protection against email attacks" },
          { title: "Zero-Day Protection", desc: "Coordination with FortiSandbox against unknown threats" },
          { title: "Multi-User Management", desc: "Customized policies by domain, group, or user" }
        ]
      },
      cta: {
        title: "Strengthen Your Protection",
        desc: "Contact our S2i experts to deploy FortiGuard Antivirus & Anti-Spam and benefit from 99.98% effective protection against malware and spam.",
        btnExpert: "Contact our experts",
        btnDemo: "FortiGuard Demo"
      }
    },
    coreSwitching: {
      seo: { 
    title: "Cisco Catalyst Core & Distribution Switches Tunisia | S2i", 
    description: "Explore Cisco Catalyst 9600 and 9500 solutions for high-performance network cores. Cisco expert in Tunisia for campus and distribution infrastructure." 
  },

      hero: {
        badge: "Cisco Network Core & Distribution",
        title: "Cisco Campus <span style='color: #d90000'>Core & Distribution</span> Switches",
        subtitle: "Catalyst 9600/9500 and Meraki platforms for a high-performance, secure, and automated network core.",
        btnExplore: "Explore switches",
        btnQuote: "Request a quote"
      },
      categoriesTitle: "Switch Categories",
      categoriesSubtitle: "Choose the right platform for your core and distribution layers",
      sidebar: {
        title: "Filters & Search",
        searchLabel: "Search",
        searchPlaceholder: "Name, feature, use case...",
        catLabel: "Category",
        allSwitches: "All switches",
        found: "switch(es) found",
        pageOf: "of",
        viewLabel: "View",
        grid: "Grid",
        list: "List",
        noResults: "No switches found",
        noResultsSub: "Try modifying your search criteria"
      },
      card: {
        new: "New",
        usage: "Use cases",
        specsLabel: "Specifications",
        ports: "Ports",
        uplinks: "Uplinks",
        fabric: "Fabric/Backplane",
        unit: "Unit",
        points: "Highlights"
      },
      otherSolutions: {
        title: "Other <span>Network</span> Solutions",
        subtitle: "Complete your network infrastructure with our integrated Cisco solutions",
        access: {
          title: "Access Switching",
          desc: "High-performance and secure campus access switches (Catalyst 9200/9300, Meraki MS225/MS390).",
          f: ["Wired access for users and WiFi APs", "PoE/PoE+ and intelligent management", "Cisco DNA Automation", "Advanced access security"]
        },
        wifi: {
          title: "WiFi (Access Point)",
          desc: "WiFi 6/6E/7 access points for high performance and reliable campus coverage.",
          f: ["Ultra-high-speed WiFi 6E/7", "Automatic RF optimization", "WPA3 security & segmentation", "Centralized or cloud management"]
        },
        controller: {
          title: "WiFi Controller",
          desc: "WiFi controllers for end-to-end orchestration, policy, and visibility.",
          f: ["Centralized AP management", "Unified policies and QoS", "Advanced analytics and troubleshooting", "High availability & redundancy"]
        }
      },
      cta: {
        title: "Let's design your network core together",
        subtitle: "Our experts assist you in designing and implementing a secure, high-performance, and automated campus backbone.",
        btnExpert: "Consult our experts",
        btnCatalog: "Download our catalog"
      }
    },
    wifi: {
      seo: { title: "Enterprise WiFi Tunisia | Cisco Meraki & WiFi 6/7 | S2i", description: "High-performance WiFi access points for businesses. Cloud-managed Cisco Meraki solutions for optimal connectivity in Tunisia." },
      hero: {
        badge: "Cisco Meraki WiFi Solutions",
        title: "Enterprise WiFi<br />Access Points",
        subtitle: "Discover our full range of Cisco Meraki WiFi access points, from WiFi 6 to WiFi 7, for all your professional environments.",
        btnExplore: "Explore solutions",
        btnGuide: "Meraki Guide",
        cardTitle: "Enterprise Cloud WiFi",
        cardSub: "Cloud-managed WiFi solutions for maximum simplicity"
      },
      sidebar: {
        search: "Search",
        searchPlaceholder: "Search for an access point...",
        category: "Category",
        allCats: "All categories",
        view: "Display",
        found: "access point(s) found",
        pageOf: "of",
        noResults: "No access points found",
        noResultsSub: "Try modifying your search criteria"
      },
      categories: {
        wifi7: "WiFi 7 Indoor",
        wifi7D: "Ultra-high performance indoor WiFi 7 access points",
        wifi6e: "WiFi 6E Indoor",
        wifi6eD: "High performance indoor WiFi 6E access points",
        wifi6: "WiFi 6 Indoor",
        wifi6D: "Indoor WiFi 6 access points for offices and campuses",
        outdoor: "Outdoor",
        outdoorD: "Ruggedized and waterproof outdoor access points"
      },
      card: {
        usage: "Key usage",
        tech: "Technologies"
      },
      advantages: {
        title: "Intelligent <span style='color: #dc2626'>WiFi Solutions</span>",
        subtitle: "Transform your wireless infrastructure with AI-native technologies",
        card1Title: "Smarter Wi-Fi, smarter spaces",
        card1Desc: "Make the most of your wireless investments by using sensor data to provide cloud-based services such as real-time location tracking, asset management, and environmental monitoring with Cisco Spaces.",
        card2Title: "Simplified network intelligence",
        card2Desc: "Transform your wireless infrastructure with AI-native technology to deliver the best performance for all spaces.",
        card2List: [
          "Remediate issues at scale with intelligent alerts and automated root cause analysis",
          "Automatically optimize radio configurations to mitigate interference and improve performance"
        ]
      }
    },
    wifiController: {
      seo: { 
    title: "Cisco Catalyst Wireless Controllers Tunisia | WLAN | S2i", 
    description: "Manage your wireless infrastructure with Cisco Catalyst 9800 controllers. Scalable and secure solutions for enterprise networks in Tunisia." 
  },
      hero: {
        badge: "Cisco Catalyst WiFi Controllers",
        title: "Enterprise WiFi<br />Controllers",
        subtitle: "Discover our full range of Cisco Catalyst WiFi controllers, from 250 to 6000 access points, for all your business environments.",
        btnExplore: "Explore Controllers",
        btnGuide: "Catalyst Guide",
        heroCardTitle: "Catalyst WiFi Controllers",
        heroCardSub: "Centralized control solutions for enterprise WiFi infrastructures"
      },
      sidebar: {
        search: "Search",
        placeholder: "Search for a controller...",
        category: "Category",
        all: "All Categories",
        display: "Display",
        results: "controller(s) found",
        pageOf: "of",
        noResults: "No controllers found",
        noResultsSub: "Try modifying your search criteria"
      },
      specs: {
        capabilities: "Capabilities",
        features: "Key Features",
        noImage: "Image not available",
        ap: "APs",
        clients: "clients",
        debit: "throughput"
      },
      advantagesSection: {
        title: "WiFi",
        titleRed: "Intelligent",
        subtitle: "Manage and optimize your wireless infrastructure with next-generation controllers",
        card1: {
          title: "Centralized and Scalable Management",
          desc: "Administer from 250 to 6000 access points from a single console with advanced management capabilities, hot patching, and seamless upgrades."
        },
        card2: {
          title: "Advanced Performance and Security",
          desc: "Benefit from performance up to 100 Gbps with line-rate hardware encryption and SD-Access integration.",
          list: [
            'Hardware encryption to eliminate performance degradation',
            'Advanced on-demand telemetry for optimal monitoring',
            'Flexible deployments: campus, cloud or data center'
          ]
        }
      },
      categories: [
        { id: 'new-generation', name: 'Next Generation', description: 'Latest generation CW9800 controllers' },
        { id: 'campus', name: 'Campus', description: 'Solutions for medium and large campus deployments' },
        { id: 'cloud', name: 'Cloud', description: 'Deployment in private or public cloud' },
        { id: 'legacy', name: 'Previous Generation', description: '9800 Controllers (End-of-Sale announced)' }
      ],
      controllerProducts: [
        {
          id: 1,
          name: "Cisco Catalyst CW9800M",
          image: "/images/CiscoWIFIController/cisco-cw9800m.avif",
          category: "new-generation",
          description: "For medium-sized campus deployments requiring fast wireless connections",
          keyUse: "Medium campuses, Flexible deployments, Data centers",
          options: "Up to 3000 APs, 32000 clients, 50 Gbps, 1RU Design, 10 Gbps HA Port",
          specifications: { accessPoints: "3000", clients: "32000", throughput: "50 Gbps", uplinks: "1/10/25 Gbps", design: "1RU", features: "10 Gbps HA Port, Hardware Encryption" }
        },
        {
          id: 2,
          name: "Cisco Catalyst CW9800H1",
          image: "/images/CiscoWIFIController/cisco-cw9800h1.avif",
          category: "new-generation",
          description: "For large campus deployments requiring fast wireless connections",
          keyUse: "Large campuses, High performance, Critical deployments",
          options: "Up to 6000 APs, 64000 clients, 100 Gbps, +36% performance vs 9800-80",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "100 Gbps", uplinks: "1/10/25 Gbps", design: "1RU", features: "10 Gbps HA Port, -40% power vs 9800-80" }
        },
        {
          id: 3,
          name: "Cisco Catalyst CW9800H2",
          image: "/images/CiscoWIFIController/cisco-cw9800h2.avif",
          category: "new-generation",
          description: "For large campus deployments requiring fast wireless connections with 40G connectivity",
          keyUse: "Large campuses, 40G connectivity, High density",
          options: "Up to 6000 APs, 64000 clients, 100 Gbps, Uplinks 1/10/40 Gbps",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "100 Gbps", uplinks: "1/10/40 Gbps", design: "1RU", features: "10 Gbps HA Port, Line-rate encryption" }
        },
        {
          id: 4,
          name: "Cisco Catalyst 9800-L",
          image: "/images/CiscoWIFIController/cisco-9800l.avif",
          category: "campus",
          description: "For small campus deployments, with flexibility of copper or fiber uplinks",
          keyUse: "Small campuses, Flexible links, SMB",
          options: "Up to 250 APs, 5000 clients, 5 Gbps, Hot patching, ISSU",
          specifications: { accessPoints: "250", clients: "5000", throughput: "5 Gbps", uplinks: "Copper/Fiber", design: "Compact", features: "Hot patching, ISSU, Advanced telemetry" }
        },
        {
          id: 5,
          name: "Cisco Catalyst 9800-CL",
          image: "/images/CiscoWIFIController/cisco-9800cl.avif",
          category: "cloud",
          description: "For deployment in private or public cloud",
          keyUse: "Private/public cloud, Virtualization, Cloud scalability",
          options: "Up to 6000 APs, 64000 clients, Multiple scaling options",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "Variable", uplinks: "Virtualized", design: "Cloud", features: "Hot patching, ISSU, SD-Access, Telemetry" }
        },
        {
          id: 6,
          name: "Cisco Catalyst 9800-40",
          image: "/images/CiscoWIFIController/cisco-9800-40.avif",
          category: "legacy",
          description: "For medium-sized campus deployments (End-of-Sale announced)",
          keyUse: "Medium campuses, Existing solutions, Planned migration",
          options: "Up to 2000 APs, 32000 clients, 40 Gbps, Hot patching, ISSU",
          specifications: { accessPoints: "2000", clients: "32000", throughput: "40 Gbps", uplinks: "Standard", design: "Legacy", features: "Hot patching, ISSU, SD-Access, EOS announced" }
        },
        {
          id: 7,
          name: "Cisco Catalyst 9800-80",
          image: "/images/CiscoWIFIController/cisco-9800-80.webp",
          category: "legacy",
          description: "For large campuses and service provider deployments (End-of-Sale announced)",
          keyUse: "Large campuses, Service providers, Legacy solutions",
          options: "Up to 6000 APs, 64000 clients, 80 Gbps, Modular chassis",
          specifications: { accessPoints: "6000", clients: "64000", throughput: "80 Gbps", uplinks: "Modular", design: "Chassis", features: "Hot patching, ISSU, Telemetry, EOS announced" }
        }
      ]
    },
    analyse: { 
      seo: { title: "IT Infrastructure Audit & Diagnosis Tunisia | S2i Consulting", description: "Full assessment of your Data Center, security, and network. S2i performs your IT audit to optimize performance in Tunisia." },
      hero: {
        title: "IT Analysis & Consulting",
        subtitle: "A reliable and efficient evaluation of your IT infrastructure",
        cta: "Book an Appointment"
      },
      intro: {
        title: "S2i supports you in the complete audit of your infrastructure",
        p1: "S2i supports you and offers a complete audit of your company's IT infrastructure; an assessment that makes your vision clearer and places you in a pragmatic approach.",
        p2: "Your information system is the engine of your company; our team of IT experts carries out a complete and detailed analysis, thus determining the positive points and risk factors of your IT infrastructure.",
        p3: "While converging towards your professional objective, the delivered specifications allow you to better evaluate the performance of your infrastructure and determine the levers for improvement, in accordance with the latest technological trends."
      },
      mainServices: [
        { title: "Existing Diagnostic", description: "Complete and detailed analysis of your current IT infrastructure" },
        { title: "Consulting & Strategy", description: "Expert recommendations to optimize your information system" }
      ],
      approach: {
        title: "Discover our approach",
        subtitle: "A proven methodology for a complete audit of your infrastructure",
        steps: [
          { title: "Appointment", description: "Scheduling the audit with our certified IT experts" },
          { title: "Detailed Analysis", description: "Full evaluation of your IT infrastructure" },
          { title: "Risk Identification", description: "Determination of positive points and risk factors" },
          { title: "Specifications", description: "Delivery of a detailed report with recommendations" }
        ]
      },
      evaluations: {
        title: "Our Evaluation Areas",
        items: [
          {
            title: "Data Center Evaluation",
            description: "Faced with a permanent need to improve the performance of your IT infrastructure, which undergoes several extensions at a fairly high rate, and your Data Centers which experience a proliferation of duplicated data, thus increasing the complexity of their management, the evaluation of your Data Centers represents an essential asset to help you gain a competitive advantage and reduce your operating costs.",
            features: ["Physical infrastructure evaluation", "Server performance analysis", "Data management optimization", "Future extension planning", "Backup plan control"]
          },
          {
            title: "Security System Evaluation",
            description: "S2i's infrastructure analysis and diagnostic services, oriented towards your company's security devices, is an essential and necessary mechanism to allow you to identify potential flaws in your security infrastructure and provide you with a set of priority actions to correct them, in order to guarantee and strengthen the security of your entire IT architecture.",
            features: ["Security flaw identification", "Protection device audit", "Priority corrective actions", "IT architecture reinforcement", "Global security guarantee"]
          },
          {
            title: "Network Evaluation",
            description: "Protecting the production system and guaranteeing high network availability is a permanent challenge for IT managers. In this area, our experts' mission is to evaluate the performance of network devices and examine the characteristics of the network infrastructure connecting your company's applications with each other and with your consolidated data centers.",
            features: ["Network performance evaluation", "Network infrastructure examination", "High availability analysis", "Connection optimization", "Optimal backup services"]
          }
        ]
      },
      deliverables: {
        title: "Our Infrastructure Audit Deliverables",
        subtitle: "A complete report and concrete recommendations to optimize your infrastructure",
        items: [
          { title: "Existing infrastructure analysis", description: "An analysis of the existing IT infrastructure and capacity" },
          { title: "Network risk diagnostic", description: "A complete diagnostic of risks at the network infrastructure level" },
          { title: "System security diagnostic", description: "A diagnostic related to system security" },
          { title: "SPOF identification", description: "Identification of potential Single Points of Failure (SPOF)" },
          { title: "Storage diagnostic", description: "A diagnostic on system storage capacity" },
          { title: "Architecture documentation", description: "Detailed documentation of the architecture" },
          { title: "Urgent action plan", description: "A plan for urgent actions" },
          { title: "Optimization strategy", description: "An infrastructure optimization strategy" }
        ]
      },
      conseil: {
        title: "S2i Consulting Services",
        subtitle: "Our experts support you in defining your IT strategy and optimizing your infrastructures",
        strat: {
          title: "Strategic IT Consulting",
          description: "Definition of your technological roadmap aligned with your business objectives. Our consultants help you make the right decisions for your digital transformation.",
          list: ["IT strategy development", "Business/IT alignment", "Technological roadmap", "Project ROI analysis", "Data governance"]
        },
        tech: {
          title: "Technical Consulting & Architecture",
          description: "Design of robust and scalable architectures. Our IT architects guide you in technological choices to optimize performance and security.",
          list: ["System & network architecture", "Choice of technologies", "Performance optimization", "Security & compliance", "Migration & modernization"]
        },
        process: {
          title: "Our Consulting Process",
          steps: [
            { title: "Needs Analysis", description: "Deep understanding of your business and technical challenges" },
            { title: "Study & Recommendations", description: "Development of personalized and costed recommendations" },
            { title: "Action Plan", description: "Definition of implementation steps with detailed schedule" },
            { title: "Support", description: "Continuous support during the deployment phase" }
          ]
        },
        advantages: {
          title: "Why choose S2i for your IT consulting?",
          btn: "Consult our experts",
          items: [
            { title: "37+ years of expertise", description: "Recognized experience in all IT fields" },
            { title: "Certified Team", description: "Certified expert consultants on the latest technologies" },
            { title: "Personalized Approach", description: "Tailor-made solutions adapted to your specific needs" },
            { title: "Continuous Innovation", description: "Technological watch and integration of the latest innovations" }
          ]
        }
      }
    },
    deploiementSupport: {
      seo: { title: "Technical Support & Managed Services Tunisia | IT Maintenance", description: "24/7 technical support and assistance for your infrastructure. Certified experts for deployment and maintenance of your systems in Tunisia." },
      banner: {
        title: "Deployment & <span>Support</span>",
        subtitle: "Complete IT deployment solutions and professional technical support",
        cta: "Start a project"
      },
      deploiement: {
        badge: "Deployment",
        title: "IT <span>Deployment</span> Solutions",
        description: "We manage your entire IT deployment projects, from planning to production, with Dell Technologies expertise",
        services: [
          { title: "Server Infrastructure", desc: "Deployment and configuration of Dell Technologies physical and virtual servers", features: ["Dell PowerEdge server installation", "RAID and storage configuration", "VMware/Hyper-V virtualization", "Clustering and high availability"] },
          { title: "Network & Connectivity", desc: "Setting up robust and secure network infrastructures", features: ["Dell Networking switches deployment", "VLAN and routing configuration", "Professional WiFi access points", "Network security and firewalling"] },
          { title: "Storage & Backup", desc: "Storage solutions and comprehensive backup strategies", features: ["Dell EMC storage arrays", "Automated backup solutions", "Replication and disaster recovery", "Archiving and compliance"] },
          { title: "IT Security", desc: "Deployment of advanced cybersecurity solutions", features: ["Next-generation firewalls", "Antivirus and anti-malware solutions", "24/7 security monitoring", "Multi-factor authentication"] }
        ],
        processTitle: "Our Deployment Process",
        processSub: "A proven methodology to guarantee the success of your projects",
        steps: [
          { step: "01", title: "Analysis & Planning", desc: "Detailed study of your needs and deployment planning", timeline: "1-2 weeks" },
          { step: "02", title: "Preparation & Tests", desc: "Environment preparation and laboratory testing", timeline: "1-3 weeks" },
          { step: "03", title: "Deployment", desc: "On-site installation and configuration of your infrastructure", timeline: "2-5 days" },
          { step: "04", title: "Tests & Validation", desc: "Complete testing and validation of all components", timeline: "1-2 days" },
          { step: "05", title: "Training & Transfer", desc: "Team training and skill transfer", timeline: "1-3 days" },
          { step: "06", title: "Continuous Support", desc: "Post-deployment technical support and guidance", timeline: "Permanent" }
        ]
      },
      support: {
        badge: "Support",
        title: "Expert <span>Technical Support</span>",
        description: "Continuous support to ensure the performance and security of your IT infrastructure",
        services: [
          { title: "24/7 Technical Support", desc: "Continuous technical assistance to ensure your operations continuity", features: ["Dedicated 24/7 hotline", "Prioritized support tickets", "On-site intervention if needed", "Fast incident resolution"], stats: { response: "< 30min", availability: "99.9%", satisfaction: "98%" } },
          { title: "Monitoring & Surveillance", desc: "Proactive infrastructure monitoring to prevent outages", features: ["24/7 infrastructure monitoring", "Real-time automatic alerts", "Customized dashboards", "Monthly performance reports"], stats: { uptime: "99.99%", alerts: "< 5min", coverage: "100%" } },
          { title: "Preventive Maintenance", desc: "Regular maintenance to optimize performance and extend lifespan", features: ["Planned preventive maintenance", "Automatic security updates", "Performance optimization", "System health checks"], stats: { frequency: "Monthly", reduction: "85%", efficiency: "+30%" } },
          { title: "Training & Guidance", desc: "Training your teams for optimal use of your systems", features: ["Personalized training sessions", "Detailed technical documentation", "Skill transfer", "Post-training support"], stats: { satisfaction: "95%", completion: "98%", retention: "92%" } }
        ],
        whyTitle: "Why choose our Support?",
        whySub: "The advantages that make the difference with S2i",
        advantages: [
          { title: "Certified Expertise", desc: "Team of Dell Technologies certified experts with over 15 years of experience" },
          { title: "Guaranteed Responsiveness", desc: "Fast interventions and efficient resolution of your IT issues" },
          { title: "Personalized Guidance", desc: "A dedicated contact person who knows your environment and challenges" },
          { title: "Enhanced Security", desc: "Proactive monitoring and advanced security measures to protect your data" }
        ]
      },
      cta: {
        title: "Ready to transform your IT infrastructure?",
        desc: "Our S2i experts support you in the deployment and support of your IT solutions with Dell Technologies excellence.",
        btn: "Consult our experts"
      }
    },
    accessSwitching: {
      seo: { title: "Cisco Catalyst Switch Tunisia | Campus LAN Network | S2i", description: "Discover Cisco Catalyst 9000 and Meraki range. Intelligent and secure switching solutions for enterprise networks in Tunisia." },
      hero: {
        badge: "Cisco Network Solutions",
        title: "Cisco <span style='color: #d90000'>Campus Access</span> Switches",
        subtitle: "Discover our full range of Cisco Catalyst and Meraki switches for high-performance and secure campus networks",
        btnExplore: "Explore switches",
        btnQuote: "Request a quote"
      },
      categories: {
        title: "Switch Categories",
        subtitle: "Find the right switching solution for your network needs"
      },
      sidebar: {
        title: "Filters & Search",
        search: "Search",
        searchPlaceholder: "Name, feature, use case...",
        category: "Category",
        all: "All switches",
        found: "switch(es) found",
        page: "Page",
        of: "of",
        view: "View",
        grid: "Grid",
        list: "List",
        noResults: "No switches found",
        noResultsSub: "Try modifying your search criteria"
      },
      card: {
        new: "New",
        usage: "Use Cases",
        specs: "Specifications",
        ports: "Ports",
        uplinks: "Uplinks",
        poe: "PoE",
        highlights: "Highlights"
      },
      other: {
        title: "Other <span style='color: #d90000'>Network</span> Solutions",
        subtitle: "Complete your network infrastructure with our integrated Cisco solutions",
        wifi: {
          title: "WiFi Solutions",
          desc: "High-performance WiFi 6/6E infrastructure with Cisco Catalyst and Meraki for optimal wireless connectivity in all your environments.",
          f: ["WiFi 6E with 6 GHz bands up to 9.6 Gbps", "Meraki centralized cloud management", "WPA3 security and automatic segmentation", "Artificial Intelligence for optimization"]
        },
        security: {
          title: "Network Security",
          desc: "Complete network security solutions with Cisco ASA firewalls, Firepower and advanced threat detection technologies.",
          f: ["Next-Gen Firewall with deep inspection", "Real-time threat detection and response", "Secure site-to-site and remote access VPN", "Centralized security policy management"]
        },
        wan: {
          title: "WAN Solutions",
          desc: "Optimization and security of WAN connections with Cisco SD-WAN and advanced routing technologies for maximum performance.",
          f: ["Intelligent SD-WAN with automatic optimization", "Multi-path routing and load balancing", "End-to-end data encryption", "Application-by-application visibility and control"]
        }
      },
      cta: {
        title: "Let's design your network infrastructure of tomorrow",
        subtitle: "Our network experts support you in the design and implementation of your infrastructure with the most advanced Cisco technologies.",
        btnExpert: "Consult our experts",
        btnCatalog: "Download our catalog"
      }
    },
    about: {
      banner: { title: "About <span style='color: #d90000'>S2i</span>", subtitle: "Over 37 years of expertise at the service of your digital transformation" },
      timeline: {
        title: "Our History", sub: "A journey of innovation and technological excellence",
        events: [
          { year: "1989", title: "S2i Creation", desc: "Founding of the company in Tunis with a vision of technological innovation" },
          { year: "1995", title: "First Dell Partnership", desc: "Beginning of our strategic collaboration with Dell Technologies" },
          { year: "2005", title: "Services Expansion", desc: "Diversification into cybersecurity and network solutions" },
          { year: "2015", title: "Digital Transformation", desc: "Accompanying companies in their digital journey" },
          { year: "2020", title: "Technology Leadership", desc: "Recognition as an IT solutions leader in Tunisia" },
          { year: "2024", title: "Continuous Innovation", desc: "Over 37 years of expertise at our customers' service" }
        ]
      },
      expertise: {
        title: "S2i expertise at the service of <span style='color: #dc2626'>innovation</span>",
        sub: "S2i implements its technical expertise to meet IT infrastructure challenges by relying on several complementary axes",
        cards: [
          { title: "Deep mastery of IT professions", desc: "S2i has developed its skills in key areas such as solution integration, network engineering, LAN and WAN network analysis, cybersecurity, data management, storage, and IP telephony. This technical diversity enables them to design optimized, reliable IT infrastructures adapted to clients' specific needs." },
          { title: "Offering viable and sustainable solutions, integrating cutting-edge technologies", desc: "S2i anticipates technological developments and offers innovative and high-performance IT environments, including aspects related to artificial intelligence, cybersecurity, and hybrid infrastructure management (on-premise, cloud). This continuous innovation capability allows them to ensure the competitiveness and resilience of deployed infrastructures." },
          { title: "End-to-end project lifecycle support", desc: "From design to production deployment, up to support and maintenance, S2i ensures responsive monitoring and high-quality technical assistance. This guarantees system availability and performance, as well as continuous adaptation to technological and business context evolutions." },
          { title: "Strategy based on anticipation and certified training", desc: "By combining technical development, team training, and skills diversification, S2i prepares its clients to integrate and master new technologies, thereby reducing risks related to the complexity and security of IT infrastructures." }
        ]
      },
      solutionsTitle: "Our Solutions & Services",
      values: {
        title: "Our Three Pillars", sub: "Fundamental values that guide our action",
        items: [
          { title: "Continuous Innovation", desc: "We integrate the latest technologies to anticipate the future needs of our clients." },
          { title: "Customer Commitment", desc: "We are committed to providing reactive assistance and sustainable support." },
          { title: "Technical Excellence", desc: "Our certified teams combine expertise and customer listening for measurable results." }
        ]
      },
      faq: {
        title: "Frequently Asked Questions", sub: "Discover how S2i puts its expertise at the service of your success",
        data: [
          { q: "How does S2i implement its technical expertise to address IT infrastructure challenges?", a: "S2i implements its technical expertise to address IT infrastructure challenges by relying on several complementary axes:\n\n**• In-depth mastery of IT professions:** S2i has developed its skills in key areas such as solution integration, network engineering, LAN and WAN network analysis, cybersecurity, data management, storage, and IP telephony. This technical diversity enables them to design optimized, reliable IT infrastructures adapted to clients' specific needs.\n\n**Provision of viable and sustainable solutions integrating cutting-edge technologies:** S2i anticipates technological developments and offers innovative and high-performance IT environments, including aspects related to artificial intelligence, cybersecurity, and hybrid infrastructure management (on-premise, cloud). This continuous innovation capability allows them to ensure the competitiveness and resilience of deployed infrastructures.\n\n**End-to-end project lifecycle support:** From design to production deployment, up to support and maintenance, S2i ensures responsive monitoring and high-quality technical assistance. This guarantees system availability and performance, as well as continuous adaptation to technological and business context evolutions.\n\n**Strategy based on anticipation and certified training:** By combining technical development, team training, and skills diversification, S2i prepares its clients to integrate and master new technologies, thereby reducing risks related to the complexity and security of IT infrastructures.\n\n**In summary,** S2i deploys its technical expertise through a global and proactive approach covering engineering, integration, security, technological innovation, and personalized support, enabling it to effectively address the complex and evolving challenges of modern IT infrastructures." },
          { q: "How does S2i use its expertise to secure and integrate innovative solutions in IT networks?", a: "S2i uses its expertise to secure and integrate innovative solutions in IT networks through several key axes:\n\n**• Secure infrastructure integration:** S2i designs and deploys reliable and secure network architectures, including the configuration of network equipment (routers, switches, firewalls) with up-to-date protocols and segmentation policies (VLAN, access rights management) adapted to clients' specific needs. This ensures optimal connectivity while limiting intrusion risks and unauthorized access.\n\n**• Proactive monitoring and risk management:** S2i implements continuous network monitoring solutions, detecting in real time abnormal behaviors, intrusion attempts, or potential vulnerabilities. This approach allows threats to be anticipated and neutralized before impacting systems.\n\n**• Deployment of advanced cybersecurity technologies:** The company integrates advanced solutions such as intrusion detection and prevention systems (IDS/IPS), SIEM solutions for security event analysis, as well as endpoint management systems to protect terminals against malware and unauthorized access.\n\n**• Continuous innovation approach:** S2i anticipates technological evolutions by integrating innovative solutions such as artificial intelligence applied to cybersecurity and by developing customized systems allowing networks to adapt to modern challenges (e.g., generative AI, digital signage).\n\n**• Personalized support and training:** In addition to technical integration, S2i supports its clients throughout the project lifecycle with a tailored approach including rigorous management, dedicated workshops, and certified training for client teams to ensure continuous mastery of integrated solutions.\n\n**In summary,** S2i combines comprehensive expertise in network engineering, cybersecurity, technological innovation, and client support to secure and integrate high-performance solutions adapted to each company's IT ecosystem, thereby effectively addressing current infrastructure challenges." },
          { q: "What strategies does S2i employ to ensure the security of digital infrastructures?", a: "S2i employs several key strategies to ensure the security of digital infrastructures, based on deep technical expertise, a rigorous approach, and integration of advanced technologies:\n\n**• Design and deployment of secure network architectures:** S2i builds robust IT infrastructures by configuring network equipment (routers, switches, firewalls) with up-to-date protocols and segmentation policies such as VLANs, ensuring network isolation and fine-grained access control to reduce intrusion risks.\n\n**• Proactive monitoring and risk management:** The company integrates continuous monitoring tools such as intrusion detection and prevention systems (IDS/IPS) and SIEM (Security Information and Event Management) platforms that analyze security events in real time to detect and anticipate threats.\n\n**• Adoption of advanced cybersecurity technologies:** S2i deploys solutions including endpoint management, strong authentication, encryption, and integrates innovations such as artificial intelligence applied to cybersecurity, allowing systems to adapt to modern and complex threats.\n\n**• Risk analysis and control approach:** The company performs precise mapping of risks related to digital infrastructures, identifies specific threats, and adapts its security policy accordingly. This includes implementing a security assurance plan with rigorous testing procedures (penetration tests, recovery tests, audits).\n\n**• Personalized support and training:** Beyond technical aspects, S2i supports its clients throughout the project lifecycle by providing structured management, dedicated workshops, and certified training for client teams to ensure continuous mastery of secure solutions.\n\n**• Compliance with standards and best practices:** In its approach, S2i relies on recognized security standards such as ISO/IEC 27001 and best practices in information system security, ensuring a reliable and compliant framework for protecting data and access.\n\n**In summary,** S2i secures digital infrastructures through a comprehensive strategy combining secure network engineering, advanced technologies, proactive risk analysis, and enhanced support, ensuring confidentiality, integrity, availability, and authenticity of information systems." },
          { q: "How does S2i use advanced technological solutions to protect its clients?", a: "S2i uses advanced technological solutions to protect its clients by combining several key approaches:\n\n**• Integration of advanced cybersecurity technologies:** S2i deploys systems such as intrusion detection and prevention systems (IDS/IPS), SIEM (Security Information and Event Management) solutions for real-time security event analysis, as well as endpoint management systems to protect terminals against malware and unauthorized access.\n\n**• Proactive monitoring and threat management:** The company implements continuous infrastructure monitoring, detecting abnormal behaviors or intrusion attempts, enabling anticipation and neutralization of threats before they impact systems.\n\n**• Integration of innovations such as artificial intelligence:** S2i integrates AI applied to cybersecurity, including generative AI, to strengthen fraud detection, identify complex threat patterns, and improve incident response with greater accuracy.\n\n**• Personalized approach and continuous training:** Beyond tools, S2i supports its clients with certified training and specific workshops to ensure full mastery of deployed solutions and continuous adaptation to technological and regulatory changes.\n\n**• Compliance with standards and collaboration with specialized organizations:** S2i complies with standards such as ISO/IEC 27001 and collaborates with recognized actors to ensure audits, penetration testing, and robust cybersecurity governance.\n\nThis global strategy, combining technical engineering, technological innovation, and strategic support, enables S2i to effectively protect its clients' IT infrastructures against current and future cyber threats while ensuring system continuity and resilience." },
          { q: "What is the impact of S2i's 37+ years of experience on the quality of its services and reputation?", a: "The more than 37 years of experience of S2i have a significant impact on the quality of its services and its reputation. This long experience has enabled it to develop considerable know-how in information technologies, relying on strong technical skills and continuous innovation capability. Thanks to this proven and in-depth expertise, S2i offers its clients optimized, reliable, and sustainable technical solutions while ensuring responsive and high-quality support and maintenance. This operational mastery has allowed S2i to position itself among IT market leaders, with a diversified and international clientele, thereby strengthening its global reputation and credibility.\n\nIn parallel, this experience is accompanied by a strategic approach based on anticipation, innovation, and customization, enabling S2i to offer services adapted to complex needs across various industries. The ability to support projects end-to-end, from design to operation, is another key element directly resulting from this strong field experience, ensuring the long-term success of client IT projects.\n\nIn summary, more than three decades of activity give S2i a strong reputation based on quality, reliability, and innovation, which are key factors for an IT player aiming to remain competitive in both national and international markets." },
          { q: "What role does S2i's seniority play in the perception of its ability to deliver high-quality services?", a: "S2i's seniority, with more than 37 years of existence, plays a central role in the perception of its ability to deliver high-quality services. Indeed, this long experience has enabled it to develop strong technical know-how, confirmed operational expertise, and a continuous innovation capacity to anticipate and respond to technological changes. This accumulated experience reassures clients regarding the reliability, sustainability, and performance of the proposed solutions.\n\nMoreover, service continuity and technical support quality result directly from this seniority, strengthening client trust in S2i as a stable and responsive partner. Seniority also allows S2i to build a strong reputation based on recognized references among thousands of clients, both nationally and internationally, across various sectors (administration, finance, telecom, industry).\n\nThus, seniority provides an image of maturity, professionalism, and proven competence, which positively influences the perception of S2i's ability to deliver services meeting high-quality standards." },
          { q: "How does S2i's experience contribute to innovation in its services?", a: "S2i's more than 37 years of experience directly contributes to innovation in its services in several essential ways.\n\nFirstly, this long experience has enabled S2i to develop strong technical know-how and acquire deep expertise in various IT fields such as solution integration, network engineering, cybersecurity, data management, storage, IP telephony, and more. This technical mastery is a key lever for integrating and deploying innovative technologies that meet evolving client needs.\n\nSecondly, S2i's seniority has provided it with a unique strategic positioning allowing it to anticipate market and technological evolutions. This results in a continuous ability to offer cutting-edge solutions, particularly in fast-growing areas such as artificial intelligence, cybersecurity, and digital signage. This anticipation is supported by an innovation policy based on certified training, continuous development, and complementary skills diversification, ensuring that services and solutions remain competitive internationally.\n\nThirdly, accumulated experience facilitates a collaborative and client-centered innovation approach. S2i works closely with its clients to understand their specific challenges and provide tailored solutions, fostering practical and useful innovation. This strategic approach supported by end-to-end project support enables co-creation of innovative solutions throughout the project lifecycle.\n\nFinally, S2i also relies on research and development (R&D) centers, particularly for future digital services in areas such as Smart City, leveraging advances in artificial intelligence, IoT, and embedded technologies. This ability to launch ambitious R&D projects is made possible by decades of expertise and experience, contributing to continuous innovation within the company." },
          { q: "How does the relationship with its partners enhance innovation at S2i?", a: "S2i's expertise fosters the creation of innovative solutions through several key mechanisms.\n\nFirst, its strong technical expertise, acquired over more than 37 years, enables deep mastery of IT technologies, which is an essential foundation for integrating suitable and high-performance technological innovations. This expertise covers a wide range: solution integration, network engineering, cybersecurity, data management, IP telephony, artificial intelligence, among others. This advanced technical base is essential for developing innovative solutions that meet specific client and market needs.\n\nSecondly, S2i relies on a strategic approach of anticipating technological developments and market trends. Its long experience allows it to remain at the forefront by integrating the latest technologies such as generative AI, digital signage, and intelligent systems, creating a continuous innovation environment. This ongoing technological watch is supported by a policy of certified training, skills diversification, and continuous development, ensuring adaptability and competitiveness of the solutions provided.\n\nFurthermore, S2i's expertise fosters practical and user-centered innovation through personalized and collaborative support. By working closely with its clients, the company deeply understands their challenges and adapts its solutions, stimulating applied creativity and co-construction of innovative technological offerings that are truly useful in their usage context.\n\nFinally, S2i invests in research and development (R&D) through dedicated centers and ambitious projects related to future challenges such as Smart City, Internet of Things (IoT), and advanced artificial intelligence. This ability to generate and structure R&D projects is a direct result of its long-standing expertise, reinforcing its role in emerging breakthrough innovations.\n\nIn summary, S2i's expertise fosters the creation of innovative solutions through its strong technological mastery, strategic anticipation of developments, collaborative approach, and investment in advanced research, enabling it to deliver innovations that are relevant, high-performing, and sustainable." }
        ]
      }
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('siteLang') || 'fr');
  const switchLanguage = (l) => { setLang(l); localStorage.setItem('siteLang', l); };
  return (
    <LanguageContext.Provider value={{ lang, switchLanguage, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);